import { reactive as aa, onBeforeMount as na, onBeforeUnmount as Us, defineComponent as A, computed as f, createElementBlock as v, openBlock as g, normalizeClass as x, unref as y, renderSlot as C, ref as Z, onMounted as Ze, createCommentVNode as O, createElementVNode as b, watch as Me, useAttrs as me, mergeProps as pe, useSlots as it, toRefs as ue, toDisplayString as G, createBlock as te, resolveDynamicComponent as ge, withCtx as X, resolveComponent as Te, normalizeProps as Re, Fragment as ie, renderList as Ue, withModifiers as Wt, shallowRef as Se, readonly as la, toValue as de, getCurrentScope as Ys, onScopeDispose as Js, isRef as Xs, nextTick as zt, getCurrentInstance as or, hasInjectionContext as Zs, inject as fe, watchEffect as ia, createTextVNode as ce, Comment as da, createVNode as Ge, Transition as Qs, normalizeStyle as yt, withKeys as eo, provide as ke, withDirectives as De, vShow as ua, toRef as qt, guardReactiveProps as to, h as Ot, TransitionGroup as ca, pushScopeId as fa, popScopeId as pa, withScopeId as ga, mergeModels as ro, useModel as so, vModelCheckbox as oo, vModelDynamic as ha, vModelRadio as ma, vModelText as ao, vModelSelect as ba } from "vue";
const va = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let no = (e = 21) => {
  let t = "", r = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += va[r[e] & 63];
  return t;
};
const Mt = aa({}), ar = (e, t) => (na(() => {
  e && (Mt[e] = {
    id: e,
    collapsed: t?.collapsed ?? !1,
    flushed: t?.flushed ?? !1,
    persistent: t?.persistent ?? !1,
    panels: []
  });
}), Us(() => {
  e && delete Mt[e];
}), {
  accordionStates: Mt,
  getAccordionState: ({ element: o }) => {
    const a = o.value && o.value.closest("[data-accordion-id]")?.dataset.accordionId;
    return a ? Mt[a] : null;
  },
  getAccordionPanelState: ({ accordionState: o, panelId: a }) => o?.value.panels.find((n) => n.id === a) ?? null
}), Mr = "-", ya = (e) => {
  const t = ka(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: s
  } = e;
  return {
    getClassGroupId: (n) => {
      const l = n.split(Mr);
      return l[0] === "" && l.length !== 1 && l.shift(), lo(l, t) || wa(n);
    },
    getConflictingClassGroupIds: (n, l) => {
      const i = r[n] || [];
      return l && s[n] ? [...i, ...s[n]] : i;
    }
  };
}, lo = (e, t) => {
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], s = t.nextPart.get(r), o = s ? lo(e.slice(1), s) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(Mr);
  return t.validators.find(({
    validator: n
  }) => n(a))?.classGroupId;
}, Jr = /^\[(.+)\]$/, wa = (e) => {
  if (Jr.test(e)) {
    const t = Jr.exec(e)[1], r = t?.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, ka = (e) => {
  const {
    theme: t,
    classGroups: r
  } = e, s = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const o in r)
    _r(r[o], s, o, t);
  return s;
}, _r = (e, t, r, s) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : Xr(t, o);
      a.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (xa(o)) {
        _r(o(s), t, r, s);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([a, n]) => {
      _r(n, Xr(t, a), r, s);
    });
  });
}, Xr = (e, t) => {
  let r = e;
  return t.split(Mr).forEach((s) => {
    r.nextPart.has(s) || r.nextPart.set(s, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(s);
  }), r;
}, xa = (e) => e.isThemeGetter, Ca = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
  const o = (a, n) => {
    r.set(a, n), t++, t > e && (t = 0, s = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let n = r.get(a);
      if (n !== void 0)
        return n;
      if ((n = s.get(a)) !== void 0)
        return o(a, n), n;
    },
    set(a, n) {
      r.has(a) ? r.set(a, n) : o(a, n);
    }
  };
}, Sr = "!", Tr = ":", $a = Tr.length, _a = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: r
  } = e;
  let s = (o) => {
    const a = [];
    let n = 0, l = 0, i = 0, d;
    for (let p = 0; p < o.length; p++) {
      let _ = o[p];
      if (n === 0 && l === 0) {
        if (_ === Tr) {
          a.push(o.slice(i, p)), i = p + $a;
          continue;
        }
        if (_ === "/") {
          d = p;
          continue;
        }
      }
      _ === "[" ? n++ : _ === "]" ? n-- : _ === "(" ? l++ : _ === ")" && l--;
    }
    const u = a.length === 0 ? o : o.substring(i), h = Sa(u), m = h !== u, c = d && d > i ? d - i : void 0;
    return {
      modifiers: a,
      hasImportantModifier: m,
      baseClassName: h,
      maybePostfixModifierPosition: c
    };
  };
  if (t) {
    const o = t + Tr, a = s;
    s = (n) => n.startsWith(o) ? a(n.substring(o.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: n,
      maybePostfixModifierPosition: void 0
    };
  }
  if (r) {
    const o = s;
    s = (a) => r({
      className: a,
      parseClassName: o
    });
  }
  return s;
}, Sa = (e) => e.endsWith(Sr) ? e.substring(0, e.length - 1) : e.startsWith(Sr) ? e.substring(1) : e, Ta = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((s) => [s, !0]));
  return (s) => {
    if (s.length <= 1)
      return s;
    const o = [];
    let a = [];
    return s.forEach((n) => {
      n[0] === "[" || t[n] ? (o.push(...a.sort(), n), a = []) : a.push(n);
    }), o.push(...a.sort()), o;
  };
}, Pa = (e) => ({
  cache: Ca(e.cacheSize),
  parseClassName: _a(e),
  sortModifiers: Ta(e),
  ...ya(e)
}), Aa = /\s+/, Fa = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: s,
    getConflictingClassGroupIds: o,
    sortModifiers: a
  } = t, n = [], l = e.trim().split(Aa);
  let i = "";
  for (let d = l.length - 1; d >= 0; d -= 1) {
    const u = l[d], {
      isExternal: h,
      modifiers: m,
      hasImportantModifier: c,
      baseClassName: p,
      maybePostfixModifierPosition: _
    } = r(u);
    if (h) {
      i = u + (i.length > 0 ? " " + i : i);
      continue;
    }
    let k = !!_, T = s(k ? p.substring(0, _) : p);
    if (!T) {
      if (!k) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      if (T = s(p), !T) {
        i = u + (i.length > 0 ? " " + i : i);
        continue;
      }
      k = !1;
    }
    const B = a(m).join(":"), M = c ? B + Sr : B, H = M + T;
    if (n.includes(H))
      continue;
    n.push(H);
    const S = o(T, k);
    for (let D = 0; D < S.length; ++D) {
      const R = S[D];
      n.push(M + R);
    }
    i = u + (i.length > 0 ? " " + i : i);
  }
  return i;
};
function za() {
  let e = 0, t, r, s = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = io(t)) && (s && (s += " "), s += r);
  return s;
}
const io = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let s = 0; s < e.length; s++)
    e[s] && (t = io(e[s])) && (r && (r += " "), r += t);
  return r;
};
function Ia(e, ...t) {
  let r, s, o, a = n;
  function n(i) {
    const d = t.reduce((u, h) => h(u), e());
    return r = Pa(d), s = r.cache.get, o = r.cache.set, a = l, l(i);
  }
  function l(i) {
    const d = s(i);
    if (d)
      return d;
    const u = Fa(i, r);
    return o(i, u), u;
  }
  return function() {
    return a(za.apply(null, arguments));
  };
}
const le = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, uo = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, co = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Ba = /^\d+\/\d+$/, Ea = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Oa = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Ma = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Na = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, La = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, rt = (e) => Ba.test(e), W = (e) => !!e && !Number.isNaN(Number(e)), Ae = (e) => !!e && Number.isInteger(Number(e)), hr = (e) => e.endsWith("%") && W(e.slice(0, -1)), _e = (e) => Ea.test(e), Ra = () => !0, Da = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Oa.test(e) && !Ma.test(e)
), fo = () => !1, ja = (e) => Na.test(e), Va = (e) => La.test(e), Ha = (e) => !z(e) && !I(e), Wa = (e) => dt(e, ho, fo), z = (e) => uo.test(e), je = (e) => dt(e, mo, Da), mr = (e) => dt(e, Ya, W), Zr = (e) => dt(e, po, fo), Ga = (e) => dt(e, go, Va), Nt = (e) => dt(e, bo, ja), I = (e) => co.test(e), gt = (e) => ut(e, mo), qa = (e) => ut(e, Ja), Qr = (e) => ut(e, po), Ka = (e) => ut(e, ho), Ua = (e) => ut(e, go), Lt = (e) => ut(e, bo, !0), dt = (e, t, r) => {
  const s = uo.exec(e);
  return s ? s[1] ? t(s[1]) : r(s[2]) : !1;
}, ut = (e, t, r = !1) => {
  const s = co.exec(e);
  return s ? s[1] ? t(s[1]) : r : !1;
}, po = (e) => e === "position" || e === "percentage", go = (e) => e === "image" || e === "url", ho = (e) => e === "length" || e === "size" || e === "bg-size", mo = (e) => e === "length", Ya = (e) => e === "number", Ja = (e) => e === "family-name", bo = (e) => e === "shadow", Xa = () => {
  const e = le("color"), t = le("font"), r = le("text"), s = le("font-weight"), o = le("tracking"), a = le("leading"), n = le("breakpoint"), l = le("container"), i = le("spacing"), d = le("radius"), u = le("shadow"), h = le("inset-shadow"), m = le("text-shadow"), c = le("drop-shadow"), p = le("blur"), _ = le("perspective"), k = le("aspect"), T = le("ease"), B = le("animate"), M = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], H = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], S = () => [...H(), I, z], D = () => ["auto", "hidden", "clip", "visible", "scroll"], R = () => ["auto", "contain", "none"], F = () => [I, z, i], U = () => [rt, "full", "auto", ...F()], Y = () => [Ae, "none", "subgrid", I, z], ee = () => ["auto", {
    span: ["full", Ae, I, z]
  }, Ae, I, z], V = () => [Ae, "auto", I, z], w = () => ["auto", "min", "max", "fr", I, z], $ = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], E = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], N = () => ["auto", ...F()], L = () => [rt, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...F()], P = () => [e, I, z], j = () => [...H(), Qr, Zr, {
    position: [I, z]
  }], Q = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], oe = () => ["auto", "cover", "contain", Ka, Wa, {
    size: [I, z]
  }], be = () => [hr, gt, je], ae = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    d,
    I,
    z
  ], re = () => ["", W, gt, je], we = () => ["solid", "dashed", "dotted", "double"], pt = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], se = () => [W, hr, Qr, Zr], tt = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    p,
    I,
    z
  ], It = () => ["none", W, I, z], Bt = () => ["none", W, I, z], gr = () => [W, I, z], Et = () => [rt, "full", ...F()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [_e],
      breakpoint: [_e],
      color: [Ra],
      container: [_e],
      "drop-shadow": [_e],
      ease: ["in", "out", "in-out"],
      font: [Ha],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [_e],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [_e],
      shadow: [_e],
      spacing: ["px", W],
      text: [_e],
      "text-shadow": [_e],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", rt, z, I, k]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [W, z, I, l]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": M()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": M()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: S()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: R()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": R()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": R()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: U()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": U()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": U()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: U()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: U()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: U()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: U()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: U()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: U()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Ae, "auto", I, z]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [rt, "full", "auto", l, ...F()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [W, rt, "auto", "initial", "none", z]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", W, I, z]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", W, I, z]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Ae, "first", "last", "none", I, z]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": Y()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ee()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": V()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": V()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": Y()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ee()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": V()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": V()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": w()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": w()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: F()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": F()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": F()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...$(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...E(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...E()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...$()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...E(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...E(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": $()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...E(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...E()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: F()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: F()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: F()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: F()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: F()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: F()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: F()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: F()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: F()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: N()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: N()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: N()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: N()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: N()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: N()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: N()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: N()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: N()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": F()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": F()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: L()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [l, "screen", ...L()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          l,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...L()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          l,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [n]
          },
          ...L()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", ...L()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "none", ...L()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", ...L()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r, gt, je]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [s, I, mr]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", hr, z]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [qa, z, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, I, z]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [W, "none", I, mr]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...F()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", I, z]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", I, z]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: P()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: P()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...we(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [W, "from-font", "auto", I, je]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: P()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [W, "auto", I, z]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: F()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", I, z]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", I, z]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: j()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: Q()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: oe()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Ae, I, z],
          radial: ["", I, z],
          conic: [Ae, I, z]
        }, Ua, Ga]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: P()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: be()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: be()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: be()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: P()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: P()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: P()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: ae()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": ae()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": ae()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": ae()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": ae()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": ae()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": ae()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": ae()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": ae()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": ae()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": ae()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": ae()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": ae()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": ae()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": ae()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: re()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": re()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": re()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": re()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": re()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": re()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": re()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": re()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": re()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": re()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": re()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...we(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...we(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: P()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": P()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": P()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": P()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": P()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": P()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": P()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": P()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": P()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: P()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...we(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [W, I, z]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", W, gt, je]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: P()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          u,
          Lt,
          Nt
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: P()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", h, Lt, Nt]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": P()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: re()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: P()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [W, je]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": P()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": re()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": P()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", m, Lt, Nt]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": P()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [W, I, z]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...pt(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": pt()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [W]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": se()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": se()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": P()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": P()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": se()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": se()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": P()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": P()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": se()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": se()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": P()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": P()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": se()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": se()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": P()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": P()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": se()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": se()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": P()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": P()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": se()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": se()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": P()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": P()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": se()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": se()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": P()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": P()
      }],
      "mask-image-radial": [{
        "mask-radial": [I, z]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": se()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": se()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": P()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": P()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": H()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [W]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": se()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": se()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": P()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": P()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: j()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: Q()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: oe()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", I, z]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          I,
          z
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: tt()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [W, I, z]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [W, I, z]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          c,
          Lt,
          Nt
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": P()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", W, I, z]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [W, I, z]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", W, I, z]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [W, I, z]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", W, I, z]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          I,
          z
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": tt()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [W, I, z]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [W, I, z]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", W, I, z]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [W, I, z]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", W, I, z]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [W, I, z]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [W, I, z]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", W, I, z]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": F()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": F()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": F()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", I, z]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [W, "initial", I, z]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", T, I, z]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [W, I, z]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", B, I, z]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [_, I, z]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": S()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: It()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": It()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": It()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": It()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Bt()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Bt()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Bt()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Bt()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: gr()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": gr()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": gr()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [I, z, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: S()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: Et()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": Et()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": Et()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": Et()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: P()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: P()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", I, z]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": F()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": F()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": F()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": F()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": F()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": F()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": F()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": F()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": F()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": F()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": F()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": F()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": F()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": F()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": F()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": F()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": F()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": F()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", I, z]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...P()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [W, gt, je, mr]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...P()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, J = /* @__PURE__ */ Ia(Xa);
function vo(e) {
  return typeof e == "string" ? e.trim() : Array.isArray(e) ? e.map(vo).join(" ").trim() : typeof e == "object" && e !== null ? Object.entries(e).filter(([t, r]) => r).map(([t]) => t).join(" ") : "";
}
const q = (e) => J(vo(e)), Za = ["data-accordion-id"], Qa = "w-full", j0 = /* @__PURE__ */ A({
  __name: "FwbAccordion",
  props: {
    class: { default: "" },
    collapsed: { type: Boolean, default: !1 },
    flushed: { type: Boolean, default: !1 },
    persistent: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = no(), r = e, s = f(() => r.class ?? ""), o = f(() => q([
      Qa,
      s.value
    ]));
    return ar(t, { ...r }), (a, n) => (g(), v("div", {
      "data-accordion-id": y(t),
      class: x(o.value)
    }, [
      C(a.$slots, "default")
    ], 10, Za));
  }
}), en = (e, t, r) => {
  const s = "p-5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900", o = f(() => r.class), a = f(() => r.activeClass), n = f(() => e.value?.flushed), l = f(() => t.value?.isVisible), i = f(() => e.value?.panels?.length ?? 0), d = f(() => t.value?.order === i.value - 1);
  return f(
    () => q(
      [
        s,
        n.value && "border-x-0 border-t-0",
        !l.value && "hidden",
        !d.value && !n.value && "border-b-0",
        d.value && "border-t-0",
        o.value,
        l.value ? a.value : ""
      ].filter((h) => h).join(" ")
    )
  ).value;
}, V0 = /* @__PURE__ */ A({
  __name: "FwbAccordionContent",
  props: {
    activeClass: { default: "" },
    class: { default: "" }
  },
  setup(e) {
    const t = e, { getAccordionState: r } = ar(), s = Z(!1), o = Z(), a = Z(), n = f(() => (o.value && o.value.closest("[data-panel-id]"))?.dataset.panelId), l = f(() => a.value?.panels.find((d) => d.id === n.value)), i = f(() => a.value && l.value ? en(a, l, t) : null);
    return Ze(() => {
      a.value = r({ element: o }), s.value = !0;
    }), (d, u) => (g(), v("div", {
      ref_key: "contentRef",
      ref: o
    }, [
      s.value ? (g(), v("div", {
        key: 0,
        class: x(i.value)
      }, [
        C(d.$slots, "default")
      ], 2)) : O("", !0)
    ], 512));
  }
}), yo = "flex w-full items-center justify-between gap-3 font-medium p-5 text-gray-500 dark:text-gray-400 rtl:text-right", tn = `${yo} border border-gray-200 hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 dark:border-gray-700 dark:hover:bg-gray-800 dark:focus:ring-gray-800`, rn = `${yo} border-b border-gray-200 dark:border-gray-700`, sn = "ml-auto size-6 shrink-0", on = (e, t, r) => {
  const s = f(
    () => q([
      sn,
      t.value?.isVisible ? "rotate-180" : ""
    ])
  ), o = f(() => r.class), a = f(() => r.activeClass), n = f(() => e.value?.panels?.length ?? 0), l = f(() => t.value?.order === 0), i = f(() => t.value?.order === n.value - 1), d = f(() => t.value?.isVisible), u = f(() => e.value?.flushed), h = f(
    () => q(
      [
        u.value ? rn : tn,
        d.value ? "text-gray-900 dark:text-white" : "text-gray-500 dark:text-gray-400",
        d.value && !u.value && "bg-gray-100 dark:bg-gray-800",
        l.value && !u.value && "rounded-t-xl",
        l.value && u.value && "border-t-0",
        !i.value && "border-b-0",
        u.value && "border-x-0 border-b",
        o.value,
        d.value ? a.value : ""
      ].filter((m) => m).join(" ")
    )
  );
  return {
    arrowClasses: s.value,
    headerClasses: h.value
  };
}, H0 = /* @__PURE__ */ A({
  __name: "FwbAccordionHeader",
  props: {
    activeClass: { default: "" },
    class: { default: "" }
  },
  setup(e) {
    const t = e, { getAccordionState: r } = ar(), s = Z(!1), o = Z(), a = Z(), n = f(() => (o.value && o.value.closest("[data-panel-id]"))?.dataset.panelId), l = f(() => a.value?.panels.find((m) => m.id === n.value)), i = f(() => a.value && l.value ? on(a, l, t) : null), d = f(() => i.value?.arrowClasses), u = f(() => i.value?.headerClasses);
    Ze(() => {
      a.value = r({ element: o }), s.value = !0;
    });
    const h = () => {
      if (a.value.persistent) {
        l.value.isVisible = !l.value?.isVisible;
        return;
      }
      const m = l.value.isVisible;
      a.value.panels.forEach((c) => {
        c.id !== n.value ? c.isVisible = !1 : c.isVisible = !m;
      });
    };
    return (m, c) => (g(), v("div", {
      ref_key: "headerRef",
      ref: o
    }, [
      s.value ? (g(), v("button", {
        key: 0,
        class: x(u.value),
        type: "button",
        onClick: h
      }, [
        C(m.$slots, "default"),
        (g(), v("svg", {
          class: x(d.value),
          fill: "currentColor",
          viewBox: "0 0 20 20",
          xmlns: "http://www.w3.org/2000/svg"
        }, c[0] || (c[0] = [
          b("path", { d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" }, null, -1)
        ]), 2))
      ], 2)) : O("", !0)
    ], 512));
  }
}), an = ({ props: e, isVisible: t }) => {
  const r = e.activeClass ?? "";
  return q([`${t ? r : ""}`]);
}, nn = ["data-panel-id"], W0 = /* @__PURE__ */ A({
  __name: "FwbAccordionPanel",
  props: {
    activeClass: { default: "" }
  },
  emits: ["show", "hide"],
  setup(e, { emit: t }) {
    const r = e, {
      getAccordionState: s,
      getAccordionPanelState: o
    } = ar(), a = Z(), n = no(), l = Z(), i = Z(), d = f(
      () => i.value ? o({ accordionState: i, panelId: n }) : null
    ), u = f(
      () => an({
        isVisible: d.value?.isVisible ?? !1,
        props: r
      })
    ), h = f(() => d.value?.isVisible), m = t;
    return Me(h, () => {
      h.value ? m("show") : m("hide");
    }), Ze(() => {
      i.value = s({ element: a }), l.value = i.value.id;
      const c = a.value && a.value.parentElement ? Array.from(a.value.parentElement.children).indexOf(a.value) : -1;
      i.value.panels.push({
        id: n,
        isVisible: (!i.value.collapsed && c === 0) ?? !1,
        order: c
      });
    }), (c, p) => (g(), v("div", {
      ref_key: "panelRef",
      ref: a,
      "data-panel-id": y(n),
      class: x(u.value)
    }, [
      l.value ? C(c.$slots, "default", { key: 0 }) : O("", !0)
    ], 10, nn));
  }
}), ln = { class: "flex items-center" }, dn = "ml-auto -mr-1.5 -my-1.5 rounded-lg focus:ring-2 p-1.5 inline-flex h-8 w-8 dark:bg-gray-800 dark:hover:bg-gray-700", G0 = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbAlert",
  props: {
    type: { default: "info" },
    closable: { type: Boolean, default: !1 },
    icon: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const r = e, s = t, o = me(), a = {
      danger: "text-red-800 dark:text-red-400",
      dark: "text-gray-800 dark:text-gray-300",
      info: "text-blue-800 dark:text-blue-400",
      success: "text-green-800 dark:text-green-400",
      warning: "text-yellow-800 dark:text-yellow-300"
    }, n = {
      danger: "bg-red-50",
      dark: "bg-gray-50",
      info: "bg-blue-50",
      success: "bg-green-50",
      warning: "bg-yellow-50"
    }, l = {
      danger: "text-red-500 dark:text-red-400 bg-red-50 hover:bg-red-200 focus:ring-red-400",
      dark: "text-gray-500 dark:text-gray-300 bg-gray-50 hover:bg-gray-200 focus:ring-gray-400 dark:hover:text-white",
      info: "text-blue-500 dark:text-blue-400 bg-blue-50 hover:bg-blue-200 focus:ring-blue-400",
      success: "text-green-500 dark:text-green-400 bg-green-50 hover:bg-green-200 focus:ring-green-400",
      warning: "text-yellow-500 dark:text-yellow-300 bg-yellow-50 hover:bg-yellow-200 focus:ring-yellow-400"
    }, i = f(() => J(dn, l[r.type])), d = {
      danger: "border-red-500 dark:text-red-400",
      dark: "border-gray-500 dark:text-gray-400",
      info: "border-blue-500 dark:text-blue-400",
      success: "border-green-500 dark:text-green-400",
      warning: "border-yellow-500 dark:text-yellow-400"
    }, u = {
      danger: [a.danger, n.danger].join(" "),
      dark: [a.dark, n.dark].join(" "),
      info: [a.info, n.info].join(" "),
      success: [a.success, n.success].join(" "),
      warning: [a.warning, n.warning].join(" ")
    }, h = f(() => J(
      "p-4 gap-3 text-sm dark:bg-gray-800 rounded-lg",
      u[r.type],
      (r.icon || r.closable) && "flex items-center",
      d[r.type],
      r.border && "border",
      o.class
    )), m = Z(!0);
    function c() {
      s("close"), m.value = !1;
    }
    return (p, _) => m.value ? (g(), v("div", pe({ key: 0 }, p.$attrs, {
      class: h.value,
      role: "alert"
    }), [
      b("div", ln, [
        p.icon || p.$slots.icon ? C(p.$slots, "icon", { key: 0 }, () => [
          _[0] || (_[0] = b("svg", {
            class: "size-5 shrink-0",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            b("path", {
              "fill-rule": "evenodd",
              d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
              "clip-rule": "evenodd"
            })
          ], -1))
        ]) : O("", !0),
        C(p.$slots, "title")
      ]),
      C(p.$slots, "default", { onCloseClick: c }),
      C(p.$slots, "close-icon", { onCloseClick: c }, () => [
        p.closable ? (g(), v("button", {
          key: 0,
          type: "button",
          class: x(i.value),
          "aria-label": "Close",
          onClick: c
        }, _[1] || (_[1] = [
          b("span", { class: "sr-only" }, "Dismiss", -1),
          b("svg", {
            class: "size-5",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            b("path", {
              "fill-rule": "evenodd",
              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
              "clip-rule": "evenodd"
            })
          ], -1)
        ]), 2)) : O("", !0)
      ])
    ], 16)) : O("", !0);
  }
}), es = {
  xs: "w-6 h-6",
  sm: "w-8 h-8",
  md: "w-10 h-10",
  lg: "w-20 h-20",
  xl: "w-36 h-36"
}, ts = {
  default: "rounded",
  rounded: "rounded-full"
}, un = "ring-2 ring-gray-300 dark:ring-gray-500 p-1", cn = "absolute h-3.5 w-3.5 rounded-full border-2 border-white dark:border-gray-800", fn = {
  away: "bg-gray-400",
  busy: "bg-yellow-400",
  offline: "bg-red-400",
  online: "bg-green-400"
}, pn = {
  "top-right-rounded": "top-0 -right-0.5",
  "top-right-default": "-top-1.5 -right-1.5",
  "top-left-rounded": "top-0 left-0",
  "top-left-default": "top-0 left-0 transform -translate-y-1/2 -translate-x-1/2",
  "bottom-right-rounded": "bottom-0 -right-0.5",
  "bottom-right-default": "bottom-0 -right-1.5 translate-y-1/2",
  "bottom-left-rounded": "bottom-0 left-0",
  "bottom-left-default": "-bottom-1.5 left-0 transform -translate-x-1/2 "
}, rs = "w-auto h-auto text-gray-400", gn = "absolute", hn = "flex overflow-hidden relative justify-center items-center", mn = "bg-gray-100 dark:bg-gray-600", bn = "font-medium text-gray-600 dark:text-gray-300", vn = {
  xs: "bottom-0",
  sm: "bottom-0",
  md: "-bottom-1",
  lg: "-bottom-2",
  xl: "-bottom-4"
};
function yn(e) {
  const t = f(
    () => q([
      es[e.size.value],
      ts[e.rounded.value ? "rounded" : "default"],
      e.bordered.value ? un : "",
      e.stacked.value ? "border-2 border-white dark:border-gray-800" : ""
    ])
  ), r = f(() => {
    const l = `${e.statusPosition.value}-${e.rounded.value ? "rounded" : "default"}`;
    return q([
      cn,
      fn[e.status.value],
      pn[l]
    ]);
  }), s = f(
    () => q([
      rs
    ])
  ), o = f(
    () => q([
      rs,
      gn,
      vn[e.size.value]
    ])
  ), a = f(
    () => q([
      hn,
      es[e.size.value],
      ts[e.rounded.value ? "rounded" : "default"],
      e.img.value && e.bordered.value ? "" : mn,
      e.bordered.value ? " overflow-visible" : ""
    ])
  ), n = f(
    () => q([
      bn
    ])
  );
  return {
    avatarClasses: t,
    avatarDotClasses: r,
    avatarPlaceholderClasses: s,
    avatarPlaceholderIconClasses: o,
    avatarPlaceholderInitialsClasses: n,
    avatarPlaceholderWrapperClasses: a
  };
}
const wn = { class: "relative" }, kn = ["alt", "src"], xn = ["data-pos"], q0 = /* @__PURE__ */ A({
  __name: "FwbAvatar",
  props: {
    alt: {
      type: String,
      default: "Avatar"
    },
    bordered: {
      type: Boolean,
      default: !1
    },
    img: {
      type: String,
      default: ""
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "md"
    },
    stacked: {
      type: Boolean,
      default: !1
    },
    status: {
      type: String,
      default: null
    },
    statusPosition: {
      type: String,
      default: "top-right"
    },
    initials: {
      type: String,
      default: null
    }
  },
  setup(e) {
    const t = Z(!1);
    function r() {
      t.value = !0;
    }
    const s = it(), o = f(() => s.placeholder), a = e, {
      avatarClasses: n,
      avatarDotClasses: l,
      avatarPlaceholderClasses: i,
      avatarPlaceholderIconClasses: d,
      avatarPlaceholderInitialsClasses: u,
      avatarPlaceholderWrapperClasses: h
    } = yn(ue(a));
    return (m, c) => (g(), v("div", wn, [
      b("div", {
        class: x(y(h))
      }, [
        e.img && !t.value ? (g(), v("img", {
          key: 0,
          alt: e.alt,
          class: x(y(n)),
          src: e.img,
          onError: r
        }, null, 42, kn)) : !e.initials && o.value ? (g(), v("div", {
          key: 1,
          class: x(y(i))
        }, [
          C(m.$slots, "placeholder")
        ], 2)) : !e.img && !e.initials ? (g(), v("svg", {
          key: 2,
          class: x(y(d)),
          fill: "currentColor",
          viewBox: "0 0 20 20",
          xmlns: "http://www.w3.org/2000/svg"
        }, c[0] || (c[0] = [
          b("path", {
            "clip-rule": "evenodd",
            d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
            "fill-rule": "evenodd"
          }, null, -1)
        ]), 2)) : (g(), v("div", {
          key: 3,
          class: x(y(u))
        }, G(e.initials), 3))
      ], 2),
      e.status ? (g(), v("span", {
        key: 0,
        class: x(y(l)),
        "data-pos": e.statusPosition
      }, null, 10, xn)) : O("", !0)
    ]));
  }
}), Pe = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [s, o] of t)
    r[s] = o;
  return r;
}, Cn = {}, $n = { class: "flex -space-x-4" };
function _n(e, t) {
  return g(), v("div", $n, [
    C(e.$slots, "default")
  ]);
}
const K0 = /* @__PURE__ */ Pe(Cn, [["render", _n]]), Sn = ["href"], U0 = /* @__PURE__ */ A({
  __name: "FwbAvatarStackCounter",
  props: {
    total: {
      type: Number,
      default: 1
    },
    href: {
      type: String,
      default: "#"
    }
  },
  setup(e) {
    return (t, r) => (g(), v("a", {
      class: "relative flex size-10 items-center justify-center rounded-full border-2 border-white bg-gray-700 text-xs font-medium text-white hover:bg-gray-600 dark:border-gray-800",
      href: e.href
    }, "+" + G(e.total), 9, Sn));
  }
}), Tn = "mr-2 px-2.5 py-0.5 rounded flex items-center justify-center", Pn = "bg-blue-100 hover:bg-blue-200 text-blue-800 dark:text-blue-800 dark:hover:bg-blue-300", An = "p-1 rounded-full mr-2", Fn = {
  default: "text-blue-800 dark:text-blue-300",
  dark: "text-gray-800 dark:text-gray-300",
  red: "text-red-800 dark:text-red-300",
  green: "text-green-800 dark:text-green-300",
  yellow: "text-yellow-800 dark:text-yellow-300",
  indigo: "text-indigo-800 dark:text-indigo-300",
  purple: "text-purple-800 dark:text-purple-300",
  pink: "text-pink-800 dark:text-pink-300"
}, zn = {
  default: "bg-blue-100 dark:bg-blue-900",
  dark: "bg-gray-100 dark:bg-gray-700",
  red: "bg-red-100 dark:bg-red-900",
  green: "bg-green-100 dark:bg-green-900",
  yellow: "bg-yellow-100 dark:bg-yellow-900",
  indigo: "bg-indigo-100 dark:bg-indigo-900",
  purple: "bg-purple-100 dark:bg-purple-900",
  pink: "bg-pink-100 dark:bg-pink-900"
}, In = {
  xs: "text-xs font-semibold",
  sm: "text-sm font-medium"
};
function Bn(e, t) {
  const r = me();
  return {
    badgeClasses: f(() => J(
      In[e.size],
      e.href ? "" : zn[e.type],
      e.href ? "" : Fn[e.type],
      e.href ? Pn : "",
      t.isContentEmpty.value ? An : Tn,
      r.class
    ))
  };
}
const Y0 = /* @__PURE__ */ A({
  __name: "FwbBadge",
  props: {
    type: { default: "default" },
    size: { default: "xs" },
    href: { default: null }
  },
  setup(e) {
    const t = e, r = it(), s = f(() => !r.default), o = f(() => t.href ? "a" : "span"), { badgeClasses: a } = Bn(t, { isContentEmpty: s });
    return (n, l) => (g(), te(ge(o.value), {
      class: x(y(a)),
      href: n.href
    }, {
      default: X(() => [
        C(n.$slots, "icon"),
        C(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "href"]));
  }
});
function En(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var br = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ss;
function On() {
  return ss || (ss = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var a = "", n = 0; n < arguments.length; n++) {
          var l = arguments[n];
          l && (a = o(a, s(l)));
        }
        return a;
      }
      function s(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return r.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var n = "";
        for (var l in a)
          t.call(a, l) && a[l] && (n = o(n, l));
        return n;
      }
      function o(a, n) {
        return n ? a ? a + " " + n : a + n : a;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  }(br)), br.exports;
}
var Mn = On();
const ne = /* @__PURE__ */ En(Mn), Nn = "inline-flex items-center space-x-1 md:space-x-3", Ln = {
  default: "flex",
  solid: "flex px-5 py-3 text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700"
};
function Rn(e) {
  const t = f(() => ne(Nn)), r = f(() => ne(
    Ln[e.solid.value ? "solid" : "defauilt"]
  ));
  return {
    breadcrumbClasses: t,
    breadcrumbWrapperClasses: r
  };
}
const J0 = /* @__PURE__ */ A({
  __name: "FwbBreadcrumb",
  props: {
    solid: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { breadcrumbClasses: r, breadcrumbWrapperClasses: s } = Rn(ue(t));
    return (o, a) => (g(), v("nav", {
      class: x(y(s)),
      "aria-label": "Breadcrumb"
    }, [
      b("ol", {
        class: x(y(r))
      }, [
        C(o.$slots, "default")
      ], 2)
    ], 2));
  }
}), Dn = "ml-1 inline-flex items-center text-sm font-medium dark:text-gray-400", jn = "text-gray-700 hover:text-gray-900 dark:hover:text-white", Vn = "text-gray-500";
function Hn(e) {
  return {
    breadcrumbItemClasses: f(() => ne(
      Dn,
      e.href.value ? jn : Vn
    ))
  };
}
const Wn = { class: "inline-flex items-center" }, Gn = {
  key: 0,
  class: "mr-1 size-6 text-gray-400",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, qn = {
  key: 0,
  class: "mr-2 size-4",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, X0 = /* @__PURE__ */ A({
  __name: "FwbBreadcrumbItem",
  props: {
    href: {
      type: String,
      default: null
    },
    home: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, r = f(() => t.href ? "a" : "span"), { breadcrumbItemClasses: s } = Hn(ue(t));
    return (o, a) => (g(), v("li", Wn, [
      C(o.$slots, "arrow-icon", {}, () => [
        e.home ? O("", !0) : (g(), v("svg", Gn, a[0] || (a[0] = [
          b("path", {
            "clip-rule": "evenodd",
            d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
            "fill-rule": "evenodd"
          }, null, -1)
        ])))
      ]),
      (g(), te(ge(r.value), {
        class: x(y(s)),
        href: e.href
      }, {
        default: X(() => [
          C(o.$slots, "home-icon", {}, () => [
            e.home ? (g(), v("svg", qn, a[1] || (a[1] = [
              b("path", { d: "M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" }, null, -1)
            ]))) : O("", !0)
          ]),
          C(o.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "href"]))
    ]));
  }
}), os = {
  default: {
    default: "text-white bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg dark:bg-blue-600 focus:outline-none dark:focus:ring-blue-800",
    blue: "text-white bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg dark:bg-blue-600 focus:outline-none dark:focus:ring-blue-800",
    alternative: "font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600",
    dark: "text-white bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg dark:bg-gray-800 dark:focus:ring-gray-700 dark:border-gray-700",
    light: "text-gray-900 bg-white border border-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-200 font-medium rounded-lg dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:focus:ring-gray-700",
    green: "focus:outline-none text-white bg-green-700 focus:ring-4 focus:ring-green-300 font-medium rounded-lg dark:bg-green-600 dark:focus:ring-green-800",
    red: "focus:outline-none text-white bg-red-700 focus:ring-4 focus:ring-red-300 font-medium rounded-lg dark:bg-red-600 dark:focus:ring-red-900",
    yellow: "focus:outline-none text-white bg-yellow-400 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg dark:focus:ring-yellow-900",
    purple: "focus:outline-none text-white bg-purple-700 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg dark:bg-purple-600 dark:focus:ring-purple-900",
    pink: "focus:outline-none text-white bg-pink-700 focus:ring-4 focus:ring-pink-300 font-medium rounded-lg dark:bg-pink-600 dark:focus:ring-pink-900"
  },
  hover: {
    default: "hover:bg-blue-800 dark:hover:bg-blue-700",
    blue: "hover:bg-blue-800 dark:hover:bg-blue-700",
    alternative: "hover:bg-gray-100 hover:text-blue-700 dark:hover:text-white dark:hover:bg-gray-700",
    dark: "hover:bg-gray-900 dark:hover:bg-gray-700",
    light: "hover:bg-gray-100 dark:hover:border-gray-600",
    green: "hover:bg-green-800 dark:hover:bg-green-700",
    red: "hover:bg-red-800 dark:hover:bg-red-700",
    yellow: "hover:bg-yellow-500",
    purple: "hover:bg-purple-800 dark:hover:bg-purple-700",
    pink: "hover:bg-pink-800 dark:hover:bg-pink-700"
  }
}, as = {
  default: {
    dark: "text-gray-900 border border-gray-800 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm text-center dark:border-gray-600 dark:text-gray-400 dark:focus:ring-gray-800",
    default: "text-blue-700 border border-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm text-center dark:border-blue-500 dark:text-blue-500 dark:focus:ring-blue-800",
    blue: "text-blue-700 border border-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm text-center dark:border-blue-500 dark:text-blue-500 dark:focus:ring-blue-800",
    green: "text-green-700 border border-green-700 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm text-center dark:border-green-500 dark:text-green-500 dark:focus:ring-green-800",
    purple: "text-purple-700 border border-purple-700 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm text-center dark:border-purple-400 dark:text-purple-400 dark:focus:ring-purple-900",
    pink: "text-pink-700 border border-pink-700 focus:ring-4 focus:outline-none focus:ring-pink-300 font-medium rounded-lg text-sm text-center dark:border-pink-400 dark:text-pink-400 dark:focus:ring-pink-900",
    red: "text-red-700 border border-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm text-center dark:border-red-500 dark:text-red-500 dark:focus:ring-red-900",
    yellow: "text-yellow-400 border border-yellow-400 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm text-center dark:border-yellow-300 dark:text-yellow-300 dark:focus:ring-yellow-900"
  },
  hover: {
    dark: "hover:text-white hover:bg-gray-900 dark:hover:text-white dark:hover:bg-gray-600",
    default: "hover:text-white hover:bg-blue-800 dark:hover:text-white dark:hover:bg-blue-600",
    blue: "hover:text-white hover:bg-blue-800 dark:hover:text-white dark:hover:bg-blue-600",
    green: "hover:text-white hover:bg-green-800 dark:hover:text-white dark:hover:bg-green-600",
    purple: "hover:text-white hover:bg-purple-800 dark:hover:text-white dark:hover:bg-purple-500",
    pink: "hover:text-white hover:bg-pink-800 dark:hover:text-white dark:hover:bg-pink-500",
    red: "hover:text-white hover:bg-red-800 dark:hover:text-white dark:hover:bg-red-600",
    yellow: "hover:text-white hover:bg-yellow-500 dark:hover:text-white dark:hover:bg-yellow-400"
  }
}, ns = {
  hover: {
    "cyan-blue": "hover:bg-gradient-to-bl",
    "green-blue": "hover:bg-gradient-to-bl",
    "pink-orange": "hover:bg-gradient-to-bl",
    "purple-blue": "hover:bg-gradient-to-bl",
    "purple-pink": "hover:bg-gradient-to-l",
    "red-yellow": "hover:bg-gradient-to-bl",
    "teal-lime": "hover:bg-gradient-to-l hover:from-teal-200 hover:to-lime-200",
    blue: "hover:bg-gradient-to-br",
    cyan: "hover:bg-gradient-to-br",
    green: "hover:bg-gradient-to-br",
    lime: "hover:bg-gradient-to-br",
    pink: "hover:bg-gradient-to-br",
    purple: "hover:bg-gradient-to-br",
    red: "hover:bg-gradient-to-br",
    teal: "hover:bg-gradient-to-br"
  },
  default: {
    "cyan-blue": "text-white bg-gradient-to-r from-cyan-500 to-blue-500 focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg",
    "green-blue": "text-white bg-gradient-to-br from-green-400 to-blue-600 focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 font-medium rounded-lg",
    "pink-orange": "text-white bg-gradient-to-br from-pink-500 to-orange-400 focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800 font-medium rounded-lg",
    "purple-blue": "text-white bg-gradient-to-br from-purple-600 to-blue-500 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg",
    "purple-pink": "text-white bg-gradient-to-r from-purple-500 to-pink-500 focus:ring-4 focus:outline-none focus:ring-purple-200 dark:focus:ring-purple-800 font-medium rounded-lg",
    "red-yellow": "text-gray-900 bg-gradient-to-r from-red-200 via-red-300 to-yellow-200 focus:ring-4 focus:outline-none focus:ring-red-100 dark:focus:ring-red-400 font-medium rounded-lg",
    "teal-lime": "text-gray-900 bg-gradient-to-r from-teal-200 to-lime-200 focus:ring-4 focus:outline-none focus:ring-lime-200 dark:focus:ring-teal-700 font-medium rounded-lg",
    blue: "text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 rounded-lg",
    cyan: "text-white bg-gradient-to-r from-cyan-500 via-cyan-600 to-cyan-700 focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 rounded-lg",
    green: "text-white bg-gradient-to-r from-green-500 via-green-600 to-green-700 focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 rounded-lg",
    lime: "text-gray-900 bg-gradient-to-r from-lime-500 via-lime-600 to-lime-700 focus:ring-4 focus:outline-none focus:ring-lime-300 dark:focus:ring-lime-800 rounded-lg",
    pink: "text-white bg-gradient-to-r from-pink-500 via-pink-600 to-pink-700 focus:ring-4 focus:outline-none focus:ring-pink-300 dark:focus:ring-pink-800 rounded-lg",
    purple: "text-white bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 focus:ring-4 focus:outline-none focus:ring-purple-300 dark:focus:ring-purple-800 rounded-lg",
    red: "text-white bg-gradient-to-r from-red-500 via-red-600 to-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 rounded-lg",
    teal: "text-white bg-gradient-to-r from-teal-500 via-teal-600 to-teal-700 focus:ring-4 focus:outline-none focus:ring-teal-300 dark:focus:ring-teal-800 rounded-lg"
  }
}, ls = {
  default: {
    "cyan-blue": "relative inline-flex items-center justify-center overflow-hidden font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800",
    "green-blue": "relative inline-flex items-center justify-center overflow-hidden font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800",
    "pink-orange": "relative inline-flex items-center justify-center overflow-hidden font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-pink-500 to-orange-400 dark:text-white focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800",
    "purple-blue": "relative inline-flex items-center justify-center overflow-hidden font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800",
    "purple-pink": "relative inline-flex items-center justify-center overflow-hidden font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-500 to-pink-500 dark:text-white focus:ring-4 focus:outline-none focus:ring-purple-200 dark:focus:ring-purple-800",
    "red-yellow": "relative inline-flex items-center justify-center overflow-hidden font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-red-200 via-red-300 to-yellow-200 dark:text-white focus:ring-4 focus:outline-none focus:ring-red-100 dark:focus:ring-red-400",
    "teal-lime": "relative inline-flex items-center justify-center overflow-hidden font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-teal-300 to-lime-300 dark:text-white focus:ring-4 focus:outline-none focus:ring-lime-200 dark:focus:ring-lime-800"
  },
  hover: {
    "cyan-blue": "group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white",
    "green-blue": "group-hover:from-green-400 group-hover:to-blue-600 hover:text-white",
    "pink-orange": "group-hover:from-pink-500 group-hover:to-orange-400 hover:text-white",
    "purple-blue": "group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white",
    "purple-pink": "group-hover:from-purple-500 group-hover:to-pink-500 hover:text-white",
    "red-yellow": "group-hover:from-red-200 group-hover:via-red-300 group-hover:to-yellow-200 dark:hover:text-gray-900",
    "teal-lime": "group-hover:from-teal-300 group-hover:to-lime-300 dark:hover:text-gray-900"
  }
}, Kn = {
  xs: "text-xs px-2 py-1",
  sm: "text-sm px-3 py-1.5",
  md: "text-sm px-4 py-2",
  lg: "text-base px-5 py-2.5",
  xl: "text-base px-6 py-3"
}, Un = {
  xs: "text-xs p-1",
  sm: "text-sm p-1.5",
  md: "text-sm p-2",
  lg: "text-base p-2.5",
  xl: "text-base p-3"
}, is = {
  blue: "shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80",
  cyan: "shadow-lg shadow-cyan-500/50 dark:shadow-lg dark:shadow-cyan-800/80",
  green: "shadow-lg shadow-green-500/50 dark:shadow-lg dark:shadow-green-800/80",
  lime: "shadow-lg shadow-lime-500/50 dark:shadow-lg dark:shadow-lime-800/80",
  pink: "shadow-lg shadow-pink-500/50 dark:shadow-lg dark:shadow-pink-800/80",
  purple: "shadow-lg shadow-purple-500/50 dark:shadow-lg dark:shadow-purple-800/80",
  red: "shadow-lg shadow-red-500/50 dark:shadow-lg dark:shadow-red-800/80",
  teal: "shadow-lg shadow-teal-500/50 dark:shadow-lg dark:shadow-teal-800/80"
}, vr = ["blue", "green", "cyan", "teal", "lime", "red", "pink", "purple"], Yn = ["alternative", "light"];
function Jn(e) {
  const t = it(), r = f(() => e.square.value ? Un[e.size.value] : Kn[e.size.value]), s = f(() => {
    const a = !!e.gradient.value, n = !!e.color.value, l = e.outline.value;
    let i = "", d = "";
    if (a && l)
      e.gradient.value && !vr.includes(e.gradient.value) ? (d = ls.default[e.gradient.value], e.disabled.value || (i = ls.hover[e.gradient.value])) : console.warn(`cannot use outline prop with "${e.gradient.value}" gradient`);
    else if (e.gradient.value && a)
      d = ns.default[e.gradient.value], e.disabled.value || (i = ns.hover[e.gradient.value]);
    else if (n && l)
      if (Yn.includes(e.color.value))
        console.warn(`cannot use outline prop with "${e.color.value}" color`);
      else {
        const h = e.color.value;
        d = as.default[h], e.disabled.value || (i = as.hover[h]);
      }
    else {
      const h = e.color.value;
      d = os.default[h], e.disabled.value || (i = os.hover[h]);
    }
    let u = "";
    return e.shadow.value === "" ? e.gradient.value && vr.includes(e.gradient.value) && (u = is[e.gradient.value]) : typeof e.shadow.value == "string" && vr.includes(e.shadow.value) && (u = is[e.shadow.value]), [
      d,
      i,
      u,
      e.pill.value && "!rounded-full",
      e.disabled.value && "cursor-not-allowed opacity-50",
      a && l ? "p-0.5" : r.value,
      (t.prefix || t.suffix || e.loading.value) && "inline-flex items-center",
      e.class.value
    ].filter((h) => h).join(" ");
  }), o = f(() => e.gradient.value && e.outline.value ? [
    "relative bg-white dark:bg-gray-900 rounded-md inline-flex items-center",
    r.value,
    e.disabled.value ? "" : "group-hover:bg-opacity-0 transition-all ease-in duration-75"
  ].filter((a) => a).join(" ") : "");
  return {
    wrapperClasses: s.value,
    spanClasses: o.value
  };
}
function Xn(e) {
  const t = {
    xs: "2.5",
    sm: "3",
    md: "4",
    lg: "5",
    xl: "6"
  }, r = f(() => t[e.size.value]);
  return {
    color: f(() => e.outline.value ? e.gradient.value ? e.gradient.value.includes("purple") ? "purple" : e.gradient.value.includes("blue") ? "blue" : e.gradient.value.includes("pink") ? "pink" : e.gradient.value.includes("red") ? "red" : "white" : ["alternative", "dark", "light"].includes(e.color.value) ? "white" : e.color.value === "default" ? "blue" : e.color.value : "white"),
    size: r
  };
}
const Zn = {
  0: "w-0 h-0",
  0.5: "w-0.5 h-0.5",
  1: "w-1 h-1",
  1.5: "w-1.5 h-1.5",
  10: "w-10 h-10",
  11: "w-11 h-11",
  12: "w-12 h-12",
  2: "w-2 h-2",
  2.5: "w-2.5 h-2.5",
  3: "w-3 h-3",
  4: "w-4 h-4",
  5: "w-5 h-5",
  6: "w-6 h-6",
  7: "w-7 h-7",
  8: "w-8 h-8",
  9: "w-9 h-9"
}, Qn = {
  blue: "fill-blue-600",
  gray: "fill-gray-600 dark:fill-gray-300",
  green: "fill-green-500",
  pink: "fill-pink-600",
  purple: "fill-purple-600",
  red: "fill-red-600",
  white: "fill-white",
  yellow: "fill-yellow-400"
};
function el(e) {
  const t = f(() => Zn[e.size.value]), r = f(() => Qn[e.color.value]), s = f(() => "text-gray-200 dark:text-gray-600"), o = f(() => "animate-spin");
  return { spinnerClasses: f(() => ne(
    o.value,
    s.value,
    r.value,
    t.value
  )) };
}
const Rt = /* @__PURE__ */ A({
  __name: "FwbSpinner",
  props: {
    color: { default: "blue" },
    size: { default: "4" }
  },
  setup(e) {
    const t = e, { spinnerClasses: r } = el(ue(t));
    return (s, o) => (g(), v("svg", {
      class: x(y(r)),
      fill: "none",
      role: "status",
      viewBox: "0 0 100 101",
      xmlns: "http://www.w3.org/2000/svg"
    }, o[0] || (o[0] = [
      b("path", {
        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
        fill: "currentColor"
      }, null, -1),
      b("path", {
        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
        fill: "currentFill"
      }, null, -1)
    ]), 2));
  }
}), tl = {
  key: 0,
  class: "mr-2"
}, rl = {
  key: 0,
  class: "mr-2"
}, sl = {
  key: 1,
  class: "ml-2"
}, ol = {
  key: 1,
  class: "ml-2"
}, al = /* @__PURE__ */ A({
  __name: "FwbButton",
  props: {
    class: { default: "" },
    color: { default: "default" },
    gradient: { default: null },
    size: { default: "md" },
    shadow: { type: [String, Boolean], default: !1 },
    pill: { type: Boolean, default: !1 },
    square: { type: Boolean, default: !1 },
    outline: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingPosition: { default: "prefix" },
    disabled: { type: Boolean, default: !1 },
    href: { default: "" },
    tag: { default: "a" }
  },
  setup(e) {
    const t = e, r = f(() => Jn(ue(t))), s = f(() => q(r.value.wrapperClasses)), o = f(() => q(r.value.spanClasses)), a = f(() => t.outline && t.gradient), n = f(() => t.loading && t.loadingPosition === "prefix"), l = f(() => t.loading && t.loadingPosition === "suffix"), { color: i, size: d } = Xn(ue(t)), u = t.tag !== "a" ? Te(t.tag) : "a", h = t.href ? u : "button", m = t.tag === "router-link" || t.tag === "nuxt-link" ? "to" : "href";
    return (c, p) => (g(), te(ge(y(h)), Re({
      class: s.value,
      [y(m) || ""]: c.href,
      disabled: y(h) === "button" && c.disabled
    }), {
      default: X(() => [
        !a.value && (c.$slots.prefix || n.value) ? (g(), v("div", tl, [
          n.value ? (g(), te(Rt, {
            key: 0,
            color: y(i),
            size: y(d)
          }, null, 8, ["color", "size"])) : C(c.$slots, "prefix", { key: 1 })
        ])) : O("", !0),
        b("span", {
          class: x(o.value)
        }, [
          a.value && (c.$slots.prefix || n.value) ? (g(), v("span", rl, [
            n.value ? (g(), te(Rt, {
              key: 0,
              color: y(i),
              size: y(d)
            }, null, 8, ["color", "size"])) : C(c.$slots, "prefix", { key: 1 })
          ])) : O("", !0),
          C(c.$slots, "default"),
          a.value && (c.$slots.suffix || l.value) ? (g(), v("span", sl, [
            l.value ? (g(), te(Rt, {
              key: 0,
              color: y(i),
              size: y(d)
            }, null, 8, ["color", "size"])) : C(c.$slots, "suffix", { key: 1 })
          ])) : O("", !0)
        ], 2),
        !a.value && (c.$slots.suffix || l.value) ? (g(), v("div", ol, [
          l.value ? (g(), te(Rt, {
            key: 0,
            color: y(i),
            size: y(d)
          }, null, 8, ["color", "size"])) : C(c.$slots, "suffix", { key: 1 })
        ])) : O("", !0)
      ]),
      _: 3
    }, 16, ["class", "disabled"]));
  }
}), nl = {}, ll = {
  class: "fwb-button-group inline-flex rounded-md shadow-xs",
  role: "group"
};
function il(e, t) {
  return g(), v("div", ll, [
    C(e.$slots, "default")
  ]);
}
const Z0 = /* @__PURE__ */ Pe(nl, [["render", il]]);
function dl(e) {
  const t = f(() => {
    let s = "";
    return e.variant.value === "image" && (s = "max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700"), e.variant.value === "default" ? s = "block max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 " : e.variant.value === "horizontal" && (s = "flex flex-col items-center bg-white rounded-lg border shadow-md md:flex-row md:max-w-xl dark:border-gray-700 dark:bg-gray-800"), e.href?.value && (s += " hover:bg-gray-100 dark:hover:bg-gray-700"), s;
  }), r = f(
    () => e.variant.value === "horizontal" ? "object-cover w-full h-96 rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" : ""
  );
  return {
    cardClasses: t,
    horizontalImageClasses: r
  };
}
const ul = ["alt", "src"], Q0 = /* @__PURE__ */ A({
  __name: "FwbCard",
  props: {
    href: {
      type: String,
      default: ""
    },
    imgAlt: {
      type: String,
      default: ""
    },
    imgSrc: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  setup(e) {
    const t = e, { cardClasses: r, horizontalImageClasses: s } = dl(ue(t)), o = f(() => t.href ? "a" : "div");
    return (a, n) => (g(), te(ge(o.value), {
      class: x(y(r)),
      href: e.href
    }, {
      default: X(() => [
        e.imgSrc ? (g(), v("img", {
          key: 0,
          alt: e.imgAlt,
          class: x([y(s), "rounded-t-lg"]),
          src: e.imgSrc
        }, null, 10, ul)) : O("", !0),
        b("div", null, [
          C(a.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["class", "href"]));
  }
}), cl = { class: "relative" }, fl = { class: "relative h-56 overflow-hidden rounded-lg sm:h-64 xl:h-80 2xl:h-96" }, pl = ["alt", "src"], gl = {
  key: 0,
  class: "absolute bottom-5 left-1/2 z-30 flex -translate-x-1/2 space-x-3"
}, hl = ["aria-label", "onClick"], eg = /* @__PURE__ */ A({
  __name: "FwbCarousel",
  props: {
    pictures: {
      type: Array,
      default() {
        return [];
      }
    },
    noIndicators: {
      type: Boolean,
      default: !1
    },
    noControls: {
      type: Boolean,
      default: !1
    },
    slide: {
      type: Boolean,
      default: !1
    },
    slideInterval: {
      type: Number,
      default: 3e3
    },
    animation: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, r = Z(0), s = Z(""), o = Z(), a = () => {
      o.value = setInterval(function() {
        i();
      }, t.slideInterval);
    }, n = () => {
      clearInterval(o.value), a();
    }, l = (u) => {
      r.value = u, n();
    }, i = () => {
      r.value !== t.pictures.length - 1 ? r.value++ : r.value = 0, s.value = "right", n();
    }, d = () => {
      r.value !== 0 ? r.value-- : r.value = t.pictures.length - 1, s.value = "left", n();
    };
    return Ze(() => {
      t.slide && a();
    }), (u, h) => (g(), v("div", cl, [
      b("div", fl, [
        (g(!0), v(ie, null, Ue(e.pictures, (m, c) => (g(), v("div", {
          key: c,
          class: x([c === r.value ? "z-30" : "z-0", "absolute inset-0 -translate-y-0"])
        }, [
          b("img", {
            alt: m.alt,
            src: m.src,
            class: "absolute left-1/2 top-1/2 block w-full -translate-x-1/2 -translate-y-1/2"
          }, null, 8, pl)
        ], 2))), 128))
      ]),
      e.noIndicators ? O("", !0) : (g(), v("div", gl, [
        (g(!0), v(ie, null, Ue(e.pictures, (m, c) => (g(), v("button", {
          key: c,
          "aria-label": "Slide " + c,
          class: x([c === r.value ? "bg-white" : "bg-white/50", "size-3 rounded-full bg-white"]),
          "aria-current": "false",
          type: "button",
          onClick: Wt((p) => l(c), ["prevent"])
        }, null, 10, hl))), 128))
      ])),
      e.noControls ? O("", !0) : (g(), v(ie, { key: 1 }, [
        b("button", {
          class: "group absolute left-0 top-0 z-30 flex h-full cursor-pointer items-center justify-center px-4 focus:outline-none",
          "data-carousel-prev": "",
          type: "button",
          onClick: Wt(d, ["prevent"])
        }, h[0] || (h[0] = [
          b("span", { class: "inline-flex size-8 items-center justify-center rounded-full bg-white/30 group-hover:bg-white/50 group-focus:outline-none group-focus:ring-4 group-focus:ring-white dark:bg-gray-800/30 dark:group-hover:bg-gray-800/60 dark:group-focus:ring-gray-800/70 sm:size-10" }, [
            b("svg", {
              class: "size-5 text-white dark:text-gray-800 sm:size-6",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              b("path", {
                d: "M15 19l-7-7 7-7",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2"
              })
            ]),
            b("span", { class: "hidden" }, "Previous")
          ], -1)
        ])),
        b("button", {
          class: "group absolute right-0 top-0 z-30 flex h-full cursor-pointer items-center justify-center px-4 focus:outline-none",
          "data-carousel-next": "",
          type: "button",
          onClick: Wt(i, ["prevent"])
        }, h[1] || (h[1] = [
          b("span", { class: "inline-flex size-8 items-center justify-center rounded-full bg-white/30 group-hover:bg-white/50 group-focus:outline-none group-focus:ring-4 group-focus:ring-white dark:bg-gray-800/30 dark:group-hover:bg-gray-800/60 dark:group-focus:ring-gray-800/70 sm:size-10" }, [
            b("svg", {
              class: "size-5 text-white dark:text-gray-800 sm:size-6",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              b("path", {
                d: "M9 5l7 7-7 7",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2"
              })
            ]),
            b("span", { class: "hidden" }, "Next")
          ], -1)
        ]))
      ], 64))
    ]));
  }
});
function wo(e) {
  return Ys() ? (Js(e), !0) : !1;
}
const yr = /* @__PURE__ */ new WeakMap(), ml = (...e) => {
  var t;
  const r = e[0], s = (t = or()) == null ? void 0 : t.proxy;
  if (s == null && !Zs())
    throw new Error("injectLocal must be called in setup");
  return s && yr.has(s) && r in yr.get(s) ? yr.get(s)[r] : fe(...e);
}, Nr = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const bl = (e) => typeof e < "u", vl = Object.prototype.toString, yl = (e) => vl.call(e) === "[object Object]", st = () => {
}, wl = /* @__PURE__ */ kl();
function kl() {
  var e, t;
  return Nr && ((e = window?.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window?.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function xl(e, t) {
  var r;
  if (typeof e == "number")
    return e + t;
  const s = ((r = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : r[0]) || "", o = e.slice(s.length), a = Number.parseFloat(s) + t;
  return Number.isNaN(a) ? e : a + o;
}
function wt(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function Cl(e) {
  return or();
}
function wr(e) {
  return Array.isArray(e) ? e : [e];
}
function $l(e, t = !0, r) {
  Cl() ? Ze(e, r) : t ? e() : zt(e);
}
function _l(e, t, r = {}) {
  const {
    immediate: s = !0,
    immediateCallback: o = !1
  } = r, a = Se(!1);
  let n = null;
  function l() {
    n && (clearTimeout(n), n = null);
  }
  function i() {
    a.value = !1, l();
  }
  function d(...u) {
    o && e(), l(), a.value = !0, n = setTimeout(() => {
      a.value = !1, n = null, e(...u);
    }, de(t));
  }
  return s && (a.value = !0, Nr && d()), wo(i), {
    isPending: la(a),
    start: d,
    stop: i
  };
}
function Sl(e = !1, t = {}) {
  const {
    truthyValue: r = !0,
    falsyValue: s = !1
  } = t, o = Xs(e), a = Se(e);
  function n(l) {
    if (arguments.length)
      return a.value = l, a.value;
    {
      const i = de(r);
      return a.value = a.value === i ? de(s) : i, a.value;
    }
  }
  return o ? n : [a, n];
}
function Tl(e, t, r) {
  return Me(
    e,
    t,
    {
      ...r,
      immediate: !0
    }
  );
}
const nr = Nr ? window : void 0;
function vt(e) {
  var t;
  const r = de(e);
  return (t = r?.$el) != null ? t : r;
}
function nt(...e) {
  const t = [], r = () => {
    t.forEach((l) => l()), t.length = 0;
  }, s = (l, i, d, u) => (l.addEventListener(i, d, u), () => l.removeEventListener(i, d, u)), o = f(() => {
    const l = wr(de(e[0])).filter((i) => i != null);
    return l.every((i) => typeof i != "string") ? l : void 0;
  }), a = Tl(
    () => {
      var l, i;
      return [
        (i = (l = o.value) == null ? void 0 : l.map((d) => vt(d))) != null ? i : [nr].filter((d) => d != null),
        wr(de(o.value ? e[1] : e[0])),
        wr(y(o.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        de(o.value ? e[3] : e[2])
      ];
    },
    ([l, i, d, u]) => {
      if (r(), !l?.length || !i?.length || !d?.length)
        return;
      const h = yl(u) ? { ...u } : u;
      t.push(
        ...l.flatMap(
          (m) => i.flatMap(
            (c) => d.map((p) => s(m, c, p, h))
          )
        )
      );
    },
    { flush: "post" }
  ), n = () => {
    a(), r();
  };
  return wo(r), n;
}
let ds = !1;
function Pl(e, t, r = {}) {
  const { window: s = nr, ignore: o = [], capture: a = !0, detectIframe: n = !1, controls: l = !1 } = r;
  if (!s)
    return l ? { stop: st, cancel: st, trigger: st } : st;
  if (wl && !ds) {
    ds = !0;
    const k = { passive: !0 };
    Array.from(s.document.body.children).forEach((T) => nt(T, "click", st, k)), nt(s.document.documentElement, "click", st, k);
  }
  let i = !0;
  const d = (k) => de(o).some((T) => {
    if (typeof T == "string")
      return Array.from(s.document.querySelectorAll(T)).some((B) => B === k.target || k.composedPath().includes(B));
    {
      const B = vt(T);
      return B && (k.target === B || k.composedPath().includes(B));
    }
  });
  function u(k) {
    const T = de(k);
    return T && T.$.subTree.shapeFlag === 16;
  }
  function h(k, T) {
    const B = de(k), M = B.$.subTree && B.$.subTree.children;
    return M == null || !Array.isArray(M) ? !1 : M.some((H) => H.el === T.target || T.composedPath().includes(H.el));
  }
  const m = (k) => {
    const T = vt(e);
    if (k.target != null && !(!(T instanceof Element) && u(e) && h(e, k)) && !(!T || T === k.target || k.composedPath().includes(T))) {
      if ("detail" in k && k.detail === 0 && (i = !d(k)), !i) {
        i = !0;
        return;
      }
      t(k);
    }
  };
  let c = !1;
  const p = [
    nt(s, "click", (k) => {
      c || (c = !0, setTimeout(() => {
        c = !1;
      }, 0), m(k));
    }, { passive: !0, capture: a }),
    nt(s, "pointerdown", (k) => {
      const T = vt(e);
      i = !d(k) && !!(T && !k.composedPath().includes(T));
    }, { passive: !0 }),
    n && nt(s, "blur", (k) => {
      setTimeout(() => {
        var T;
        const B = vt(e);
        ((T = s.document.activeElement) == null ? void 0 : T.tagName) === "IFRAME" && !B?.contains(s.document.activeElement) && t(k);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), _ = () => p.forEach((k) => k());
  return l ? {
    stop: _,
    cancel: () => {
      i = !1;
    },
    trigger: (k) => {
      i = !0, m(k), i = !1;
    }
  } : _;
}
function Al() {
  const e = Se(!1), t = or();
  return t && Ze(() => {
    e.value = !0;
  }, t), e;
}
function Fl(e) {
  const t = Al();
  return f(() => (t.value, !!e()));
}
const zl = Symbol("vueuse-ssr-width");
function ko() {
  const e = Zs() ? ml(zl, null) : null;
  return typeof e == "number" ? e : void 0;
}
function ht(e, t = {}) {
  const { window: r = nr, ssrWidth: s = ko() } = t, o = Fl(() => r && "matchMedia" in r && typeof r.matchMedia == "function"), a = Se(typeof s == "number"), n = Se(), l = Se(!1), i = (d) => {
    l.value = d.matches;
  };
  return ia(() => {
    if (a.value) {
      a.value = !o.value;
      const d = de(e).split(",");
      l.value = d.some((u) => {
        const h = u.includes("not all"), m = u.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), c = u.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let p = !!(m || c);
        return m && p && (p = s >= wt(m[1])), c && p && (p = s <= wt(c[1])), h ? !p : p;
      });
      return;
    }
    o.value && (n.value = r.matchMedia(de(e)), l.value = n.value.matches);
  }), nt(n, "change", i, { passive: !0 }), f(() => l.value);
}
const xo = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
};
function Co(e, t = {}) {
  function r(c, p) {
    let _ = de(e[de(c)]);
    return p != null && (_ = xl(_, p)), typeof _ == "number" && (_ = `${_}px`), _;
  }
  const { window: s = nr, strategy: o = "min-width", ssrWidth: a = ko() } = t, n = typeof a == "number", l = n ? Se(!1) : { value: !0 };
  n && $l(() => l.value = !!s);
  function i(c, p) {
    return !l.value && n ? c === "min" ? a >= wt(p) : a <= wt(p) : s ? s.matchMedia(`(${c}-width: ${p})`).matches : !1;
  }
  const d = (c) => ht(() => `(min-width: ${r(c)})`, t), u = (c) => ht(() => `(max-width: ${r(c)})`, t), h = Object.keys(e).reduce((c, p) => (Object.defineProperty(c, p, {
    get: () => o === "min-width" ? d(p) : u(p),
    enumerable: !0,
    configurable: !0
  }), c), {});
  function m() {
    const c = Object.keys(e).map((p) => [p, h[p], wt(r(p))]).sort((p, _) => p[2] - _[2]);
    return f(() => c.filter(([, p]) => p.value).map(([p]) => p));
  }
  return Object.assign(h, {
    greaterOrEqual: d,
    smallerOrEqual: u,
    greater(c) {
      return ht(() => `(min-width: ${r(c, 0.1)})`, t);
    },
    smaller(c) {
      return ht(() => `(max-width: ${r(c, -0.1)})`, t);
    },
    between(c, p) {
      return ht(() => `(min-width: ${r(c)}) and (max-width: ${r(p, -0.1)})`, t);
    },
    isGreater(c) {
      return i("min", r(c, 0.1));
    },
    isGreaterOrEqual(c) {
      return i("min", r(c));
    },
    isSmaller(c) {
      return i("max", r(c, -0.1));
    },
    isSmallerOrEqual(c) {
      return i("max", r(c));
    },
    isInBetween(c, p) {
      return i("min", r(c)) && i("max", r(p, -0.1));
    },
    current: m,
    active() {
      const c = m();
      return f(() => c.value.length === 0 ? "" : c.value.at(o === "min-width" ? -1 : 0));
    }
  });
}
function Il(e) {
  return JSON.parse(JSON.stringify(e));
}
function Bl(e, t, r, s = {}) {
  var o, a, n;
  const {
    clone: l = !1,
    passive: i = !1,
    eventName: d,
    deep: u = !1,
    defaultValue: h,
    shouldEmit: m
  } = s, c = or(), p = r || c?.emit || ((o = c?.$emit) == null ? void 0 : o.bind(c)) || ((n = (a = c?.proxy) == null ? void 0 : a.$emit) == null ? void 0 : n.bind(c?.proxy));
  let _ = d;
  _ = _ || `update:${t.toString()}`;
  const k = (M) => l ? typeof l == "function" ? l(M) : Il(M) : M, T = () => bl(e[t]) ? k(e[t]) : h, B = (M) => {
    m ? m(M) && p(_, M) : p(_, M);
  };
  if (i) {
    const M = T(), H = Z(M);
    let S = !1;
    return Me(
      () => e[t],
      (D) => {
        S || (S = !0, H.value = k(D), zt(() => S = !1));
      }
    ), Me(
      H,
      (D) => {
        !S && (D !== e[t] || u) && B(D);
      },
      { deep: u }
    ), H;
  } else
    return f({
      get() {
        return T();
      },
      set(M) {
        B(M);
      }
    });
}
const El = "fwb-dropdown inline-flex relative", Ol = "absolute z-10 bg-white rounded shadow-sm dark:bg-gray-700", Dt = 8, Ml = {
  horizontal: "left-0",
  vertical: "top-0",
  horizontal_reverse: "right-0",
  vertical_reverse: "bottom-0"
}, Nl = {
  bottom: "",
  left: "rotate-90",
  right: "-rotate-90",
  top: "rotate-180"
}, Ll = {
  bottom: (e) => `bottom: -${e.height + Dt}px;`,
  left: (e) => `left: -${e.width + Dt}px;`,
  right: (e) => `right: -${e.width + Dt}px;`,
  top: (e) => `top: -${e.height + Dt}px;`
};
function Rl({ contentWrapper: e, isContentVisible: t, props: r }) {
  const s = r.alignToEnd, o = r.placement, a = r.contentWrapperClass ?? "", n = r.triggerWrapperClass ?? "", l = r.class ?? "", i = f(() => {
    let k = "";
    return t.value && (k += " fwb-dropdown-active"), q([El, k, l]);
  }), d = f(() => {
    let k = ["top", "bottom"].includes(o) ? "horizontal" : "vertical";
    return s && (k = `${k}_reverse`), q([
      Ol,
      Ml[k],
      a
    ]);
  }), u = f(() => q([n])), h = "", m = f(
    () => q([
      Nl[o],
      o === "left" ? "mr-2" : ""
    ])
  ), c = Z(""), p = () => {
    const k = e.value?.getBoundingClientRect();
    c.value = k ? Ll[o](k) : "";
  }, _ = new MutationObserver(() => {
    p();
  });
  return Me(t, (k) => {
    k && zt(() => p());
  }), Me(
    e,
    (k) => {
      k ? _.observe(k, {
        childList: !0,
        subtree: !0
      }) : _.disconnect();
    }
  ), {
    contentStyles: c,
    contentWrapperClasses: d,
    triggerClasses: h,
    triggerSuffixClass: m,
    triggerWrapperClasses: u,
    wrapperClasses: i
  };
}
var Dl = typeof global == "object" && global && global.Object === Object && global, jl = typeof self == "object" && self && self.Object === Object && self, Lr = Dl || jl || Function("return this")(), Ne = Lr.Symbol, $o = Object.prototype, Vl = $o.hasOwnProperty, Hl = $o.toString, mt = Ne ? Ne.toStringTag : void 0;
function Wl(e) {
  var t = Vl.call(e, mt), r = e[mt];
  try {
    e[mt] = void 0;
    var s = !0;
  } catch {
  }
  var o = Hl.call(e);
  return s && (t ? e[mt] = r : delete e[mt]), o;
}
var Gl = Object.prototype, ql = Gl.toString;
function Kl(e) {
  return ql.call(e);
}
var Ul = "[object Null]", Yl = "[object Undefined]", us = Ne ? Ne.toStringTag : void 0;
function Rr(e) {
  return e == null ? e === void 0 ? Yl : Ul : us && us in Object(e) ? Wl(e) : Kl(e);
}
function Dr(e) {
  return e != null && typeof e == "object";
}
var Jl = "[object Symbol]";
function jr(e) {
  return typeof e == "symbol" || Dr(e) && Rr(e) == Jl;
}
function Xl(e, t) {
  for (var r = -1, s = e == null ? 0 : e.length, o = Array(s); ++r < s; )
    o[r] = t(e[r], r, e);
  return o;
}
var ct = Array.isArray, cs = Ne ? Ne.prototype : void 0, fs = cs ? cs.toString : void 0;
function _o(e) {
  if (typeof e == "string")
    return e;
  if (ct(e))
    return Xl(e, _o) + "";
  if (jr(e))
    return fs ? fs.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Kt(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function Zl(e) {
  return e;
}
var Ql = "[object AsyncFunction]", ei = "[object Function]", ti = "[object GeneratorFunction]", ri = "[object Proxy]";
function si(e) {
  if (!Kt(e))
    return !1;
  var t = Rr(e);
  return t == ei || t == ti || t == Ql || t == ri;
}
var kr = Lr["__core-js_shared__"], ps = function() {
  var e = /[^.]+$/.exec(kr && kr.keys && kr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function oi(e) {
  return !!ps && ps in e;
}
var ai = Function.prototype, ni = ai.toString;
function li(e) {
  if (e != null) {
    try {
      return ni.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ii = /[\\^$.*+?()[\]{}|]/g, di = /^\[object .+?Constructor\]$/, ui = Function.prototype, ci = Object.prototype, fi = ui.toString, pi = ci.hasOwnProperty, gi = RegExp(
  "^" + fi.call(pi).replace(ii, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function hi(e) {
  if (!Kt(e) || oi(e))
    return !1;
  var t = si(e) ? gi : di;
  return t.test(li(e));
}
function mi(e, t) {
  return e?.[t];
}
function Vr(e, t) {
  var r = mi(e, t);
  return hi(r) ? r : void 0;
}
function bi(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
var vi = 800, yi = 16, wi = Date.now;
function ki(e) {
  var t = 0, r = 0;
  return function() {
    var s = wi(), o = yi - (s - r);
    if (r = s, o > 0) {
      if (++t >= vi)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function xi(e) {
  return function() {
    return e;
  };
}
var Ut = function() {
  try {
    var e = Vr(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Ci = Ut ? function(e, t) {
  return Ut(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: xi(t),
    writable: !0
  });
} : Zl, $i = ki(Ci), _i = 9007199254740991, Si = /^(?:0|[1-9]\d*)$/;
function So(e, t) {
  var r = typeof e;
  return t = t ?? _i, !!t && (r == "number" || r != "symbol" && Si.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Ti(e, t, r) {
  t == "__proto__" && Ut ? Ut(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function To(e, t) {
  return e === t || e !== e && t !== t;
}
var Pi = Object.prototype, Ai = Pi.hasOwnProperty;
function Fi(e, t, r) {
  var s = e[t];
  (!(Ai.call(e, t) && To(s, r)) || r === void 0 && !(t in e)) && Ti(e, t, r);
}
var gs = Math.max;
function zi(e, t, r) {
  return t = gs(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var s = arguments, o = -1, a = gs(s.length - t, 0), n = Array(a); ++o < a; )
      n[o] = s[t + o];
    o = -1;
    for (var l = Array(t + 1); ++o < t; )
      l[o] = s[o];
    return l[t] = r(n), bi(e, this, l);
  };
}
var Ii = 9007199254740991;
function Bi(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Ii;
}
var Ei = "[object Arguments]";
function hs(e) {
  return Dr(e) && Rr(e) == Ei;
}
var Po = Object.prototype, Oi = Po.hasOwnProperty, Mi = Po.propertyIsEnumerable, Ao = hs(/* @__PURE__ */ function() {
  return arguments;
}()) ? hs : function(e) {
  return Dr(e) && Oi.call(e, "callee") && !Mi.call(e, "callee");
}, Ni = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Li = /^\w*$/;
function Ri(e, t) {
  if (ct(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || jr(e) ? !0 : Li.test(e) || !Ni.test(e) || t != null && e in Object(t);
}
var St = Vr(Object, "create");
function Di() {
  this.__data__ = St ? St(null) : {}, this.size = 0;
}
function ji(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Vi = "__lodash_hash_undefined__", Hi = Object.prototype, Wi = Hi.hasOwnProperty;
function Gi(e) {
  var t = this.__data__;
  if (St) {
    var r = t[e];
    return r === Vi ? void 0 : r;
  }
  return Wi.call(t, e) ? t[e] : void 0;
}
var qi = Object.prototype, Ki = qi.hasOwnProperty;
function Ui(e) {
  var t = this.__data__;
  return St ? t[e] !== void 0 : Ki.call(t, e);
}
var Yi = "__lodash_hash_undefined__";
function Ji(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = St && t === void 0 ? Yi : t, this;
}
function Ye(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
Ye.prototype.clear = Di;
Ye.prototype.delete = ji;
Ye.prototype.get = Gi;
Ye.prototype.has = Ui;
Ye.prototype.set = Ji;
function Xi() {
  this.__data__ = [], this.size = 0;
}
function lr(e, t) {
  for (var r = e.length; r--; )
    if (To(e[r][0], t))
      return r;
  return -1;
}
var Zi = Array.prototype, Qi = Zi.splice;
function ed(e) {
  var t = this.__data__, r = lr(t, e);
  if (r < 0)
    return !1;
  var s = t.length - 1;
  return r == s ? t.pop() : Qi.call(t, r, 1), --this.size, !0;
}
function td(e) {
  var t = this.__data__, r = lr(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function rd(e) {
  return lr(this.__data__, e) > -1;
}
function sd(e, t) {
  var r = this.__data__, s = lr(r, e);
  return s < 0 ? (++this.size, r.push([e, t])) : r[s][1] = t, this;
}
function ft(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
ft.prototype.clear = Xi;
ft.prototype.delete = ed;
ft.prototype.get = td;
ft.prototype.has = rd;
ft.prototype.set = sd;
var od = Vr(Lr, "Map");
function ad() {
  this.size = 0, this.__data__ = {
    hash: new Ye(),
    map: new (od || ft)(),
    string: new Ye()
  };
}
function nd(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ir(e, t) {
  var r = e.__data__;
  return nd(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function ld(e) {
  var t = ir(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function id(e) {
  return ir(this, e).get(e);
}
function dd(e) {
  return ir(this, e).has(e);
}
function ud(e, t) {
  var r = ir(this, e), s = r.size;
  return r.set(e, t), this.size += r.size == s ? 0 : 1, this;
}
function Qe(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
Qe.prototype.clear = ad;
Qe.prototype.delete = ld;
Qe.prototype.get = id;
Qe.prototype.has = dd;
Qe.prototype.set = ud;
var cd = "Expected a function";
function Hr(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(cd);
  var r = function() {
    var s = arguments, o = t ? t.apply(this, s) : s[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var n = e.apply(this, s);
    return r.cache = a.set(o, n) || a, n;
  };
  return r.cache = new (Hr.Cache || Qe)(), r;
}
Hr.Cache = Qe;
var fd = 500;
function pd(e) {
  var t = Hr(e, function(s) {
    return r.size === fd && r.clear(), s;
  }), r = t.cache;
  return t;
}
var gd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hd = /\\(\\)?/g, md = pd(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(gd, function(r, s, o, a) {
    t.push(o ? a.replace(hd, "$1") : s || r);
  }), t;
});
function bd(e) {
  return e == null ? "" : _o(e);
}
function dr(e, t) {
  return ct(e) ? e : Ri(e, t) ? [e] : md(bd(e));
}
function Wr(e) {
  if (typeof e == "string" || jr(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function vd(e, t) {
  t = dr(t, e);
  for (var r = 0, s = t.length; e != null && r < s; )
    e = e[Wr(t[r++])];
  return r && r == s ? e : void 0;
}
function yd(e, t) {
  for (var r = -1, s = t.length, o = e.length; ++r < s; )
    e[o + r] = t[r];
  return e;
}
var ms = Ne ? Ne.isConcatSpreadable : void 0;
function wd(e) {
  return ct(e) || Ao(e) || !!(ms && e && e[ms]);
}
function kd(e, t, r, s, o) {
  var a = -1, n = e.length;
  for (r || (r = wd), o || (o = []); ++a < n; ) {
    var l = e[a];
    r(l) ? yd(o, l) : o[o.length] = l;
  }
  return o;
}
function xd(e) {
  var t = e == null ? 0 : e.length;
  return t ? kd(e) : [];
}
function Cd(e) {
  return $i(zi(e, void 0, xd), e + "");
}
function $d(e, t) {
  return e != null && t in Object(e);
}
function _d(e, t, r) {
  t = dr(t, e);
  for (var s = -1, o = t.length, a = !1; ++s < o; ) {
    var n = Wr(t[s]);
    if (!(a = e != null && r(e, n)))
      break;
    e = e[n];
  }
  return a || ++s != o ? a : (o = e == null ? 0 : e.length, !!o && Bi(o) && So(n, o) && (ct(e) || Ao(e)));
}
function Sd(e, t) {
  return e != null && _d(e, t, $d);
}
function Td(e, t, r, s) {
  if (!Kt(e))
    return e;
  t = dr(t, e);
  for (var o = -1, a = t.length, n = a - 1, l = e; l != null && ++o < a; ) {
    var i = Wr(t[o]), d = r;
    if (i === "__proto__" || i === "constructor" || i === "prototype")
      return e;
    if (o != n) {
      var u = l[i];
      d = void 0, d === void 0 && (d = Kt(u) ? u : So(t[o + 1]) ? [] : {});
    }
    Fi(l, i, d), l = l[i];
  }
  return e;
}
function Pd(e, t, r) {
  for (var s = -1, o = t.length, a = {}; ++s < o; ) {
    var n = t[s], l = vd(e, n);
    r(l, n) && Td(a, dr(n, e), l);
  }
  return a;
}
function Ad(e, t) {
  return Pd(e, t, function(r, s) {
    return Sd(e, s);
  });
}
var Fd = Cd(function(e, t) {
  return e == null ? {} : Ad(e, t);
});
function Yt(e, t = !0, r = []) {
  return e.forEach((s) => {
    if (s !== null) {
      if (typeof s != "object") {
        (typeof s == "string" || typeof s == "number") && r.push(ce(String(s)));
        return;
      }
      if (Array.isArray(s)) {
        Yt(s, t, r);
        return;
      }
      if (s.type === ie) {
        if (s.children === null)
          return;
        Array.isArray(s.children) && Yt(s.children, t, r);
      } else s.type !== da && r.push(s);
    }
  }), r;
}
function zd(e, t = "default", r = void 0) {
  const s = e[t];
  if (!s)
    return console.warn("getFirstSlotVNode", `slot[${t}] is empty`), null;
  const o = Yt(s(r));
  return o.length === 1 ? o[0] : (console.warn("getFirstSlotVNode", `slot[${t}] should have exactly one child`), null);
}
const Id = {
  focus: ["onFocus", "onBlur"],
  click: ["onClick"],
  hover: ["onMouseenter", "onMouseleave"]
};
function Bd(e, t) {
  Object.entries(Id).forEach(([, r]) => {
    r.forEach((s) => {
      e.props ? e.props = Object.assign({}, e.props) : e.props = {};
      const o = e.props[s], a = t[s];
      o ? e.props[s] = (...n) => {
        o(...n), a(...n);
      } : e.props[s] = a;
    });
  });
}
const bs = A({
  name: "SlotListener",
  props: {
    trigger: {
      type: String,
      default: "click"
    }
  },
  emits: ["click", "focus", "blur", "mouseenter", "mouseleave"],
  setup(e, { emit: t }) {
    return {
      handleClick: (l) => {
        t("click", l);
      },
      handleBlur: (l) => {
        t("blur", l);
      },
      handleFocus: (l) => {
        t("focus", l);
      },
      handleMouseLeave: (l) => {
        t("mouseleave", l);
      },
      handleMouseEnter: (l) => {
        t("mouseenter", l);
      }
    };
  },
  render() {
    const {
      $slots: e
    } = this, t = {
      onClick: this.handleClick,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur
    }, r = zd(e, "default"), s = [
      t
    ];
    return r?.props && s.push(
      Fd(r.props, "onClick", "onMouseenter", "onMouseleave", "onFocus", "onBlur")
    ), r && Bd(
      r,
      {
        onBlur: (a) => {
          s.forEach((n) => {
            n?.onBlur?.(a);
          });
        },
        onFocus: (a) => {
          s.forEach((n) => {
            n?.onFocus?.(a);
          });
        },
        onClick: (a) => {
          s.forEach((n) => {
            n?.onClick?.(a);
          });
        },
        onMouseenter: (a) => {
          s.forEach((n) => {
            n?.onMouseenter?.(a);
          });
        },
        onMouseleave: (a) => {
          s.forEach((n) => {
            n?.onMouseleave?.(a);
          });
        }
      }
    ), r;
  }
}), tg = /* @__PURE__ */ A({
  __name: "FwbDropdown",
  props: {
    alignToEnd: { type: Boolean, default: !1 },
    class: { default: "" },
    closeInside: { type: Boolean, default: !1 },
    color: { default: "default" },
    contentWrapperClass: { default: "" },
    disabled: { type: Boolean, default: !1 },
    placement: { default: "bottom" },
    text: { default: "Dropdown" },
    transition: { default: "" },
    triggerClass: { default: "" },
    triggerWrapperClass: { default: "" }
  },
  emits: ["show", "hide"],
  setup(e, { emit: t }) {
    const r = e, s = Z(), o = Z(), a = Z(!1), n = () => a.value = !a.value, l = () => r.closeInside && (a.value = !1);
    Pl(
      s,
      () => a.value && (a.value = !1)
    );
    const i = t;
    Me(a, () => {
      a.value ? i("show") : i("hide");
    });
    const d = {
      bottom: "to-bottom",
      left: "to-left",
      right: "to-right",
      top: "to-top"
    }, u = f(
      () => r.transition ? r.transition : d[r.placement]
    ), {
      contentStyles: h,
      contentWrapperClasses: m,
      triggerSuffixClass: c,
      triggerWrapperClasses: p,
      wrapperClasses: _
    } = Rl({ contentWrapper: o, isContentVisible: a, props: r });
    return (k, T) => (g(), v("div", {
      ref_key: "dropdownWrapper",
      ref: s,
      class: x(y(_))
    }, [
      b("div", {
        class: x(y(p))
      }, [
        Ge(bs, { onClick: n }, {
          default: X(() => [
            C(k.$slots, "trigger", {}, () => [
              Ge(al, {
                "aria-expanded": a.value,
                class: x([k.placement === "left" ? ["flex-row-reverse", "pl-2"] : "", k.triggerClass]),
                color: k.color,
                disabled: k.disabled,
                "aria-haspopup": "true",
                role: "button"
              }, {
                suffix: X(() => [
                  (g(), v("svg", {
                    class: x([y(c), "size-4"]),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, T[0] || (T[0] = [
                    b("path", {
                      d: "M19 9l-7 7-7-7",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2"
                    }, null, -1)
                  ]), 2))
                ]),
                default: X(() => [
                  ce(G(k.text) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-expanded", "class", "color", "disabled"])
            ])
          ]),
          _: 3
        })
      ], 2),
      Ge(Qs, { name: u.value }, {
        default: X(() => [
          a.value ? (g(), v("div", {
            key: 0,
            ref_key: "contentWrapper",
            ref: o,
            class: x(y(m)),
            style: yt(y(h))
          }, [
            Ge(bs, { onClick: l }, {
              default: X(() => [
                C(k.$slots, "default")
              ]),
              _: 3
            })
          ], 6)) : O("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ], 2));
  }
}), rg = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbFooter",
  props: {
    sticky: { type: Boolean, default: !1 },
    footerType: { default: "default" }
  },
  setup(e) {
    const t = e, r = me(), s = J(
      t.footerType === "sitemap" && "bg-gray-800",
      t.footerType === "socialmedia" && "p-4 bg-white sm:p-6 dark:bg-gray-800",
      t.footerType === "logo" && "p-4 bg-white rounded-lg shadow-sm md:px-6 md:py-8 dark:bg-gray-800",
      t.footerType === "default" && "p-4 bg-white rounded-lg shadow-sm md:flex md:items-center md:justify-between md:p-6 dark:bg-gray-800",
      t.sticky && "absolute bottom-0 left-0 z-20 w-full border-t border-gray-200 dark:border-gray-600",
      r.class
    );
    return (o, a) => (g(), v("footer", pe(o.$attrs, { class: y(s) }), [
      C(o.$slots, "default")
    ], 16));
  }
}), Ed = ["href"], Od = ["alt", "src"], sg = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbFooterBrand",
  props: {
    href: { default: "" },
    src: { default: "" },
    alt: { default: "" },
    name: { default: "" },
    imageClass: { default: "" },
    nameClass: { default: "" },
    aClass: { default: "" }
  },
  setup(e) {
    const t = me(), r = e, s = J("mb-6 md:mb-0", t.class), o = J("flex items-center", r.aClass), a = J("h-8 mr-3", r.imageClass), n = J("self-center text-2xl font-semibold whitespace-nowrap dark:text-white", r.nameClass);
    return (l, i) => (g(), v("div", pe({ class: y(s) }, l.$attrs), [
      b("a", {
        class: x(y(o)),
        href: l.href
      }, [
        b("img", {
          alt: l.alt,
          class: x(y(a)),
          src: l.src
        }, null, 10, Od),
        b("span", {
          class: x(y(n))
        }, G(l.name), 3)
      ], 10, Ed)
    ], 16));
  }
}), og = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbFooterCopyright",
  props: {
    year: { default: (/* @__PURE__ */ new Date()).getFullYear() },
    by: { default: "" },
    href: { default: "" },
    aClass: { default: "" },
    copyrightMessage: { default: "All Rights Reserved." }
  },
  setup(e) {
    const t = e, r = me(), s = J("block text-sm text-gray-500 sm:text-center dark:text-gray-400", r.class), o = J(t.href ? "hover:underline" : "ml-1", t.aClass), a = t.href ? "a" : "span";
    return (n, l) => (g(), v("span", pe(n.$attrs, { class: y(s) }), [
      ce(" © " + G(n.year) + " ", 1),
      (g(), te(ge(y(a)), {
        class: x(y(o)),
        href: n.href
      }, {
        default: X(() => [
          ce(G(n.by), 1)
        ]),
        _: 1
      }, 8, ["class", "href"])),
      ce(" " + G(n.copyrightMessage), 1)
    ], 16));
  }
}), Md = { class: "sr-only" }, ag = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbFooterIcon",
  props: {
    href: { default: "" },
    ariaLabel: { default: "" },
    srText: { default: "" }
  },
  setup(e) {
    const t = me(), s = e.href ? "a" : "span", o = J("text-gray-500 hover:text-gray-900 dark:hover:text-white", t.class);
    return (a, n) => (g(), te(ge(y(s)), pe({
      "aria-label": a.ariaLabel,
      class: y(o),
      href: a.href
    }, a.$attrs), {
      default: X(() => [
        C(a.$slots, "default"),
        b("span", Md, G(a.srText), 1)
      ]),
      _: 3
    }, 16, ["aria-label", "class", "href"]));
  }
}), ng = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbFooterLink",
  props: {
    href: { default: "" },
    aClass: { default: "" },
    component: { default: "a" }
  },
  setup(e) {
    const t = me(), r = e, s = r.component === "a" ? "a" : Te(r.component), o = r.component === "router-link" ? "to" : "href", a = J("hover:underline", r.aClass), n = J("mr-4 md:mr-6 last:mr-0", t.class);
    return (l, i) => (g(), v("li", pe(l.$attrs, { class: y(n) }), [
      (g(), te(ge(y(s)), Re({
        [y(o) || ""]: l.href,
        class: y(a)
      }), {
        default: X(() => [
          C(l.$slots, "default")
        ]),
        _: 3
      }, 16, ["class"]))
    ], 16));
  }
}), lg = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbFooterLinkGroup",
  setup(e) {
    const t = me(), r = J("flex flex-wrap items-center mt-3 text-sm font-medium text-gray-500 dark:text-gray-400 sm:mt-0", t.class);
    return (s, o) => (g(), v("ul", pe(s.$attrs, { class: y(r) }), [
      C(s.$slots, "default")
    ], 16));
  }
}), ig = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbJumbotron",
  props: {
    headerLevel: { default: 1 },
    subText: { default: "" },
    subTextClasses: { default: "" },
    headerText: { default: "" },
    headerClasses: { default: "" }
  },
  setup(e) {
    const t = e, r = me(), s = f(() => J(
      "bg-white dark:bg-gray-900 py-8 lg:py-16 px-4 mx-auto max-w-screen-xl text-center ",
      r.class
    )), o = f(() => J("mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white", t.headerClasses)), a = f(() => J("mb-8 text-lg font-normal text-gray-500 lg:text-xl sm:px-0 lg:px-16 dark:text-gray-400", t.subTextClasses));
    return (n, l) => (g(), v("div", pe(n.$attrs, { class: s.value }), [
      (g(), te(ge(`h${n.headerLevel}`), {
        class: x(o.value)
      }, {
        default: X(() => [
          ce(G(n.headerText), 1)
        ]),
        _: 1
      }, 8, ["class"])),
      b("div", {
        class: x(a.value)
      }, G(n.subText), 3),
      C(n.$slots, "default")
    ], 16));
  }
}), Nd = "overflow-hidden w-48 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white";
function Ld() {
  return {
    containerClasses: f(() => ne(
      Nd
    ))
  };
}
const dg = /* @__PURE__ */ A({
  __name: "FwbListGroup",
  setup(e) {
    const { containerClasses: t } = Ld();
    return (r, s) => (g(), v("ul", {
      class: x(y(t))
    }, [
      C(r.$slots, "default")
    ], 2));
  }
}), Rd = "inline-flex items-center w-full px-4 py-2 border-b border-gray-200 dark:border-gray-600", Dd = "block w-full px-4 py-2 cursor-pointer hover:bg-gray-100 hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white", jd = "bg-gray-100 cursor-not-allowed dark:bg-gray-600 dark:text-gray-400", Vd = "text-white bg-blue-700 dark:bg-gray-800 hover:text-white hover:bg-blue-700 hover:dark:bg-gray-800";
function Hd(e) {
  return {
    itemClasses: f(() => q([
      Rd,
      e.disabled.value ? jd : "",
      !e.disabled.value && e.hover.value ? Dd : "",
      !e.disabled.value && e.active.value ? Vd : ""
    ]))
  };
}
const Wd = {
  key: 0,
  class: "mr-2"
}, Gd = {
  key: 1,
  class: "ml-2"
}, ug = /* @__PURE__ */ A({
  __name: "FwbListGroupItem",
  props: {
    hover: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { itemClasses: r } = Hd(ue(t));
    return (s, o) => (g(), v("li", {
      class: x(y(r))
    }, [
      s.$slots.prefix ? (g(), v("div", Wd, [
        C(s.$slots, "prefix")
      ])) : O("", !0),
      C(s.$slots, "default"),
      s.$slots.suffix ? (g(), v("div", Gd, [
        C(s.$slots, "suffix")
      ])) : O("", !0)
    ], 2));
  }
});
function qd(e) {
  return Ys() ? (Js(e), !0) : !1;
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Kd = (e) => e != null;
function Ud(e) {
  return Array.isArray(e) ? e : [e];
}
function Yd(e) {
  var t;
  const r = de(e);
  return (t = r?.$el) != null ? t : r;
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Fo = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Jt = /* @__PURE__ */ Fo.join(","), zo = typeof Element > "u", Je = zo ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Xt = !zo && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, Zt = function e(t, r) {
  var s;
  r === void 0 && (r = !0);
  var o = t == null || (s = t.getAttribute) === null || s === void 0 ? void 0 : s.call(t, "inert"), a = o === "" || o === "true", n = a || r && t && e(t.parentNode);
  return n;
}, Jd = function(t) {
  var r, s = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "contenteditable");
  return s === "" || s === "true";
}, Io = function(t, r, s) {
  if (Zt(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Jt));
  return r && Je.call(t, Jt) && o.unshift(t), o = o.filter(s), o;
}, Bo = function e(t, r, s) {
  for (var o = [], a = Array.from(t); a.length; ) {
    var n = a.shift();
    if (!Zt(n, !1))
      if (n.tagName === "SLOT") {
        var l = n.assignedElements(), i = l.length ? l : n.children, d = e(i, !0, s);
        s.flatten ? o.push.apply(o, d) : o.push({
          scopeParent: n,
          candidates: d
        });
      } else {
        var u = Je.call(n, Jt);
        u && s.filter(n) && (r || !t.includes(n)) && o.push(n);
        var h = n.shadowRoot || // check for an undisclosed shadow
        typeof s.getShadowRoot == "function" && s.getShadowRoot(n), m = !Zt(h, !1) && (!s.shadowRootFilter || s.shadowRootFilter(n));
        if (h && m) {
          var c = e(h === !0 ? n.children : h.children, !0, s);
          s.flatten ? o.push.apply(o, c) : o.push({
            scopeParent: n,
            candidates: c
          });
        } else
          a.unshift.apply(a, n.children);
      }
  }
  return o;
}, Eo = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, We = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Jd(t)) && !Eo(t) ? 0 : t.tabIndex;
}, Xd = function(t, r) {
  var s = We(t);
  return s < 0 && r && !Eo(t) ? 0 : s;
}, Zd = function(t, r) {
  return t.tabIndex === r.tabIndex ? t.documentOrder - r.documentOrder : t.tabIndex - r.tabIndex;
}, Oo = function(t) {
  return t.tagName === "INPUT";
}, Qd = function(t) {
  return Oo(t) && t.type === "hidden";
}, eu = function(t) {
  var r = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(s) {
    return s.tagName === "SUMMARY";
  });
  return r;
}, tu = function(t, r) {
  for (var s = 0; s < t.length; s++)
    if (t[s].checked && t[s].form === r)
      return t[s];
}, ru = function(t) {
  if (!t.name)
    return !0;
  var r = t.form || Xt(t), s = function(l) {
    return r.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = s(window.CSS.escape(t.name));
  else
    try {
      o = s(t.name);
    } catch (n) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", n.message), !1;
    }
  var a = tu(o, t.form);
  return !a || a === t;
}, su = function(t) {
  return Oo(t) && t.type === "radio";
}, ou = function(t) {
  return su(t) && !ru(t);
}, au = function(t) {
  var r, s = t && Xt(t), o = (r = s) === null || r === void 0 ? void 0 : r.host, a = !1;
  if (s && s !== t) {
    var n, l, i;
    for (a = !!((n = o) !== null && n !== void 0 && (l = n.ownerDocument) !== null && l !== void 0 && l.contains(o) || t != null && (i = t.ownerDocument) !== null && i !== void 0 && i.contains(t)); !a && o; ) {
      var d, u, h;
      s = Xt(o), o = (d = s) === null || d === void 0 ? void 0 : d.host, a = !!((u = o) !== null && u !== void 0 && (h = u.ownerDocument) !== null && h !== void 0 && h.contains(o));
    }
  }
  return a;
}, vs = function(t) {
  var r = t.getBoundingClientRect(), s = r.width, o = r.height;
  return s === 0 && o === 0;
}, nu = function(t, r) {
  var s = r.displayCheck, o = r.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = Je.call(t, "details>summary:first-of-type"), n = a ? t.parentElement : t;
  if (Je.call(n, "details:not([open]) *"))
    return !0;
  if (!s || s === "full" || s === "legacy-full") {
    if (typeof o == "function") {
      for (var l = t; t; ) {
        var i = t.parentElement, d = Xt(t);
        if (i && !i.shadowRoot && o(i) === !0)
          return vs(t);
        t.assignedSlot ? t = t.assignedSlot : !i && d !== t.ownerDocument ? t = d.host : t = i;
      }
      t = l;
    }
    if (au(t))
      return !t.getClientRects().length;
    if (s !== "legacy-full")
      return !0;
  } else if (s === "non-zero-area")
    return vs(t);
  return !1;
}, lu = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var r = t.parentElement; r; ) {
      if (r.tagName === "FIELDSET" && r.disabled) {
        for (var s = 0; s < r.children.length; s++) {
          var o = r.children.item(s);
          if (o.tagName === "LEGEND")
            return Je.call(r, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      r = r.parentElement;
    }
  return !1;
}, Qt = function(t, r) {
  return !(r.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Zt(r) || Qd(r) || nu(r, t) || // For a details element with a summary, the summary element gets the focus
  eu(r) || lu(r));
}, Pr = function(t, r) {
  return !(ou(r) || We(r) < 0 || !Qt(t, r));
}, iu = function(t) {
  var r = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(r) || r >= 0);
}, du = function e(t) {
  var r = [], s = [];
  return t.forEach(function(o, a) {
    var n = !!o.scopeParent, l = n ? o.scopeParent : o, i = Xd(l, n), d = n ? e(o.candidates) : l;
    i === 0 ? n ? r.push.apply(r, d) : r.push(l) : s.push({
      documentOrder: a,
      tabIndex: i,
      item: o,
      isScope: n,
      content: d
    });
  }), s.sort(Zd).reduce(function(o, a) {
    return a.isScope ? o.push.apply(o, a.content) : o.push(a.content), o;
  }, []).concat(r);
}, uu = function(t, r) {
  r = r || {};
  var s;
  return r.getShadowRoot ? s = Bo([t], r.includeContainer, {
    filter: Pr.bind(null, r),
    flatten: !1,
    getShadowRoot: r.getShadowRoot,
    shadowRootFilter: iu
  }) : s = Io(t, r.includeContainer, Pr.bind(null, r)), du(s);
}, cu = function(t, r) {
  r = r || {};
  var s;
  return r.getShadowRoot ? s = Bo([t], r.includeContainer, {
    filter: Qt.bind(null, r),
    flatten: !0,
    getShadowRoot: r.getShadowRoot
  }) : s = Io(t, r.includeContainer, Qt.bind(null, r)), s;
}, ot = function(t, r) {
  if (r = r || {}, !t)
    throw new Error("No node provided");
  return Je.call(t, Jt) === !1 ? !1 : Pr(r, t);
}, fu = /* @__PURE__ */ Fo.concat("iframe").join(","), xr = function(t, r) {
  if (r = r || {}, !t)
    throw new Error("No node provided");
  return Je.call(t, fu) === !1 ? !1 : Qt(r, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Ar(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, s = Array(t); r < t; r++) s[r] = e[r];
  return s;
}
function pu(e) {
  if (Array.isArray(e)) return Ar(e);
}
function gu(e, t, r) {
  return (t = yu(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function hu(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function mu() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ys(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    t && (s = s.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, s);
  }
  return r;
}
function ws(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ys(Object(r), !0).forEach(function(s) {
      gu(e, s, r[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ys(Object(r)).forEach(function(s) {
      Object.defineProperty(e, s, Object.getOwnPropertyDescriptor(r, s));
    });
  }
  return e;
}
function bu(e) {
  return pu(e) || hu(e) || wu(e) || mu();
}
function vu(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var s = r.call(e, t);
    if (typeof s != "object") return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function yu(e) {
  var t = vu(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function wu(e, t) {
  if (e) {
    if (typeof e == "string") return Ar(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ar(e, t) : void 0;
  }
}
var ks = {
  activateTrap: function(t, r) {
    if (t.length > 0) {
      var s = t[t.length - 1];
      s !== r && s._setPausedState(!0);
    }
    var o = t.indexOf(r);
    o === -1 || t.splice(o, 1), t.push(r);
  },
  deactivateTrap: function(t, r) {
    var s = t.indexOf(r);
    s !== -1 && t.splice(s, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, ku = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, xu = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, kt = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Cu = function(t) {
  return kt(t) && !t.shiftKey;
}, $u = function(t) {
  return kt(t) && t.shiftKey;
}, xs = function(t) {
  return setTimeout(t, 0);
}, bt = function(t) {
  for (var r = arguments.length, s = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
    s[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, s) : t;
}, jt = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, _u = [], Su = function(t, r) {
  var s = r?.document || document, o = r?.trapStack || _u, a = ws({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Cu,
    isKeyBackward: $u
  }, r), n = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, l, i = function(w, $, E) {
    return w && w[$] !== void 0 ? w[$] : a[E || $];
  }, d = function(w, $) {
    var E = typeof $?.composedPath == "function" ? $.composedPath() : void 0;
    return n.containerGroups.findIndex(function(N) {
      var L = N.container, P = N.tabbableNodes;
      return L.contains(w) || E?.includes(L) || P.find(function(j) {
        return j === w;
      });
    });
  }, u = function(w) {
    var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = $.hasFallback, N = E === void 0 ? !1 : E, L = $.params, P = L === void 0 ? [] : L, j = a[w];
    if (typeof j == "function" && (j = j.apply(void 0, bu(P))), j === !0 && (j = void 0), !j) {
      if (j === void 0 || j === !1)
        return j;
      throw new Error("`".concat(w, "` was specified but was not a node, or did not return a node"));
    }
    var Q = j;
    if (typeof j == "string") {
      try {
        Q = s.querySelector(j);
      } catch (oe) {
        throw new Error("`".concat(w, '` appears to be an invalid selector; error="').concat(oe.message, '"'));
      }
      if (!Q && !N)
        throw new Error("`".concat(w, "` as selector refers to no known node"));
    }
    return Q;
  }, h = function() {
    var w = u("initialFocus", {
      hasFallback: !0
    });
    if (w === !1)
      return !1;
    if (w === void 0 || w && !xr(w, a.tabbableOptions))
      if (d(s.activeElement) >= 0)
        w = s.activeElement;
      else {
        var $ = n.tabbableGroups[0], E = $ && $.firstTabbableNode;
        w = E || u("fallbackFocus");
      }
    else w === null && (w = u("fallbackFocus"));
    if (!w)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return w;
  }, m = function() {
    if (n.containerGroups = n.containers.map(function(w) {
      var $ = uu(w, a.tabbableOptions), E = cu(w, a.tabbableOptions), N = $.length > 0 ? $[0] : void 0, L = $.length > 0 ? $[$.length - 1] : void 0, P = E.find(function(oe) {
        return ot(oe);
      }), j = E.slice().reverse().find(function(oe) {
        return ot(oe);
      }), Q = !!$.find(function(oe) {
        return We(oe) > 0;
      });
      return {
        container: w,
        tabbableNodes: $,
        focusableNodes: E,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: Q,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: N,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: L,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: P,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: j,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(be) {
          var ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, re = $.indexOf(be);
          return re < 0 ? ae ? E.slice(E.indexOf(be) + 1).find(function(we) {
            return ot(we);
          }) : E.slice(0, E.indexOf(be)).reverse().find(function(we) {
            return ot(we);
          }) : $[re + (ae ? 1 : -1)];
        }
      };
    }), n.tabbableGroups = n.containerGroups.filter(function(w) {
      return w.tabbableNodes.length > 0;
    }), n.tabbableGroups.length <= 0 && !u("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (n.containerGroups.find(function(w) {
      return w.posTabIndexesFound;
    }) && n.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, c = function(w) {
    var $ = w.activeElement;
    if ($)
      return $.shadowRoot && $.shadowRoot.activeElement !== null ? c($.shadowRoot) : $;
  }, p = function(w) {
    if (w !== !1 && w !== c(document)) {
      if (!w || !w.focus) {
        p(h());
        return;
      }
      w.focus({
        preventScroll: !!a.preventScroll
      }), n.mostRecentlyFocusedNode = w, ku(w) && w.select();
    }
  }, _ = function(w) {
    var $ = u("setReturnFocus", {
      params: [w]
    });
    return $ || ($ === !1 ? !1 : w);
  }, k = function(w) {
    var $ = w.target, E = w.event, N = w.isBackward, L = N === void 0 ? !1 : N;
    $ = $ || jt(E), m();
    var P = null;
    if (n.tabbableGroups.length > 0) {
      var j = d($, E), Q = j >= 0 ? n.containerGroups[j] : void 0;
      if (j < 0)
        L ? P = n.tabbableGroups[n.tabbableGroups.length - 1].lastTabbableNode : P = n.tabbableGroups[0].firstTabbableNode;
      else if (L) {
        var oe = n.tabbableGroups.findIndex(function(se) {
          var tt = se.firstTabbableNode;
          return $ === tt;
        });
        if (oe < 0 && (Q.container === $ || xr($, a.tabbableOptions) && !ot($, a.tabbableOptions) && !Q.nextTabbableNode($, !1)) && (oe = j), oe >= 0) {
          var be = oe === 0 ? n.tabbableGroups.length - 1 : oe - 1, ae = n.tabbableGroups[be];
          P = We($) >= 0 ? ae.lastTabbableNode : ae.lastDomTabbableNode;
        } else kt(E) || (P = Q.nextTabbableNode($, !1));
      } else {
        var re = n.tabbableGroups.findIndex(function(se) {
          var tt = se.lastTabbableNode;
          return $ === tt;
        });
        if (re < 0 && (Q.container === $ || xr($, a.tabbableOptions) && !ot($, a.tabbableOptions) && !Q.nextTabbableNode($)) && (re = j), re >= 0) {
          var we = re === n.tabbableGroups.length - 1 ? 0 : re + 1, pt = n.tabbableGroups[we];
          P = We($) >= 0 ? pt.firstTabbableNode : pt.firstDomTabbableNode;
        } else kt(E) || (P = Q.nextTabbableNode($));
      }
    } else
      P = u("fallbackFocus");
    return P;
  }, T = function(w) {
    var $ = jt(w);
    if (!(d($, w) >= 0)) {
      if (bt(a.clickOutsideDeactivates, w)) {
        l.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      bt(a.allowOutsideClick, w) || w.preventDefault();
    }
  }, B = function(w) {
    var $ = jt(w), E = d($, w) >= 0;
    if (E || $ instanceof Document)
      E && (n.mostRecentlyFocusedNode = $);
    else {
      w.stopImmediatePropagation();
      var N, L = !0;
      if (n.mostRecentlyFocusedNode)
        if (We(n.mostRecentlyFocusedNode) > 0) {
          var P = d(n.mostRecentlyFocusedNode), j = n.containerGroups[P].tabbableNodes;
          if (j.length > 0) {
            var Q = j.findIndex(function(oe) {
              return oe === n.mostRecentlyFocusedNode;
            });
            Q >= 0 && (a.isKeyForward(n.recentNavEvent) ? Q + 1 < j.length && (N = j[Q + 1], L = !1) : Q - 1 >= 0 && (N = j[Q - 1], L = !1));
          }
        } else
          n.containerGroups.some(function(oe) {
            return oe.tabbableNodes.some(function(be) {
              return We(be) > 0;
            });
          }) || (L = !1);
      else
        L = !1;
      L && (N = k({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: n.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(n.recentNavEvent)
      })), p(N || n.mostRecentlyFocusedNode || h());
    }
    n.recentNavEvent = void 0;
  }, M = function(w) {
    var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    n.recentNavEvent = w;
    var E = k({
      event: w,
      isBackward: $
    });
    E && (kt(w) && w.preventDefault(), p(E));
  }, H = function(w) {
    (a.isKeyForward(w) || a.isKeyBackward(w)) && M(w, a.isKeyBackward(w));
  }, S = function(w) {
    xu(w) && bt(a.escapeDeactivates, w) !== !1 && (w.preventDefault(), l.deactivate());
  }, D = function(w) {
    var $ = jt(w);
    d($, w) >= 0 || bt(a.clickOutsideDeactivates, w) || bt(a.allowOutsideClick, w) || (w.preventDefault(), w.stopImmediatePropagation());
  }, R = function() {
    if (n.active)
      return ks.activateTrap(o, l), n.delayInitialFocusTimer = a.delayInitialFocus ? xs(function() {
        p(h());
      }) : p(h()), s.addEventListener("focusin", B, !0), s.addEventListener("mousedown", T, {
        capture: !0,
        passive: !1
      }), s.addEventListener("touchstart", T, {
        capture: !0,
        passive: !1
      }), s.addEventListener("click", D, {
        capture: !0,
        passive: !1
      }), s.addEventListener("keydown", H, {
        capture: !0,
        passive: !1
      }), s.addEventListener("keydown", S), l;
  }, F = function() {
    if (n.active)
      return s.removeEventListener("focusin", B, !0), s.removeEventListener("mousedown", T, !0), s.removeEventListener("touchstart", T, !0), s.removeEventListener("click", D, !0), s.removeEventListener("keydown", H, !0), s.removeEventListener("keydown", S), l;
  }, U = function(w) {
    var $ = w.some(function(E) {
      var N = Array.from(E.removedNodes);
      return N.some(function(L) {
        return L === n.mostRecentlyFocusedNode;
      });
    });
    $ && p(h());
  }, Y = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(U) : void 0, ee = function() {
    Y && (Y.disconnect(), n.active && !n.paused && n.containers.map(function(w) {
      Y.observe(w, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return l = {
    get active() {
      return n.active;
    },
    get paused() {
      return n.paused;
    },
    activate: function(w) {
      if (n.active)
        return this;
      var $ = i(w, "onActivate"), E = i(w, "onPostActivate"), N = i(w, "checkCanFocusTrap");
      N || m(), n.active = !0, n.paused = !1, n.nodeFocusedBeforeActivation = s.activeElement, $?.();
      var L = function() {
        N && m(), R(), ee(), E?.();
      };
      return N ? (N(n.containers.concat()).then(L, L), this) : (L(), this);
    },
    deactivate: function(w) {
      if (!n.active)
        return this;
      var $ = ws({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, w);
      clearTimeout(n.delayInitialFocusTimer), n.delayInitialFocusTimer = void 0, F(), n.active = !1, n.paused = !1, ee(), ks.deactivateTrap(o, l);
      var E = i($, "onDeactivate"), N = i($, "onPostDeactivate"), L = i($, "checkCanReturnFocus"), P = i($, "returnFocus", "returnFocusOnDeactivate");
      E?.();
      var j = function() {
        xs(function() {
          P && p(_(n.nodeFocusedBeforeActivation)), N?.();
        });
      };
      return P && L ? (L(_(n.nodeFocusedBeforeActivation)).then(j, j), this) : (j(), this);
    },
    pause: function(w) {
      return n.active ? (n.manuallyPaused = !0, this._setPausedState(!0, w)) : this;
    },
    unpause: function(w) {
      return n.active ? (n.manuallyPaused = !1, o[o.length - 1] !== this ? this : this._setPausedState(!1, w)) : this;
    },
    updateContainerElements: function(w) {
      var $ = [].concat(w).filter(Boolean);
      return n.containers = $.map(function(E) {
        return typeof E == "string" ? s.querySelector(E) : E;
      }), n.active && m(), ee(), this;
    }
  }, Object.defineProperties(l, {
    _isManuallyPaused: {
      value: function() {
        return n.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(w, $) {
        if (n.paused === w)
          return this;
        if (n.paused = w, w) {
          var E = i($, "onPause"), N = i($, "onPostPause");
          E?.(), F(), ee(), N?.();
        } else {
          var L = i($, "onUnpause"), P = i($, "onPostUnpause");
          L?.(), m(), R(), ee(), P?.();
        }
        return this;
      }
    }
  }), l.updateContainerElements(t), l;
};
function Tu(e, t = {}) {
  let r;
  const { immediate: s, ...o } = t, a = Se(!1), n = Se(!1), l = (m) => r && r.activate(m), i = (m) => r && r.deactivate(m), d = () => {
    r && (r.pause(), n.value = !0);
  }, u = () => {
    r && (r.unpause(), n.value = !1);
  }, h = f(() => {
    const m = de(e);
    return Ud(m).map((c) => {
      const p = de(c);
      return typeof p == "string" ? p : Yd(p);
    }).filter(Kd);
  });
  return Me(
    h,
    (m) => {
      m.length && (r = Su(m, {
        ...o,
        onActivate() {
          a.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          a.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), s && l());
    },
    { flush: "post" }
  ), qd(() => i()), {
    hasFocus: a,
    isPaused: n,
    activate: l,
    deactivate: i,
    pause: d,
    unpause: u
  };
}
const Pu = { class: "relative rounded-lg bg-white shadow-sm dark:bg-gray-700" }, Au = {
  key: 0,
  class: "rounded-b border-t border-gray-200 p-6 dark:border-gray-600"
}, cg = /* @__PURE__ */ A({
  __name: "FwbModal",
  props: {
    notEscapable: { type: Boolean, default: !1 },
    persistent: { type: Boolean, default: !1 },
    size: { default: "2xl" },
    position: { default: "center" },
    focusTrap: { type: Boolean, default: !1 }
  },
  emits: ["close", "click:outside"],
  setup(e, { emit: t }) {
    const r = e, s = t, o = {
      xs: "max-w-xs",
      sm: "max-w-sm",
      md: "max-w-md",
      lg: "max-w-lg",
      xl: "max-w-xl",
      "2xl": "max-w-2xl",
      "3xl": "max-w-3xl",
      "4xl": "max-w-4xl",
      "5xl": "max-w-5xl",
      "6xl": "max-w-6xl",
      "7xl": "max-w-7xl"
    }, a = {
      "top-start": "self-start justify-self-start",
      "top-center": "self-start justify-self-center",
      "top-end": "self-start justify-self-end",
      "center-start": "self-center justify-self-start",
      center: "self-center justify-self-center",
      "center-end": "self-center justify-self-end",
      "bottom-start": "self-end justify-self-start",
      "bottom-center": "self-end justify-self-center",
      "bottom-end": "self-end justify-self-end"
    };
    function n() {
      s("close");
    }
    function l() {
      r.persistent || (s("click:outside"), n());
    }
    function i() {
      !r.notEscapable && !r.persistent && n();
    }
    const d = Z(null), { activate: u, deactivate: h } = Tu(d, {
      immediate: !1,
      initialFocus: () => d.value?.querySelector('button[aria-label="close"]') || d.value
    });
    return Ze(async () => {
      d.value && r.focusTrap && (await zt(), u());
    }), Us(() => {
      h();
    }), (m, c) => (g(), v("div", null, [
      c[1] || (c[1] = b("div", { class: "fixed inset-0 z-40 bg-gray-900/50 dark:bg-gray-900/80" }, null, -1)),
      b("div", {
        ref_key: "modalRef",
        ref: d,
        class: "fixed inset-x-0 top-0 z-50 grid h-modal w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
        tabindex: "0",
        onClick: Wt(l, ["self"]),
        onKeyup: eo(i, ["esc"])
      }, [
        b("div", {
          class: x([`${o[m.size]} ${a[m.position]}`, "relative w-full p-4"])
        }, [
          b("div", Pu, [
            b("div", {
              class: x([m.$slots.header ? "border-b border-gray-200 dark:border-gray-600" : "", "flex items-center justify-between rounded-t p-4"])
            }, [
              C(m.$slots, "header"),
              m.persistent ? O("", !0) : (g(), v("button", {
                key: 0,
                "aria-label": "close",
                class: "ms-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white",
                type: "button",
                onClick: n
              }, [
                C(m.$slots, "close-icon", {}, () => [
                  c[0] || (c[0] = b("svg", {
                    class: "size-5",
                    fill: "currentColor",
                    viewBox: "0 0 20 20",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    b("path", {
                      "clip-rule": "evenodd",
                      d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                      "fill-rule": "evenodd"
                    })
                  ], -1))
                ])
              ]))
            ], 2),
            b("div", {
              class: x([m.$slots.header ? "" : "pt-0", "p-6"])
            }, [
              C(m.$slots, "body")
            ], 2),
            m.$slots.footer ? (g(), v("div", Au, [
              C(m.$slots, "footer")
            ])) : O("", !0)
          ])
        ], 2)
      ], 544)
    ]));
  }
}), Fu = { class: "container mx-auto flex flex-wrap items-center justify-between" }, zu = {
  key: 0,
  class: "hidden md:order-2 md:flex"
}, Iu = " border-gray-200", Bu = "fixed w-full z-20 top-0 left-0 border-b border-gray-200 dark:border-gray-600", Eu = "rounded", Ou = "p-3 bg-gray-50 dark:bg-gray-800 dark:border-gray-700", Mu = "bg-white px-2 sm:px-4 py-2.5 dark:bg-gray-900", fg = /* @__PURE__ */ A({
  __name: "FwbNavbar",
  props: {
    class: {
      type: String,
      default: ""
    },
    sticky: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    solid: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, r = it(), o = Co(xo).smaller("md"), a = Z(!1), n = Sl(a), l = f(() => q(
      [
        Iu,
        t.sticky ? Bu : "",
        t.rounded ? Eu : "",
        t.solid ? Ou : Mu,
        t.class
      ].join(" ")
    )), i = f(
      () => o ? a.value : !0
    );
    return (d, u) => (g(), v("nav", {
      class: x(l.value)
    }, [
      b("div", Fu, [
        C(d.$slots, "logo"),
        b("button", {
          "aria-controls": "navbar-default",
          "aria-expanded": "false",
          class: "ml-3 inline-flex items-center rounded-lg p-2 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 md:hidden",
          type: "button",
          onClick: u[0] || (u[0] = (h) => y(n)())
        }, [
          u[2] || (u[2] = b("span", { class: "sr-only" }, "Open main menu", -1)),
          C(d.$slots, "menu-icon", {}, () => [
            u[1] || (u[1] = b("svg", {
              "aria-hidden": "true",
              class: "size-6",
              fill: "currentColor",
              viewBox: "0 0 20 20",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              b("path", {
                "clip-rule": "evenodd",
                d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                "fill-rule": "evenodd"
              })
            ], -1))
          ])
        ]),
        C(d.$slots, "default", { isShowMenu: i.value }),
        y(r)["right-side"] ? (g(), v("div", zu, [
          C(d.$slots, "right-side")
        ])) : O("", !0)
      ])
    ], 2));
  }
}), Nu = "w-full md:block md:w-auto", Lu = "flex flex-col p-4 mt-4 rounded-lg border border-gray-100 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700", Ru = "bg-gray-50", pg = /* @__PURE__ */ A({
  __name: "FwbNavbarCollapse",
  props: {
    isShowMenu: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const r = Co(xo).smaller("md"), s = e, o = f(() => ne(
      Nu,
      s.isShowMenu ? "" : "hidden"
    )), a = f(() => ne(
      Lu,
      r.value ? Ru : ""
    ));
    return (n, l) => (g(), v("div", {
      class: x(o.value)
    }, [
      b("ul", {
        class: x(a.value)
      }, [
        C(n.$slots, "default")
      ], 2)
    ], 2));
  }
}), Du = "bg-blue-700 md:bg-transparent text-white md:text-blue-700 dark:text-white", ju = "text-gray-700 hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent", Vu = "block py-2 pr-4 pl-3 rounded md:p-0", gg = /* @__PURE__ */ A({
  __name: "FwbNavbarLink",
  props: {
    link: { default: "/" },
    isActive: { type: Boolean, default: !1 },
    component: { default: "a" },
    linkAttr: { default: "href" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const r = e, s = t, o = f(() => r.component !== "a" ? Te(r.component) : "a"), a = J(
      Vu,
      r.isActive ? Du : ju
    ), n = (l) => {
      r.disabled || s("click", l);
    };
    return (l, i) => (g(), v("li", null, [
      (g(), te(ge(o.value), Re({
        [l.linkAttr || ""]: l.link,
        class: y(a),
        onClick: n
      }), {
        default: X(() => [
          C(l.$slots, "default")
        ]),
        _: 3
      }, 16, ["class"]))
    ]));
  }
}), Hu = ["src", "alt"], Wu = { class: "self-center whitespace-nowrap text-xl font-semibold dark:text-white" }, hg = /* @__PURE__ */ A({
  __name: "FwbNavbarLogo",
  props: {
    link: { default: "/" },
    imageUrl: { default: "/assets/logo.svg" },
    alt: { default: "Logo" },
    component: { default: "a" },
    linkAttr: { default: "href" }
  },
  setup(e) {
    const t = e, r = f(() => t.component !== "a" ? Te(t.component) : "a");
    return (s, o) => (g(), te(ge(r.value), Re({
      class: "flex items-center",
      [s.linkAttr || ""]: s.link
    }), {
      default: X(() => [
        b("img", {
          src: s.imageUrl,
          alt: s.alt,
          class: "mr-3 h-6 sm:h-10"
        }, null, 8, Hu),
        b("span", Wu, [
          C(s.$slots, "default")
        ])
      ]),
      _: 3
    }, 16));
  }
}), Gu = { "aria-label": "Navigation" }, qu = { class: "font-semibold text-gray-900 dark:text-white" }, Ku = { class: "font-semibold text-gray-900 dark:text-white" }, Uu = { class: "font-semibold text-gray-900 dark:text-white" }, Yu = ["disabled"], Ju = ["disabled"], Xu = {
  key: 0,
  stroke: "currentColor",
  fill: "currentColor",
  "stroke-width": "0",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  class: "size-5",
  height: "1em",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, Zu = ["disabled", "onClick"], Qu = ["disabled"], ec = {
  key: 0,
  stroke: "currentColor",
  fill: "currentColor",
  "stroke-width": "0",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  class: "size-5",
  height: "1em",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, tc = ["disabled"], rc = "flex h-8 items-center justify-center border border-r-0 border-gray-300 bg-white px-3 text-sm leading-tight text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white", sc = "ml-0 flex h-8 items-center justify-center gap-1 border border-gray-300 bg-white px-3 leading-tight text-gray-500 first:rounded-l-lg last:rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white", oc = "rounded-none border-none bg-gray-800 text-white first:rounded-l last:rounded-r hover:bg-gray-900 hover:text-white dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white", ac = "bg-blue-50 text-blue-600 hover:bg-blue-100 hover:text-blue-700 dark:bg-gray-700 dark:text-white", nc = "disabled:cursor-not-allowed disabled:opacity-50", Cs = "h-10 px-4", mg = /* @__PURE__ */ A({
  __name: "FwbPagination",
  props: {
    modelValue: { default: 1 },
    totalPages: { default: void 0 },
    perPage: { default: 10 },
    totalItems: { default: 10 },
    layout: { default: "pagination" },
    showIcons: { type: Boolean, default: !1 },
    sliceLength: { default: 2 },
    previousLabel: { default: "Prev" },
    nextLabel: { default: "Next" },
    firstLabel: { default: "First" },
    lastLabel: { default: "Last" },
    enableFirstLast: { type: Boolean, default: !1 },
    hideLabels: { type: Boolean, default: !1 },
    large: { type: Boolean, default: !1 }
  },
  emits: ["update:model-value", "page-changed"],
  setup(e, { emit: t }) {
    const r = t, s = e;
    function o(S) {
      r("update:model-value", S), r("page-changed", S);
    }
    function a() {
      r("update:model-value", s.modelValue - 1), r("page-changed", s.modelValue - 1);
    }
    function n() {
      r("update:model-value", s.modelValue + 1), r("page-changed", s.modelValue + 1);
    }
    function l() {
      r("update:model-value", 1), r("page-changed", 1);
    }
    function i() {
      const S = d.value;
      r("update:model-value", S), r("page-changed", S);
    }
    const d = f(() => s.totalPages ? s.totalPages : Math.ceil(s.totalItems / s.perPage)), u = f(() => s.modelValue <= 1), h = f(() => s.modelValue >= d.value), m = (S) => S === s.modelValue, c = f(() => {
      if (s.layout === "navigation") return [];
      if (s.layout === "table") return [];
      if (d.value <= s.sliceLength * 2 + 1) {
        const R = [];
        for (let F = 1; F <= d.value; F++)
          R.push(F);
        return R;
      }
      if (s.modelValue <= s.sliceLength) {
        const R = [], F = Math.abs(s.modelValue - s.sliceLength) + s.modelValue + s.sliceLength + 1;
        for (let U = 1; U <= F; U++)
          R.push(U);
        return R;
      }
      if (s.modelValue >= d.value - s.sliceLength) {
        const R = [];
        for (let F = Math.abs(d.value - s.sliceLength * 2); F <= d.value; F++)
          R.push(F);
        return R;
      }
      const S = [], D = s.modelValue - s.sliceLength > 0 ? s.modelValue - s.sliceLength : 1;
      for (let R = D; R < s.modelValue + s.sliceLength + 1 && !(R >= d.value); R++)
        S.push(R);
      return S;
    }), p = f(() => s.modelValue * s.perPage - s.perPage + 1), _ = f(() => {
      const S = s.modelValue * s.perPage;
      return s.totalItems && S > s.totalItems ? s.totalItems : S;
    }), k = f(() => s.totalItems ? s.totalItems : d.value * s.perPage), T = f(() => s.modelValue === 1), B = f(() => s.modelValue === d.value), M = (S) => q(
      [
        rc,
        S ? ac : "",
        s.large ? Cs : ""
      ]
    ), H = (S) => q(
      [
        sc,
        s.layout === "table" ? oc : "",
        s.layout === "navigation" ? "[&:not(:last-child)]:mr-3 rounded-lg" : "[&:not(:last-child)]:border-r-0",
        S === s.modelValue || S > d.value || S < 1 ? nc : "",
        s.large ? Cs : ""
      ]
    );
    return (S, D) => (g(), v("nav", Gu, [
      S.layout === "table" ? (g(), v("div", {
        key: 0,
        class: x(["mb-2 text-gray-700 dark:text-gray-400", S.large ? "text-base" : "text-sm"])
      }, [
        D[0] || (D[0] = ce(" Showing ")),
        b("span", qu, G(p.value), 1),
        D[1] || (D[1] = ce(" to ")),
        b("span", Ku, G(_.value), 1),
        D[2] || (D[2] = ce(" of ")),
        b("span", Uu, G(k.value), 1)
      ], 2)) : O("", !0),
      b("div", {
        class: x(["inline-flex", S.large && "text-base h-10"])
      }, [
        C(S.$slots, "start"),
        S.enableFirstLast ? C(S.$slots, "first-button", { key: 0 }, () => [
          b("button", {
            disabled: T.value,
            class: x(H(1)),
            onClick: l
          }, [
            C(S.$slots, "first-icon", {}, () => [
              D[3] || (D[3] = b("svg", {
                stroke: "currentColor",
                fill: "none",
                "stroke-width": "0",
                viewBox: "0 0 20 20",
                "aria-hidden": "true",
                class: "size-5",
                height: "1em",
                width: "1em",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                b("path", {
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "m17 14-4-4 4-4m-6 8-4-4 4-4"
                })
              ], -1))
            ]),
            S.hideLabels ? O("", !0) : (g(), v(ie, { key: 0 }, [
              ce(G(S.firstLabel), 1)
            ], 64))
          ], 10, Yu)
        ]) : O("", !0),
        C(S.$slots, "prev-button", {
          disabled: u.value,
          decreasePage: a
        }, () => [
          b("button", {
            disabled: u.value,
            class: x(H(S.modelValue - 1)),
            onClick: a
          }, [
            C(S.$slots, "prev-icon", {}, () => [
              S.showIcons || S.$slots["prev-icon"] ? (g(), v("svg", Xu, D[4] || (D[4] = [
                b("path", {
                  "fill-rule": "evenodd",
                  d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ]))) : O("", !0)
            ]),
            S.hideLabels ? O("", !0) : (g(), v(ie, { key: 0 }, [
              ce(G(S.previousLabel), 1)
            ], 64))
          ], 10, Ju)
        ]),
        (g(!0), v(ie, null, Ue(c.value, (R) => C(S.$slots, "page-button", {
          key: R,
          page: R,
          setPage: o,
          disabled: m(R)
        }, () => [
          b("button", {
            disabled: m(R),
            class: x(M(R === S.modelValue)),
            onClick: (F) => o(R)
          }, G(R), 11, Zu)
        ])), 128)),
        C(S.$slots, "next-button", {
          disabled: h.value,
          increasePage: n
        }, () => [
          b("button", {
            disabled: h.value,
            class: x(H(S.modelValue + 1)),
            onClick: n
          }, [
            S.hideLabels ? O("", !0) : (g(), v(ie, { key: 0 }, [
              ce(G(S.nextLabel), 1)
            ], 64)),
            C(S.$slots, "next-icon", {}, () => [
              S.showIcons || S.$slots["next-icon"] ? (g(), v("svg", ec, D[5] || (D[5] = [
                b("path", {
                  "fill-rule": "evenodd",
                  d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                  "clip-rule": "evenodd"
                }, null, -1)
              ]))) : O("", !0)
            ])
          ], 10, Qu)
        ]),
        S.enableFirstLast ? C(S.$slots, "last-button", { key: 1 }, () => [
          b("button", {
            disabled: B.value,
            class: x(H(d.value)),
            onClick: i
          }, [
            S.hideLabels ? O("", !0) : (g(), v(ie, { key: 0 }, [
              ce(G(S.lastLabel), 1)
            ], 64)),
            C(S.$slots, "last-icon", {}, () => [
              D[6] || (D[6] = b("svg", {
                stroke: "currentColor",
                fill: "none",
                "stroke-width": "0",
                viewBox: "0 0 20 20",
                "aria-hidden": "true",
                class: "size-5",
                height: "1em",
                width: "1em",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                b("path", {
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "m7 14 4-4-4-4m6 8 4-4-4-4"
                })
              ], -1))
            ])
          ], 10, tc)
        ]) : O("", !0),
        C(S.$slots, "end")
      ], 2)
    ]));
  }
}), lc = {
  default: "bg-blue-600 dark:bg-blue-600",
  blue: "bg-blue-600 dark:bg-blue-600",
  dark: "bg-gray-600 dark:bg-gray-300",
  green: "bg-green-600 dark:bg-green-500",
  red: "bg-red-600 dark:bg-red-500",
  yellow: "bg-yellow-400",
  indigo: "bg-indigo-600 dark:bg-indigo-500",
  purple: "bg-purple-600 dark:bg-purple-500"
}, ic = {
  default: "",
  blue: "text-blue-700 dark:text-blue-500",
  dark: "dark:text-white",
  green: "text-green-700 dark:text-green-500",
  red: "text-red-700 dark:text-red-500",
  yellow: "text-yellow-700 dark:text-yellow-500",
  indigo: "text-indigo-700 dark:text-indigo-500",
  purple: "text-purple-700 dark:text-purple-500"
}, $s = {
  sm: "h-1.5 text-xs leading-none",
  md: "h-2.5 text-xs leading-none",
  lg: "h-4 text-sm leading-none",
  xl: "h-6 text-base leading-tight"
};
function dc(e) {
  const t = f(() => ne(
    lc[e.color.value],
    $s[e.size.value]
  )), r = f(() => ne(
    $s[e.size.value]
  )), s = f(() => ne(
    ic[e.color.value]
  ));
  return {
    innerClasses: t,
    outerClasses: r,
    outsideLabelClasses: s
  };
}
const uc = {
  key: 0,
  class: "mb-1 flex justify-between"
}, bg = /* @__PURE__ */ A({
  __name: "FwbProgress",
  props: {
    color: { default: "default" },
    label: { default: "" },
    labelPosition: { default: "none" },
    labelProgress: { type: Boolean, default: !1 },
    progress: { default: 0 },
    size: { default: "md" }
  },
  setup(e) {
    const t = e, {
      innerClasses: r,
      outerClasses: s,
      outsideLabelClasses: o
    } = dc(ue(t));
    return (a, n) => (g(), v("div", null, [
      a.label || a.labelProgress && a.labelPosition === "outside" ? (g(), v("div", uc, [
        b("span", {
          class: x([y(o), "text-base font-medium"])
        }, G(a.label), 3),
        a.labelProgress && a.labelPosition === "outside" ? (g(), v("span", {
          key: 0,
          class: x([y(o), "text-sm font-medium"])
        }, G(a.progress) + "%", 3)) : O("", !0)
      ])) : O("", !0),
      b("div", {
        class: x([y(s), "w-full rounded-full bg-gray-200 dark:bg-gray-700"])
      }, [
        b("div", {
          class: x([y(r), "rounded-full p-0.5 text-center font-medium text-blue-100"]),
          style: yt({ width: a.progress + "%" })
        }, [
          a.labelProgress && a.labelPosition === "inside" ? (g(), v(ie, { key: 0 }, [
            ce(G(a.progress) + "% ", 1)
          ], 64)) : O("", !0)
        ], 6)
      ], 2)
    ]));
  }
}), cc = {
  sm: "w-5 h-5",
  md: "w-7 h-7",
  lg: "w-10 h-10"
};
function fc(e) {
  return { sizeClasses: f(() => ne(
    cc[e.size.value] ?? ""
  )) };
}
const pc = { class: "flex items-center" }, gc = ["href"], vg = /* @__PURE__ */ A({
  __name: "FwbRating",
  props: {
    rating: { default: 3 },
    reviewLink: { default: "" },
    reviewText: { default: "" },
    scale: { default: 5 },
    size: { default: "md" }
  },
  setup(e) {
    const t = e, r = f(() => Math.floor(t.rating)), s = f(() => t.scale - r.value), { sizeClasses: o } = fc(ue(t));
    return (a, n) => (g(), v("div", pc, [
      (g(!0), v(ie, null, Ue(r.value, (l) => (g(), v("svg", {
        key: l,
        class: x([y(o), "text-yellow-400"]),
        fill: "currentColor",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
      }, n[0] || (n[0] = [
        b("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" }, null, -1)
      ]), 2))), 128)),
      (g(!0), v(ie, null, Ue(s.value, (l) => (g(), v("svg", {
        key: l,
        class: x([y(o), "text-gray-300 dark:text-gray-500"]),
        fill: "currentColor",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
      }, n[1] || (n[1] = [
        b("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" }, null, -1)
      ]), 2))), 128)),
      C(a.$slots, "besideText"),
      a.reviewText && a.reviewLink ? (g(), v(ie, { key: 0 }, [
        n[2] || (n[2] = b("span", { class: "mx-1.5 size-1 rounded-full bg-gray-500 dark:bg-gray-400" }, null, -1)),
        b("a", {
          href: a.reviewLink,
          class: "text-sm font-medium text-gray-900 underline hover:no-underline dark:text-white"
        }, G(a.reviewText), 9, gc)
      ], 64)) : O("", !0)
    ]));
  }
}), hc = { class: "h-full overflow-y-auto bg-gray-50 px-3 py-4 dark:bg-gray-800" }, mc = { class: "space-y-2 font-medium" }, yg = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbSidebar",
  setup(e) {
    const t = me(), r = J("absolute top-0 left-0 z-40 w-64 h-screen transition-transform", t.class);
    return (s, o) => (g(), v("aside", pe(s.$attrs, {
      class: y(r),
      "aria-label": "Sidebar"
    }), [
      b("div", hc, [
        b("div", mc, [
          C(s.$slots, "default")
        ])
      ])
    ], 16));
  }
}), bc = {
  class: "mt-6 rounded-lg bg-blue-50 p-4 dark:bg-blue-900",
  role: "alert"
}, vc = { class: "mb-3 flex items-center" }, yc = { class: "mr-2 rounded bg-orange-100 px-2.5 py-0.5 text-sm font-semibold text-orange-800 dark:bg-orange-200 dark:text-orange-900" }, wg = /* @__PURE__ */ A({
  __name: "FwbSidebarCta",
  props: {
    label: { default: void 0 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const r = t;
    function s() {
      r("close");
    }
    return (o, a) => (g(), v("div", bc, [
      b("div", vc, [
        b("span", yc, G(o.label), 1),
        b("button", {
          type: "button",
          class: "-m-1.5 ml-auto inline-flex size-6 items-center justify-center rounded-lg bg-blue-50 p-1 text-blue-900 hover:bg-blue-200 focus:ring-2 focus:ring-blue-400 dark:bg-blue-900 dark:text-blue-400 dark:hover:bg-blue-800",
          "aria-label": "Close",
          onClick: s
        }, a[0] || (a[0] = [
          b("span", { class: "sr-only" }, "Close", -1),
          b("svg", {
            class: "size-2.5",
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 14 14"
          }, [
            b("path", {
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            })
          ], -1)
        ]))
      ]),
      C(o.$slots, "default")
    ]));
  }
}), wc = { class: "overflow-hidden" }, kc = { class: "ml-3 flex-1 whitespace-nowrap text-left" }, xc = { class: "z-0 space-y-2 overflow-hidden py-2" }, Cc = { key: 0 }, kg = /* @__PURE__ */ A({
  __name: "FwbSidebarDropdownItem",
  setup(e, { expose: t }) {
    const r = Z(!1);
    function s() {
      r.value = !r.value;
    }
    return t({
      isOpen: r
    }), (o, a) => (g(), v("div", wc, [
      b("button", {
        type: "button",
        class: "group z-10 flex w-full items-center rounded-lg p-2 text-base text-gray-900 transition duration-75 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700",
        "aria-controls": "dropdown-content",
        onClick: s
      }, [
        C(o.$slots, "icon", {}, () => [
          a[0] || (a[0] = b("svg", {
            class: "size-5 shrink-0 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white",
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "currentColor",
            viewBox: "0 0 18 21"
          }, [
            b("path", { d: "M15 12a1 1 0 0 0 .962-.726l2-7A1 1 0 0 0 17 3H3.77L3.175.745A1 1 0 0 0 2.208 0H1a1 1 0 0 0 0 2h.438l.6 2.255v.019l2 7 .746 2.986A3 3 0 1 0 9 17a2.966 2.966 0 0 0-.184-1h2.368c-.118.32-.18.659-.184 1a3 3 0 1 0 3-3H6.78l-.5-2H15Z" })
          ], -1))
        ]),
        b("span", kc, [
          C(o.$slots, "trigger")
        ]),
        C(o.$slots, "arrow-icon", { toggleDropdown: s }, () => [
          (g(), v("svg", {
            class: x(["size-3 transition-all duration-300", r.value && "rotate-180"]),
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 10 6"
          }, a[1] || (a[1] = [
            b("path", {
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "m1 1 4 4 4-4"
            }, null, -1)
          ]), 2))
        ])
      ]),
      b("div", xc, [
        Ge(Qs, {
          duration: 150,
          "enter-from-class": "-translate-y-full",
          "enter-to-class": "translate-y-0",
          "enter-active-class": "transition duration-400 ease-out",
          "leave-active-class": "transition duration-400 ease-in",
          "leave-from-class": "translate-y-0",
          "leave-to-class": "-translate-y-full"
        }, {
          default: X(() => [
            r.value ? (g(), v("div", Cc, [
              C(o.$slots, "default")
            ])) : O("", !0)
          ]),
          _: 3
        })
      ])
    ]));
  }
}), xg = /* @__PURE__ */ A({
  __name: "FwbSidebarItem",
  props: {
    link: { default: "/" },
    tag: { default: "router-link" }
  },
  setup(e) {
    const t = e, r = t.tag === "a" ? "a" : Te(t.tag), s = t.tag === "a" ? "href" : "to";
    return (o, a) => (g(), te(ge(y(r)), Re({
      [y(s) || ""]: o.link,
      class: "group flex items-center rounded-lg p-2 text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
    }), {
      default: X(() => [
        C(o.$slots, "icon"),
        b("span", {
          class: x(["flex-1 whitespace-nowrap", o.$slots.icon && "ml-3"])
        }, [
          C(o.$slots, "default")
        ], 2),
        C(o.$slots, "suffix")
      ]),
      _: 3
    }, 16));
  }
}), $c = "pt-4 mt-4 space-y-2 font-medium border-t border-gray-200 dark:border-gray-700", Cg = /* @__PURE__ */ A({
  __name: "FwbSidebarItemGroup",
  props: {
    border: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, r) => (g(), v("div", {
      class: x(t.border && $c)
    }, [
      C(t.$slots, "default")
    ], 2));
  }
}), _c = ["src", "alt"], Sc = { class: "self-center whitespace-nowrap text-xl font-semibold dark:text-white" }, $g = /* @__PURE__ */ A({
  __name: "FwbSidebarLogo",
  props: {
    name: { default: "" },
    link: { default: "/" },
    logo: { default: "" },
    alt: { default: "" },
    tag: { default: "router-link" }
  },
  setup(e) {
    const t = e, r = t.tag === "a" ? "a" : Te(t.tag), s = t.tag === "a" ? "href" : "to";
    return (o, a) => (g(), te(ge(y(r)), Re({
      [y(s) || ""]: o.link,
      class: "mb-5 flex items-center pl-2.5"
    }), {
      default: X(() => [
        b("img", {
          src: o.logo,
          class: "mr-3 h-6 sm:h-7",
          alt: o.alt ?? o.name
        }, null, 8, _c),
        b("span", Sc, G(o.name), 1)
      ]),
      _: 1
    }, 16));
  }
}), Tc = { class: "relative overflow-x-auto shadow-md sm:rounded-lg" }, Pc = { class: "w-full text-left text-sm text-gray-500 dark:text-gray-400" }, _g = /* @__PURE__ */ A({
  __name: "FwbTable",
  props: {
    striped: {
      type: Boolean,
      default: !1
    },
    stripedColumns: {
      type: Boolean,
      default: !1
    },
    hoverable: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e;
    return ke("hoverable", t.hoverable), ke("striped", t.striped), ke("stripedColumns", t.stripedColumns), (r, s) => (g(), v("div", Tc, [
      b("table", Pc, [
        C(r.$slots, "default")
      ])
    ]));
  }
}), Ac = {};
function Fc(e, t) {
  return g(), v("tbody", null, [
    C(e.$slots, "default")
  ]);
}
const Sg = /* @__PURE__ */ Pe(Ac, [["render", Fc]]), zc = "px-6 py-4 first:font-medium first:text-gray-900 first:dark:text-white first:whitespace-nowrap last:text-right", Ic = "even:bg-gray-white even:dark:bg-gray-900 odd:dark:bg-gray-800 odd:bg-gray-50";
function Bc() {
  const e = fe("stripedColumns");
  return { tableCellClasses: f(() => ne(
    zc,
    { [Ic]: e }
  )) };
}
const Tg = /* @__PURE__ */ A({
  __name: "FwbTableCell",
  setup(e) {
    const { tableCellClasses: t } = Bc();
    return (r, s) => (g(), v("td", {
      class: x(y(t))
    }, [
      C(r.$slots, "default")
    ], 2));
  }
}), Ec = {}, Oc = { class: "bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400" };
function Mc(e, t) {
  return g(), v("thead", Oc, [
    b("tr", null, [
      C(e.$slots, "default")
    ])
  ]);
}
const Pg = /* @__PURE__ */ Pe(Ec, [["render", Mc]]), Nc = "px-6 py-3 text-xs uppercase", Lc = "even:bg-white even:dark:bg-gray-900 odd:dark:bg-gray-800 odd:bg-gray-50";
function Rc() {
  const e = fe("stripedColumns");
  return { tableHeadCellClasses: f(() => ne(
    Nc,
    { [Lc]: e }
  )) };
}
const Ag = /* @__PURE__ */ A({
  __name: "FwbTableHeadCell",
  setup(e) {
    const { tableHeadCellClasses: t } = Rc();
    return (r, s) => (g(), v("th", {
      scope: "col",
      class: x(y(t))
    }, [
      C(r.$slots, "default")
    ], 2));
  }
}), Dc = "bg-white dark:bg-gray-800 [&:not(:last-child)]:border-b [&:not(:last-child)]:dark:border-gray-700", jc = "odd:bg-white even:bg-gray-50 odd:dark:bg-gray-800 even:dark:bg-gray-700", Vc = "hover:bg-gray-50 dark:hover:bg-gray-600";
function Hc() {
  const e = fe("striped"), t = fe("hoverable");
  return { tableRowClasses: f(() => ne(
    Dc,
    {
      [Vc]: t,
      [jc]: e
    }
  )) };
}
const Fg = /* @__PURE__ */ A({
  __name: "FwbTableRow",
  setup(e) {
    const { tableRowClasses: t } = Hc();
    return (r, s) => (g(), v("tr", {
      class: x(y(t))
    }, [
      C(r.$slots, "default")
    ], 2));
  }
}), Mo = "flowbite-tab-activate-func-injection", No = "flowbite-tab-active-name-injection", Lo = "flowbite-tab-style-injection", Ro = "flowbite-tab-visibility-directive-injection", Wc = { key: 0 }, Gc = { key: 1 }, zg = /* @__PURE__ */ A({
  __FLOWBITE_TAB__: !0,
  __name: "FwbTab",
  props: {
    name: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = fe(No, ""), r = fe(Ro, "if");
    return (s, o) => y(r) === "if" ? (g(), v(ie, { key: 0 }, [
      y(t) === e.name ? (g(), v("div", Wc, [
        C(s.$slots, "default")
      ])) : O("", !0)
    ], 64)) : y(r) === "show" ? De((g(), v("div", Gc, [
      C(s.$slots, "default")
    ], 512)), [
      [ua, y(t) === e.name]
    ]) : O("", !0);
  }
});
function qc(e) {
  const t = f(() => J(
    "flex flex-wrap font-medium text-center text-gray-500 dark:text-gray-400 text-sm",
    e.variant === "underline" && "-mb-px",
    e.variant === "default" && "border-b border-gray-200 dark:border-gray-700"
  ));
  return {
    divClasses: f(() => e.variant === "underline" ? "border-b border-gray-200 dark:border-gray-700 font-medium text-center text-gray-500 dark:text-gray-400 text-sm" : ""),
    ulClasses: t
  };
}
const Kc = {
  border: (e) => e.substring(0, e.lastIndexOf("-"))
}, Uc = (e, t = Kc) => {
  const s = Object.keys(t).find((o) => e.includes(o));
  return s ? t[s](e) : e.substring(0, e.indexOf("-"));
};
function qe(...e) {
  return e.filter((t) => t).reduce((t, r) => {
    const s = Array.isArray(r) ? Array.from(r).map((u) => u.split(" ")).flat() : r.split(" "), o = s.map((u) => Uc(u)), a = o.filter((u) => !t.types.includes(u)), l = [...o.filter((u) => t.types.includes(u)), ...a], i = [.../* @__PURE__ */ new Set([...t.types, ...l])], d = i.map((u) => {
      if (l.includes(u)) {
        const m = o.indexOf(u);
        if (m >= 0)
          return s[m] || "";
      }
      const h = t.types.indexOf(u);
      return h >= 0 && t.classes[h] || "";
    }).filter((u) => !!u);
    return {
      types: i,
      classes: d
    };
  }, { types: [], classes: [] }).classes.join(" ");
}
const Do = "flowbite-themable-injection-key", at = {
  blue: {
    background: "bg-blue-700 dark:bg-blue-600",
    disabled: "",
    hover: "hover:bg-blue-800 dark:hover:bg-blue-700",
    text: "text-blue-600 dark:text-blue-500",
    border: "border-blue-600 dark:border-blue-500",
    focus: "focus:ring-blue-300 dark:focus:ring-blue-800"
  },
  green: {
    background: "bg-green-700 dark:bg-green-600",
    disabled: "",
    hover: "hover:bg-green-800 dark:hover:bg-green-700",
    text: "text-green-600 dark:text-green-500",
    border: "border-green-600 dark:border-green-500",
    focus: "focus:ring-green-300 dark:focus:ring-green-800"
  },
  pink: {
    background: "bg-pink-700 dark:bg-pink-600",
    disabled: "",
    hover: "hover:bg-pink-800 dark:hover:bg-pink-700",
    text: "text-pink-600 dark:text-pink-500",
    border: "border-pink-600 dark:border-pink-500",
    focus: "focus:ring-pink-300 dark:focus:ring-pink-900"
  },
  purple: {
    background: "bg-purple-700 dark:bg-purple-600",
    disabled: "",
    hover: "hover:bg-purple-800 dark:hover:bg-purple-700",
    text: "text-purple-600 dark:text-purple-500",
    border: "border-purple-600 dark:border-purple-500",
    focus: "focus:ring-purple-300 dark:focus:ring-purple-900"
  },
  red: {
    background: "bg-red-700 dark:bg-red-600",
    disabled: "",
    hover: "hover:bg-red-800 dark:hover:bg-red-700",
    text: "text-red-600 dark:text-red-500",
    border: "border-red-600 dark:border-red-500",
    focus: "focus:ring-red-300 dark:focus:ring-red-900"
  }
};
function jo(e) {
  const t = fe(Do, Z(null)), r = f(() => e || t.value), s = f(() => !!t?.value), o = f(
    () => r.value ? at[r.value].background : ""
  ), a = f(
    () => r.value ? at[r.value].border : ""
  ), n = f(() => t?.value || void 0), l = f(
    () => r.value ? at[r.value].disabled : ""
  ), i = f(
    () => r.value ? at[r.value].focus : ""
  ), d = f(
    () => r.value ? at[r.value].hover : ""
  ), u = f(
    () => r.value ? at[r.value].text : ""
  );
  return {
    backgroundClasses: o,
    borderClasses: a,
    color: n,
    disabledClasses: l,
    focusClasses: i,
    hoverClasses: d,
    isActive: s,
    textClasses: u
  };
}
const Yc = {
  default: "cursor-pointer inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300",
  active: "cursor-pointer inline-block p-4 text-blue-600 bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500",
  disabled: "inline-block p-4 text-gray-400 rounded-t-lg cursor-not-allowed dark:text-gray-500"
}, Jc = {
  default: "cursor-pointer inline-block p-4 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300",
  active: "cursor-pointer inline-block p-4 text-blue-600 rounded-t-lg border-b-2 border-blue-600 active dark:text-blue-500 dark:border-blue-500",
  disabled: "inline-block p-4 text-gray-400 rounded-t-lg cursor-not-allowed dark:text-gray-500"
}, Xc = {
  default: "cursor-pointer inline-block py-3 px-4 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 dark:hover:text-white",
  active: "cursor-pointer inline-block py-3 px-4 text-white bg-blue-600 rounded-lg active",
  disabled: "inline-block py-3 px-4 text-gray-400 cursor-not-allowed dark:text-gray-500"
};
function Zc(e) {
  const t = jo();
  return { tabClasses: f(() => {
    const s = t.isActive.value, o = e.active.value ? "active" : e.disabled.value ? "disabled" : "default";
    return e.variant === "default" ? qe(
      Yc[o],
      (s && o) === "active" ? t.textClasses.value : ""
    ) : e.variant === "underline" ? qe(
      Jc[o],
      (s && o) === "active" ? [t.borderClasses.value, t.textClasses.value] : ""
    ) : e.variant === "pills" ? qe(
      Xc[o],
      (s && o) === "active" ? [t.backgroundClasses.value, "text-white"] : ""
    ) : "";
  }) };
}
const Qc = /* @__PURE__ */ A({
  __name: "FwbTabPane",
  props: {
    name: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, r = fe(Lo);
    r || console.warn("you can't use Tab outside of Tabs component. No tab style injection found");
    const s = fe(Mo);
    s || console.warn("you can't use Tab outside of Tabs component. No tab activate injection found");
    const o = () => {
      if (!t.disabled) {
        if (!s) return console.warn("no onActivate");
        s(t.name);
      }
    }, { tabClasses: a } = Zc({
      active: qt(t, "active"),
      disabled: qt(t, "disabled"),
      variant: r
    });
    return (n, l) => (g(), v("li", null, [
      b("div", {
        class: x(y(a)),
        onClick: o
      }, G(e.title), 3)
    ]));
  }
}), Ig = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbTabs",
  props: {
    variant: { default: "default" },
    modelValue: { default: "" },
    directive: { default: "if" }
  },
  emits: ["update:modelValue", "click:pane"],
  setup(e, { emit: t }) {
    const r = e, s = t, { ulClasses: o, divClasses: a } = qc(r);
    ke(Lo, r.variant);
    const l = it().default, i = f(() => l ? Yt(l({})).filter((m) => m.type.__FLOWBITE_TAB__) : []), d = f({
      get: () => r.modelValue,
      set: (m) => s("update:modelValue", m)
    });
    ke(No, d), ke(Ro, qt(r, "directive"));
    const u = (m) => {
      d.value = m;
    }, h = () => {
      s("click:pane");
    };
    return ke(Mo, u), (m, c) => (g(), v(ie, null, [
      b("div", {
        class: x(y(a))
      }, [
        b("ul", {
          class: x(y(o))
        }, [
          (g(!0), v(ie, null, Ue(i.value, (p, _) => (g(), te(Qc, {
            key: _,
            active: d.value === p.props?.name,
            disabled: p.props?.disabled,
            name: p.props?.name,
            title: p.props?.title,
            onClick: h
          }, null, 8, ["active", "disabled", "name", "title"]))), 128))
        ], 2)
      ], 2),
      b("div", Re(to(m.$attrs)), [
        C(m.$slots, "default")
      ], 16)
    ], 64));
  }
}), ef = "relative border-gray-200 dark:border-gray-700", tf = "border-l", rf = "flex", Bg = /* @__PURE__ */ A({
  __name: "FwbTimeline",
  props: {
    horizontal: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e;
    ke("horizontal", t.horizontal);
    const r = f(() => ne(
      ef,
      t.horizontal ? rf : tf
    ));
    return (s, o) => (g(), v("ol", pe({ class: r.value }, s.$attrs), [
      C(s.$slots, "default")
    ], 16));
  }
}), sf = {}, of = { class: "mb-4 text-base font-normal text-gray-500 dark:text-gray-400" };
function af(e, t) {
  return g(), v("p", of, [
    C(e.$slots, "default")
  ]);
}
const Eg = /* @__PURE__ */ Pe(sf, [["render", af]]), Og = /* @__PURE__ */ A({
  __name: "FwbTimelineContent",
  setup(e) {
    const t = fe("horizontal"), r = f(() => ne(t ? "mt-3 sm:pr-8" : ""));
    return (s, o) => (g(), v("div", {
      class: x(r.value)
    }, [
      C(s.$slots, "default")
    ], 2));
  }
}), nf = "mb-10", lf = "mb-6 sm:mb-0 relative", df = "ml-6", Mg = /* @__PURE__ */ A({
  __name: "FwbTimelineItem",
  setup(e) {
    const t = fe("horizontal"), r = f(() => ne(nf, t ? lf : df));
    return (s, o) => (g(), v("li", {
      class: x(r.value)
    }, [
      C(s.$slots, "default")
    ], 2));
  }
}), uf = "h-0.5 w-full bg-gray-200 dark:bg-gray-700 sm:flex", Ng = /* @__PURE__ */ A({
  __name: "FwbTimelinePoint",
  setup(e) {
    const t = it(), r = f(() => !!t.default), s = fe("horizontal"), o = f(() => ne(s ? "flex items-center" : "")), a = f(() => ne(uf, { "sm:hidden hidden": !s })), n = f(() => {
      const l = "absolute rounded-full -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700", i = "mt-1.5 w-3 h-3 bg-gray-200", d = "mt-1.5 w-6 h-6 -left-3 flex justify-center items-center bg-blue-200 ring-8 ring-white dark:ring-gray-900", u = "w-3 h-3 bg-gray-200", h = "w-6 h-6 -left-3 flex justify-center items-center bg-blue-200 ring-8 ring-white dark:ring-gray-900", m = !s && !r.value, c = !s && r.value, p = s && !r.value, _ = s && r.value;
      return ne(
        l,
        {
          [i]: m,
          [d]: c,
          [u]: p,
          [h]: _
        }
      );
    });
    return (l, i) => (g(), v("div", {
      class: x(o.value)
    }, [
      b("div", {
        class: x(n.value)
      }, [
        C(l.$slots, "default")
      ], 2),
      b("div", {
        class: x(a.value)
      }, null, 2)
    ], 2));
  }
}), cf = {}, ff = { class: "mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500" };
function pf(e, t) {
  return g(), v("time", ff, [
    C(e.$slots, "default")
  ]);
}
const Lg = /* @__PURE__ */ Pe(cf, [["render", pf]]), gf = {}, hf = { class: "text-lg font-semibold text-gray-900 dark:text-white" };
function mf(e, t) {
  return g(), v("h3", hf, [
    C(e.$slots, "default")
  ]);
}
const Rg = /* @__PURE__ */ Pe(gf, [["render", mf]]), bf = {
  danger: "text-red-500 bg-red-100 dark:bg-red-800 dark:text-red-200",
  empty: "",
  success: "text-green-500 bg-green-100 dark:bg-green-800 dark:text-green-200",
  warning: "text-orange-500 bg-orange-100 dark:bg-orange-700 dark:text-orange-200"
}, vf = {
  center: "items-center",
  end: "items-end",
  start: "items-start"
}, _s = "flex w-full max-w-xs p-4 text-gray-500 bg-white rounded-lg shadow-sm dark:text-gray-400 dark:bg-gray-800", Ss = "text-sm font-normal";
function yf(e) {
  const t = f(() => bf[e.type.value]), r = f(() => {
    const o = vf[e.alignment.value];
    return e.divide.value ? q([_s, "dark:divide-gray-700 divide-x divide-gray-200", o]) : q([_s, o]);
  }), s = f(() => e.type.value !== "empty" && e.divide.value ? q([Ss, "pl-3"]) : Ss);
  return {
    typeClasses: t,
    wrapperClasses: r,
    contentClasses: s
  };
}
function wf(e) {
  const {
    backgroundClasses: t,
    borderClasses: r,
    disabledClasses: s,
    focusClasses: o,
    hoverClasses: a,
    isActive: n,
    textClasses: l
  } = jo(e.theme?.value);
  return {
    classes: f(() => {
      if (!n.value)
        return "";
      const d = [];
      return e.apply.value.includes("text") && d.push(l.value), e.apply.value.includes("border") && d.push(r.value), e.apply.value.includes("background") && d.push(t.value), e.apply.value.includes("hover") && d.push(a.value), e.apply.value.includes("disabled") && d.push(s.value), e.apply.value.includes("focus") && d.push(o.value), d.join(" ");
    })
  };
}
const kf = /* @__PURE__ */ A({
  __name: "FlowbiteThemableChild",
  props: {
    apply: {
      type: Array,
      required: !0
    },
    tag: {
      type: String,
      default: "div"
    },
    theme: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const t = me(), r = e, { classes: s } = wf(ue(r)), o = f(() => t.class || "");
    return (a, n) => (g(), te(ge(e.tag), {
      class: x(y(qe)(o.value, y(s)))
    }, {
      default: X(() => [
        C(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), xf = {
  key: 1,
  "aria-hidden": "true",
  class: "size-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, Cf = {
  key: 2,
  "aria-hidden": "true",
  class: "size-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, $f = {
  key: 3,
  "aria-hidden": "true",
  class: "size-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, Ts = /* @__PURE__ */ A({
  __name: "FwbToast",
  props: {
    type: {
      type: String,
      default: "empty"
    },
    alignment: {
      type: String,
      default: "center"
    },
    closable: {
      type: Boolean,
      default: !1
    },
    divide: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const r = e, s = Z(!0), o = t, {
      typeClasses: a,
      wrapperClasses: n,
      contentClasses: l
    } = yf(ue(r)), i = () => {
      o("close"), s.value = !1;
    };
    return (d, u) => s.value ? (g(), v("div", {
      key: 0,
      id: "toast-default",
      class: x(y(n)),
      role: "alert"
    }, [
      e.type !== "empty" || d.$slots.icon ? (g(), te(kf, {
        key: 0,
        apply: ["background", "text"],
        class: x(["inline-flex size-8 shrink-0 items-center justify-center rounded-lg", y(a)])
      }, {
        default: X(() => [
          d.$slots.icon ? C(d.$slots, "icon", {
            key: 0,
            class: x({ "ml-3": e.type !== "empty" })
          }) : e.type === "success" ? (g(), v("svg", xf, u[0] || (u[0] = [
            b("path", {
              "clip-rule": "evenodd",
              d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
              "fill-rule": "evenodd"
            }, null, -1)
          ]))) : e.type === "danger" ? (g(), v("svg", Cf, u[1] || (u[1] = [
            b("path", {
              "clip-rule": "evenodd",
              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
              "fill-rule": "evenodd"
            }, null, -1)
          ]))) : e.type === "warning" ? (g(), v("svg", $f, u[2] || (u[2] = [
            b("path", {
              "clip-rule": "evenodd",
              d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
              "fill-rule": "evenodd"
            }, null, -1)
          ]))) : O("", !0)
        ]),
        _: 3
      }, 8, ["class"])) : O("", !0),
      b("div", {
        class: x([y(l), { "ml-3": d.$slots.icon || e.type !== "empty" }])
      }, [
        C(d.$slots, "default")
      ], 2),
      e.closable ? (g(), v("button", {
        key: 1,
        "aria-label": "Close",
        class: "-m-1.5 ml-auto inline-flex size-8 rounded-lg border-none bg-white p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-900 focus:ring-2 focus:ring-gray-300 dark:bg-gray-800 dark:text-gray-500 dark:hover:bg-gray-700 dark:hover:text-white",
        type: "button",
        onClick: i
      }, u[3] || (u[3] = [
        b("span", { class: "sr-only" }, "Close", -1),
        b("svg", {
          class: "size-5",
          fill: "currentColor",
          viewBox: "0 0 20 20",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          b("path", {
            "clip-rule": "evenodd",
            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
            "fill-rule": "evenodd"
          })
        ], -1)
      ]))) : O("", !0)
    ], 2)) : O("", !0);
  }
}), Vo = "flowbite-toast-injection-key", _f = A({
  components: {
    FwbToast: Ts
  },
  props: {
    transition: {
      type: String,
      default: "slide-left"
    }
  },
  setup() {
    const e = Z([]), t = (a, n) => {
      _l(() => o(a), n);
    }, r = (a) => {
      const n = parseInt(((/* @__PURE__ */ new Date()).getTime() * Math.random()).toString()).toString();
      return e.value.push({
        id: n,
        ...a
      }), a.time > 0 && t(n, a.time), n;
    }, s = () => {
      if (e.value.length === 0)
        return "";
      const a = e.value[e.value.length - 1].id;
      return e.value.pop(), a;
    }, o = (a) => {
      const n = e.value.findIndex((l) => l.id === a);
      return n >= 0 && e.value.splice(n, 1), n >= 0;
    };
    return ke(Vo, {
      add: r,
      pop: s,
      remove: o
    }), {
      toasts: e,
      removeToast: o
    };
  },
  render() {
    const { $props: e, $slots: t, toasts: r, removeToast: s } = this;
    return Ot("div", {}, [
      t.default ? t.default() : null,
      // rendering default slot
      Ot(
        ca,
        {
          name: e.transition,
          tag: "div",
          class: "xl:w-1/6 md:w-1/4 sm:w-1/4 fixed top-3 right-3 flex flex-col gap-2 z-50"
        },
        {
          default: () => r.map(
            (o) => o.component ? Ot(
              o.component,
              {
                key: o.id,
                onClose: () => s(o.id),
                ...o.componentProps ? o.componentProps : {}
              },
              () => o.text
            ) : Ot(
              Ts,
              {
                closable: !0,
                type: o.type,
                key: o.id,
                onClose: () => s(o.id)
              },
              () => o.text
            )
          )
        }
      )
    ]);
  }
}), Dg = /* @__PURE__ */ Pe(_f, [["__scopeId", "data-v-f00c0361"]]), Sf = ["top", "right", "bottom", "left"], Ps = ["start", "end"], As = /* @__PURE__ */ Sf.reduce((e, t) => e.concat(t, t + "-" + Ps[0], t + "-" + Ps[1]), []), Tt = Math.min, He = Math.max, Tf = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Pf = {
  start: "end",
  end: "start"
};
function Fr(e, t, r) {
  return He(e, Tt(t, r));
}
function et(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function $e(e) {
  return e.split("-")[0];
}
function ye(e) {
  return e.split("-")[1];
}
function Ho(e) {
  return e === "x" ? "y" : "x";
}
function Gr(e) {
  return e === "y" ? "height" : "width";
}
function Xe(e) {
  return ["top", "bottom"].includes($e(e)) ? "y" : "x";
}
function qr(e) {
  return Ho(Xe(e));
}
function Wo(e, t, r) {
  r === void 0 && (r = !1);
  const s = ye(e), o = qr(e), a = Gr(o);
  let n = o === "x" ? s === (r ? "end" : "start") ? "right" : "left" : s === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (n = tr(n)), [n, tr(n)];
}
function Af(e) {
  const t = tr(e);
  return [er(e), t, er(t)];
}
function er(e) {
  return e.replace(/start|end/g, (t) => Pf[t]);
}
function Ff(e, t, r) {
  const s = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], n = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? o : s : t ? s : o;
    case "left":
    case "right":
      return t ? a : n;
    default:
      return [];
  }
}
function zf(e, t, r, s) {
  const o = ye(e);
  let a = Ff($e(e), r === "start", s);
  return o && (a = a.map((n) => n + "-" + o), t && (a = a.concat(a.map(er)))), a;
}
function tr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Tf[t]);
}
function If(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Go(e) {
  return typeof e != "number" ? If(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function xt(e) {
  const {
    x: t,
    y: r,
    width: s,
    height: o
  } = e;
  return {
    width: s,
    height: o,
    top: r,
    left: t,
    right: t + s,
    bottom: r + o,
    x: t,
    y: r
  };
}
function Fs(e, t, r) {
  let {
    reference: s,
    floating: o
  } = e;
  const a = Xe(t), n = qr(t), l = Gr(n), i = $e(t), d = a === "y", u = s.x + s.width / 2 - o.width / 2, h = s.y + s.height / 2 - o.height / 2, m = s[l] / 2 - o[l] / 2;
  let c;
  switch (i) {
    case "top":
      c = {
        x: u,
        y: s.y - o.height
      };
      break;
    case "bottom":
      c = {
        x: u,
        y: s.y + s.height
      };
      break;
    case "right":
      c = {
        x: s.x + s.width,
        y: h
      };
      break;
    case "left":
      c = {
        x: s.x - o.width,
        y: h
      };
      break;
    default:
      c = {
        x: s.x,
        y: s.y
      };
  }
  switch (ye(t)) {
    case "start":
      c[n] -= m * (r && d ? -1 : 1);
      break;
    case "end":
      c[n] += m * (r && d ? -1 : 1);
      break;
  }
  return c;
}
const Bf = async (e, t, r) => {
  const {
    placement: s = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: n
  } = r, l = a.filter(Boolean), i = await (n.isRTL == null ? void 0 : n.isRTL(t));
  let d = await n.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: h
  } = Fs(d, s, i), m = s, c = {}, p = 0;
  for (let _ = 0; _ < l.length; _++) {
    const {
      name: k,
      fn: T
    } = l[_], {
      x: B,
      y: M,
      data: H,
      reset: S
    } = await T({
      x: u,
      y: h,
      initialPlacement: s,
      placement: m,
      strategy: o,
      middlewareData: c,
      rects: d,
      platform: n,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = B ?? u, h = M ?? h, c = {
      ...c,
      [k]: {
        ...c[k],
        ...H
      }
    }, S && p <= 50 && (p++, typeof S == "object" && (S.placement && (m = S.placement), S.rects && (d = S.rects === !0 ? await n.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: u,
      y: h
    } = Fs(d, m, i)), _ = -1);
  }
  return {
    x: u,
    y: h,
    placement: m,
    strategy: o,
    middlewareData: c
  };
};
async function ur(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: s,
    y: o,
    platform: a,
    rects: n,
    elements: l,
    strategy: i
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: h = "floating",
    altBoundary: m = !1,
    padding: c = 0
  } = et(t, e), p = Go(c), k = l[m ? h === "floating" ? "reference" : "floating" : h], T = xt(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(k))) == null || r ? k : k.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: d,
    rootBoundary: u,
    strategy: i
  })), B = h === "floating" ? {
    x: s,
    y: o,
    width: n.floating.width,
    height: n.floating.height
  } : n.reference, M = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), H = await (a.isElement == null ? void 0 : a.isElement(M)) ? await (a.getScale == null ? void 0 : a.getScale(M)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = xt(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: B,
    offsetParent: M,
    strategy: i
  }) : B);
  return {
    top: (T.top - S.top + p.top) / H.y,
    bottom: (S.bottom - T.bottom + p.bottom) / H.y,
    left: (T.left - S.left + p.left) / H.x,
    right: (S.right - T.right + p.right) / H.x
  };
}
const Ef = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: s,
      placement: o,
      rects: a,
      platform: n,
      elements: l,
      middlewareData: i
    } = t, {
      element: d,
      padding: u = 0
    } = et(e, t) || {};
    if (d == null)
      return {};
    const h = Go(u), m = {
      x: r,
      y: s
    }, c = qr(o), p = Gr(c), _ = await n.getDimensions(d), k = c === "y", T = k ? "top" : "left", B = k ? "bottom" : "right", M = k ? "clientHeight" : "clientWidth", H = a.reference[p] + a.reference[c] - m[c] - a.floating[p], S = m[c] - a.reference[c], D = await (n.getOffsetParent == null ? void 0 : n.getOffsetParent(d));
    let R = D ? D[M] : 0;
    (!R || !await (n.isElement == null ? void 0 : n.isElement(D))) && (R = l.floating[M] || a.floating[p]);
    const F = H / 2 - S / 2, U = R / 2 - _[p] / 2 - 1, Y = Tt(h[T], U), ee = Tt(h[B], U), V = Y, w = R - _[p] - ee, $ = R / 2 - _[p] / 2 + F, E = Fr(V, $, w), N = !i.arrow && ye(o) != null && $ !== E && a.reference[p] / 2 - ($ < V ? Y : ee) - _[p] / 2 < 0, L = N ? $ < V ? $ - V : $ - w : 0;
    return {
      [c]: m[c] + L,
      data: {
        [c]: E,
        centerOffset: $ - E - L,
        ...N && {
          alignmentOffset: L
        }
      },
      reset: N
    };
  }
});
function Of(e, t, r) {
  return (e ? [...r.filter((o) => ye(o) === e), ...r.filter((o) => ye(o) !== e)] : r.filter((o) => $e(o) === o)).filter((o) => e ? ye(o) === e || (t ? er(o) !== o : !1) : !0);
}
const Mf = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var r, s, o;
      const {
        rects: a,
        middlewareData: n,
        placement: l,
        platform: i,
        elements: d
      } = t, {
        crossAxis: u = !1,
        alignment: h,
        allowedPlacements: m = As,
        autoAlignment: c = !0,
        ...p
      } = et(e, t), _ = h !== void 0 || m === As ? Of(h || null, c, m) : m, k = await ur(t, p), T = ((r = n.autoPlacement) == null ? void 0 : r.index) || 0, B = _[T];
      if (B == null)
        return {};
      const M = Wo(B, a, await (i.isRTL == null ? void 0 : i.isRTL(d.floating)));
      if (l !== B)
        return {
          reset: {
            placement: _[0]
          }
        };
      const H = [k[$e(B)], k[M[0]], k[M[1]]], S = [...((s = n.autoPlacement) == null ? void 0 : s.overflows) || [], {
        placement: B,
        overflows: H
      }], D = _[T + 1];
      if (D)
        return {
          data: {
            index: T + 1,
            overflows: S
          },
          reset: {
            placement: D
          }
        };
      const R = S.map((Y) => {
        const ee = ye(Y.placement);
        return [Y.placement, ee && u ? (
          // Check along the mainAxis and main crossAxis side.
          Y.overflows.slice(0, 2).reduce((V, w) => V + w, 0)
        ) : (
          // Check only the mainAxis.
          Y.overflows[0]
        ), Y.overflows];
      }).sort((Y, ee) => Y[1] - ee[1]), U = ((o = R.filter((Y) => Y[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        ye(Y[0]) ? 2 : 3
      ).every((ee) => ee <= 0))[0]) == null ? void 0 : o[0]) || R[0][0];
      return U !== l ? {
        data: {
          index: T + 1,
          overflows: S
        },
        reset: {
          placement: U
        }
      } : {};
    }
  };
}, Nf = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, s;
      const {
        placement: o,
        middlewareData: a,
        rects: n,
        initialPlacement: l,
        platform: i,
        elements: d
      } = t, {
        mainAxis: u = !0,
        crossAxis: h = !0,
        fallbackPlacements: m,
        fallbackStrategy: c = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: _ = !0,
        ...k
      } = et(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const T = $e(o), B = Xe(l), M = $e(l) === l, H = await (i.isRTL == null ? void 0 : i.isRTL(d.floating)), S = m || (M || !_ ? [tr(l)] : Af(l)), D = p !== "none";
      !m && D && S.push(...zf(l, _, p, H));
      const R = [l, ...S], F = await ur(t, k), U = [];
      let Y = ((s = a.flip) == null ? void 0 : s.overflows) || [];
      if (u && U.push(F[T]), h) {
        const $ = Wo(o, n, H);
        U.push(F[$[0]], F[$[1]]);
      }
      if (Y = [...Y, {
        placement: o,
        overflows: U
      }], !U.every(($) => $ <= 0)) {
        var ee, V;
        const $ = (((ee = a.flip) == null ? void 0 : ee.index) || 0) + 1, E = R[$];
        if (E)
          return {
            data: {
              index: $,
              overflows: Y
            },
            reset: {
              placement: E
            }
          };
        let N = (V = Y.filter((L) => L.overflows[0] <= 0).sort((L, P) => L.overflows[1] - P.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!N)
          switch (c) {
            case "bestFit": {
              var w;
              const L = (w = Y.filter((P) => {
                if (D) {
                  const j = Xe(P.placement);
                  return j === B || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  j === "y";
                }
                return !0;
              }).map((P) => [P.placement, P.overflows.filter((j) => j > 0).reduce((j, Q) => j + Q, 0)]).sort((P, j) => P[1] - j[1])[0]) == null ? void 0 : w[0];
              L && (N = L);
              break;
            }
            case "initialPlacement":
              N = l;
              break;
          }
        if (o !== N)
          return {
            reset: {
              placement: N
            }
          };
      }
      return {};
    }
  };
};
async function Lf(e, t) {
  const {
    placement: r,
    platform: s,
    elements: o
  } = e, a = await (s.isRTL == null ? void 0 : s.isRTL(o.floating)), n = $e(r), l = ye(r), i = Xe(r) === "y", d = ["left", "top"].includes(n) ? -1 : 1, u = a && i ? -1 : 1, h = et(t, e);
  let {
    mainAxis: m,
    crossAxis: c,
    alignmentAxis: p
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: h.mainAxis || 0,
    crossAxis: h.crossAxis || 0,
    alignmentAxis: h.alignmentAxis
  };
  return l && typeof p == "number" && (c = l === "end" ? p * -1 : p), i ? {
    x: c * u,
    y: m * d
  } : {
    x: m * d,
    y: c * u
  };
}
const Rf = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, s;
      const {
        x: o,
        y: a,
        placement: n,
        middlewareData: l
      } = t, i = await Lf(t, e);
      return n === ((r = l.offset) == null ? void 0 : r.placement) && (s = l.arrow) != null && s.alignmentOffset ? {} : {
        x: o + i.x,
        y: a + i.y,
        data: {
          ...i,
          placement: n
        }
      };
    }
  };
}, Df = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: s,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: n = !1,
        limiter: l = {
          fn: (k) => {
            let {
              x: T,
              y: B
            } = k;
            return {
              x: T,
              y: B
            };
          }
        },
        ...i
      } = et(e, t), d = {
        x: r,
        y: s
      }, u = await ur(t, i), h = Xe($e(o)), m = Ho(h);
      let c = d[m], p = d[h];
      if (a) {
        const k = m === "y" ? "top" : "left", T = m === "y" ? "bottom" : "right", B = c + u[k], M = c - u[T];
        c = Fr(B, c, M);
      }
      if (n) {
        const k = h === "y" ? "top" : "left", T = h === "y" ? "bottom" : "right", B = p + u[k], M = p - u[T];
        p = Fr(B, p, M);
      }
      const _ = l.fn({
        ...t,
        [m]: c,
        [h]: p
      });
      return {
        ..._,
        data: {
          x: _.x - r,
          y: _.y - s,
          enabled: {
            [m]: a,
            [h]: n
          }
        }
      };
    }
  };
}, jf = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, s;
      const {
        placement: o,
        rects: a,
        platform: n,
        elements: l
      } = t, {
        apply: i = () => {
        },
        ...d
      } = et(e, t), u = await ur(t, d), h = $e(o), m = ye(o), c = Xe(o) === "y", {
        width: p,
        height: _
      } = a.floating;
      let k, T;
      h === "top" || h === "bottom" ? (k = h, T = m === (await (n.isRTL == null ? void 0 : n.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (T = h, k = m === "end" ? "top" : "bottom");
      const B = _ - u.top - u.bottom, M = p - u.left - u.right, H = Tt(_ - u[k], B), S = Tt(p - u[T], M), D = !t.middlewareData.shift;
      let R = H, F = S;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (F = M), (s = t.middlewareData.shift) != null && s.enabled.y && (R = B), D && !m) {
        const Y = He(u.left, 0), ee = He(u.right, 0), V = He(u.top, 0), w = He(u.bottom, 0);
        c ? F = p - 2 * (Y !== 0 || ee !== 0 ? Y + ee : He(u.left, u.right)) : R = _ - 2 * (V !== 0 || w !== 0 ? V + w : He(u.top, u.bottom));
      }
      await i({
        ...t,
        availableWidth: F,
        availableHeight: R
      });
      const U = await n.getDimensions(l.floating);
      return p !== U.width || _ !== U.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function he(e) {
  var t;
  return ((t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function xe(e) {
  return he(e).getComputedStyle(e);
}
const zs = Math.min, Ct = Math.max, rr = Math.round;
function qo(e) {
  const t = xe(e);
  let r = parseFloat(t.width), s = parseFloat(t.height);
  const o = e.offsetWidth, a = e.offsetHeight, n = rr(r) !== o || rr(s) !== a;
  return n && (r = o, s = a), { width: r, height: s, fallback: n };
}
function Le(e) {
  return Uo(e) ? (e.nodeName || "").toLowerCase() : "";
}
let Vt;
function Ko() {
  if (Vt) return Vt;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (Vt = e.brands.map((t) => t.brand + "/" + t.version).join(" "), Vt) : navigator.userAgent;
}
function Ce(e) {
  return e instanceof he(e).HTMLElement;
}
function Ee(e) {
  return e instanceof he(e).Element;
}
function Uo(e) {
  return e instanceof he(e).Node;
}
function Is(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof he(e).ShadowRoot || e instanceof ShadowRoot;
}
function cr(e) {
  const { overflow: t, overflowX: r, overflowY: s, display: o } = xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + s + r) && !["inline", "contents"].includes(o);
}
function Vf(e) {
  return ["table", "td", "th"].includes(Le(e));
}
function zr(e) {
  const t = /firefox/i.test(Ko()), r = xe(e), s = r.backdropFilter || r.WebkitBackdropFilter;
  return r.transform !== "none" || r.perspective !== "none" || !!s && s !== "none" || t && r.willChange === "filter" || t && !!r.filter && r.filter !== "none" || ["transform", "perspective"].some((o) => r.willChange.includes(o)) || ["paint", "layout", "strict", "content"].some((o) => {
    const a = r.contain;
    return a != null && a.includes(o);
  });
}
function Yo() {
  return !/^((?!chrome|android).)*safari/i.test(Ko());
}
function Kr(e) {
  return ["html", "body", "#document"].includes(Le(e));
}
function Jo(e) {
  return Ee(e) ? e : e.contextElement;
}
const Xo = { x: 1, y: 1 };
function lt(e) {
  const t = Jo(e);
  if (!Ce(t)) return Xo;
  const r = t.getBoundingClientRect(), { width: s, height: o, fallback: a } = qo(t);
  let n = (a ? rr(r.width) : r.width) / s, l = (a ? rr(r.height) : r.height) / o;
  return n && Number.isFinite(n) || (n = 1), l && Number.isFinite(l) || (l = 1), { x: n, y: l };
}
function Pt(e, t, r, s) {
  var o, a;
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), l = Jo(e);
  let i = Xo;
  t && (s ? Ee(s) && (i = lt(s)) : i = lt(e));
  const d = l ? he(l) : window, u = !Yo() && r;
  let h = (n.left + (u && ((o = d.visualViewport) == null ? void 0 : o.offsetLeft) || 0)) / i.x, m = (n.top + (u && ((a = d.visualViewport) == null ? void 0 : a.offsetTop) || 0)) / i.y, c = n.width / i.x, p = n.height / i.y;
  if (l) {
    const _ = he(l), k = s && Ee(s) ? he(s) : s;
    let T = _.frameElement;
    for (; T && s && k !== _; ) {
      const B = lt(T), M = T.getBoundingClientRect(), H = getComputedStyle(T);
      M.x += (T.clientLeft + parseFloat(H.paddingLeft)) * B.x, M.y += (T.clientTop + parseFloat(H.paddingTop)) * B.y, h *= B.x, m *= B.y, c *= B.x, p *= B.y, h += M.x, m += M.y, T = he(T).frameElement;
    }
  }
  return { width: c, height: p, top: m, right: h + c, bottom: m + p, left: h, x: h, y: m };
}
function Oe(e) {
  return ((Uo(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function fr(e) {
  return Ee(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function Zo(e) {
  return Pt(Oe(e)).left + fr(e).scrollLeft;
}
function At(e) {
  if (Le(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || Is(e) && e.host || Oe(e);
  return Is(t) ? t.host : t;
}
function Qo(e) {
  const t = At(e);
  return Kr(t) ? t.ownerDocument.body : Ce(t) && cr(t) ? t : Qo(t);
}
function sr(e, t) {
  var r;
  t === void 0 && (t = []);
  const s = Qo(e), o = s === ((r = e.ownerDocument) == null ? void 0 : r.body), a = he(s);
  return o ? t.concat(a, a.visualViewport || [], cr(s) ? s : []) : t.concat(s, sr(s));
}
function Bs(e, t, r) {
  return t === "viewport" ? xt(function(s, o) {
    const a = he(s), n = Oe(s), l = a.visualViewport;
    let i = n.clientWidth, d = n.clientHeight, u = 0, h = 0;
    if (l) {
      i = l.width, d = l.height;
      const m = Yo();
      (m || !m && o === "fixed") && (u = l.offsetLeft, h = l.offsetTop);
    }
    return { width: i, height: d, x: u, y: h };
  }(e, r)) : Ee(t) ? xt(function(s, o) {
    const a = Pt(s, !0, o === "fixed"), n = a.top + s.clientTop, l = a.left + s.clientLeft, i = Ce(s) ? lt(s) : { x: 1, y: 1 };
    return { width: s.clientWidth * i.x, height: s.clientHeight * i.y, x: l * i.x, y: n * i.y };
  }(t, r)) : xt(function(s) {
    const o = Oe(s), a = fr(s), n = s.ownerDocument.body, l = Ct(o.scrollWidth, o.clientWidth, n.scrollWidth, n.clientWidth), i = Ct(o.scrollHeight, o.clientHeight, n.scrollHeight, n.clientHeight);
    let d = -a.scrollLeft + Zo(s);
    const u = -a.scrollTop;
    return xe(n).direction === "rtl" && (d += Ct(o.clientWidth, n.clientWidth) - l), { width: l, height: i, x: d, y: u };
  }(Oe(e)));
}
function Es(e) {
  return Ce(e) && xe(e).position !== "fixed" ? e.offsetParent : null;
}
function Os(e) {
  const t = he(e);
  let r = Es(e);
  for (; r && Vf(r) && xe(r).position === "static"; ) r = Es(r);
  return r && (Le(r) === "html" || Le(r) === "body" && xe(r).position === "static" && !zr(r)) ? t : r || function(s) {
    let o = At(s);
    for (; Ce(o) && !Kr(o); ) {
      if (zr(o)) return o;
      o = At(o);
    }
    return null;
  }(e) || t;
}
function Hf(e, t, r) {
  const s = Ce(t), o = Oe(t), a = Pt(e, !0, r === "fixed", t);
  let n = { scrollLeft: 0, scrollTop: 0 };
  const l = { x: 0, y: 0 };
  if (s || !s && r !== "fixed") if ((Le(t) !== "body" || cr(o)) && (n = fr(t)), Ce(t)) {
    const i = Pt(t, !0);
    l.x = i.x + t.clientLeft, l.y = i.y + t.clientTop;
  } else o && (l.x = Zo(o));
  return { x: a.left + n.scrollLeft - l.x, y: a.top + n.scrollTop - l.y, width: a.width, height: a.height };
}
const Wf = { getClippingRect: function(e) {
  let { element: t, boundary: r, rootBoundary: s, strategy: o } = e;
  const a = r === "clippingAncestors" ? function(d, u) {
    const h = u.get(d);
    if (h) return h;
    let m = sr(d).filter((k) => Ee(k) && Le(k) !== "body"), c = null;
    const p = xe(d).position === "fixed";
    let _ = p ? At(d) : d;
    for (; Ee(_) && !Kr(_); ) {
      const k = xe(_), T = zr(_);
      (p ? T || c : T || k.position !== "static" || !c || !["absolute", "fixed"].includes(c.position)) ? c = k : m = m.filter((B) => B !== _), _ = At(_);
    }
    return u.set(d, m), m;
  }(t, this._c) : [].concat(r), n = [...a, s], l = n[0], i = n.reduce((d, u) => {
    const h = Bs(t, u, o);
    return d.top = Ct(h.top, d.top), d.right = zs(h.right, d.right), d.bottom = zs(h.bottom, d.bottom), d.left = Ct(h.left, d.left), d;
  }, Bs(t, l, o));
  return { width: i.right - i.left, height: i.bottom - i.top, x: i.left, y: i.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: r, strategy: s } = e;
  const o = Ce(r), a = Oe(r);
  if (r === a) return t;
  let n = { scrollLeft: 0, scrollTop: 0 }, l = { x: 1, y: 1 };
  const i = { x: 0, y: 0 };
  if ((o || !o && s !== "fixed") && ((Le(r) !== "body" || cr(a)) && (n = fr(r)), Ce(r))) {
    const d = Pt(r);
    l = lt(r), i.x = d.x + r.clientLeft, i.y = d.y + r.clientTop;
  }
  return { width: t.width * l.x, height: t.height * l.y, x: t.x * l.x - n.scrollLeft * l.x + i.x, y: t.y * l.y - n.scrollTop * l.y + i.y };
}, isElement: Ee, getDimensions: function(e) {
  return Ce(e) ? qo(e) : e.getBoundingClientRect();
}, getOffsetParent: Os, getDocumentElement: Oe, getScale: lt, async getElementRects(e) {
  let { reference: t, floating: r, strategy: s } = e;
  const o = this.getOffsetParent || Os, a = this.getDimensions;
  return { reference: Hf(t, await o(r), s), floating: { x: 0, y: 0, ...await a(r) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => xe(e).direction === "rtl" }, Gf = (e, t, r) => {
  const s = /* @__PURE__ */ new Map(), o = { platform: Wf, ...r }, a = { ...o.platform, _c: s };
  return Bf(e, t, { ...o, platform: a });
}, Ke = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: !1,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (e) => [...e, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function Ir(e, t) {
  let r = Ke.themes[e] || {}, s;
  do
    s = r[t], typeof s > "u" ? r.$extend ? r = Ke.themes[r.$extend] || {} : (r = null, s = Ke[t]) : r = null;
  while (r);
  return s;
}
function qf(e) {
  const t = [e];
  let r = Ke.themes[e] || {};
  do
    r.$extend && !r.$resetCss ? (t.push(r.$extend), r = Ke.themes[r.$extend] || {}) : r = null;
  while (r);
  return t.map((s) => `v-popper--theme-${s}`);
}
function Ms(e) {
  const t = [e];
  let r = Ke.themes[e] || {};
  do
    r.$extend ? (t.push(r.$extend), r = Ke.themes[r.$extend] || {}) : r = null;
  while (r);
  return t;
}
let Ft = !1;
if (typeof window < "u") {
  Ft = !1;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        Ft = !0;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let ea = !1;
typeof window < "u" && typeof navigator < "u" && (ea = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const Kf = ["auto", "top", "bottom", "left", "right"].reduce((e, t) => e.concat([
  t,
  `${t}-start`,
  `${t}-end`
]), []), Ns = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, Ls = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function Rs(e, t) {
  const r = e.indexOf(t);
  r !== -1 && e.splice(r, 1);
}
function Cr() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const ve = [];
let Ve = null;
const Ds = {};
function js(e) {
  let t = Ds[e];
  return t || (t = Ds[e] = []), t;
}
let Br = function() {
};
typeof window < "u" && (Br = window.Element);
function K(e) {
  return function(t) {
    return Ir(t.theme, e);
  };
}
const $r = "__floating-vue__popper", ta = () => A({
  name: "VPopper",
  provide() {
    return {
      [$r]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [$r]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: K("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: K("positioningDisabled")
    },
    placement: {
      type: String,
      default: K("placement"),
      validator: (e) => Kf.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: K("delay")
    },
    distance: {
      type: [Number, String],
      default: K("distance")
    },
    skidding: {
      type: [Number, String],
      default: K("skidding")
    },
    triggers: {
      type: Array,
      default: K("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: K("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: K("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: K("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: K("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: K("popperHideTriggers")
    },
    container: {
      type: [String, Object, Br, Boolean],
      default: K("container")
    },
    boundary: {
      type: [String, Br],
      default: K("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: K("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: K("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: K("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: K("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: K("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: K("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: K("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: K("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: K("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: K("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: K("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: K("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: K("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: K("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: K("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: K("flip")
    },
    shift: {
      type: Boolean,
      default: K("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: K("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: K("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: K("disposeTimeout")
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0,
      pendingHide: !1,
      containsGlobalTarget: !1,
      isDisposed: !0,
      mouseDownContains: !1
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[$r]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, t;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((t = this.popperShowTriggers) == null ? void 0 : t.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: !0
    },
    positioningDisabled: "$_refreshListeners",
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((e, t) => (e[t] = "$_computePosition", e), {})
  },
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: t = !1, force: r = !1 } = {}) {
      var s, o;
      (s = this.parentPopper) != null && s.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = !1, (r || !this.disabled) && (((o = this.parentPopper) == null ? void 0 : o.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, t), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: e = null, skipDelay: t = !1 } = {}) {
      var r;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: t }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((r = this.parentPopper) == null ? void 0 : r.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = !1, this.$_scheduleHide(e, t), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var e;
      this.isDisposed && (this.isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = ((e = this.referenceNode) == null ? void 0 : e.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((t) => t.nodeType === t.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push(Rf({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const t = this.placement.startsWith("auto");
      if (t ? e.middleware.push(Mf({
        alignment: this.placement.split("-")[1] ?? ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(Df({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !t && this.flip && e.middleware.push(Nf({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(Ef({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: s, rects: o, middlewareData: a }) => {
          let n;
          const { centerOffset: l } = a.arrow;
          return s.startsWith("top") || s.startsWith("bottom") ? n = Math.abs(l) > o.reference.width / 2 : n = Math.abs(l) > o.reference.height / 2, {
            data: {
              overflow: n
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const s = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: o, placement: a, middlewareData: n }) => {
            var l;
            if ((l = n.autoSize) != null && l.skip)
              return {};
            let i, d;
            return a.startsWith("top") || a.startsWith("bottom") ? i = o.reference.width : d = o.reference.height, this.$_innerNode.style[s === "min" ? "minWidth" : s === "max" ? "maxWidth" : "width"] = i != null ? `${i}px` : null, this.$_innerNode.style[s === "min" ? "minHeight" : s === "max" ? "maxHeight" : "height"] = d != null ? `${d}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(jf({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: s, availableHeight: o }) => {
          this.$_innerNode.style.maxWidth = s != null ? `${s}px` : null, this.$_innerNode.style.maxHeight = o != null ? `${o}px` : null;
        }
      })));
      const r = await Gf(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: r.x,
        y: r.y,
        placement: r.placement,
        strategy: r.strategy,
        arrow: {
          ...r.middlewareData.arrow,
          ...r.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(e, t = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), Ve && this.instantMove && Ve.instantMove && Ve !== this.parentPopper) {
        Ve.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      t ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e, t = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (Ve = this), t ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const t = this.delay;
      return parseInt(t && t[e] || t || 0);
    },
    async $_applyShow(e = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await Cr(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...sr(this.$_referenceNode),
        ...sr(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const t = this.$_referenceNode.getBoundingClientRect(), r = this.$_popperNode.querySelector(".v-popper__wrapper"), s = r.parentNode.getBoundingClientRect(), o = t.x + t.width / 2 - (s.left + r.offsetLeft), a = t.y + t.height / 2 - (s.top + r.offsetTop);
        this.result.transformOrigin = `${o}px ${a}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let t;
        for (let r = 0; r < ve.length; r++)
          t = ve[r], t.showGroup !== e && (t.hide(), t.$emit("close-group"));
      }
      ve.push(this), document.body.classList.add("v-popper--some-open");
      for (const t of Ms(this.theme))
        js(t).push(this), document.body.classList.add(`v-popper--some-open--${t}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await Cr(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, Rs(ve, this), ve.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const r of Ms(this.theme)) {
        const s = js(r);
        Rs(s, this), s.length === 0 && document.body.classList.remove(`v-popper--some-open--${r}`);
      }
      Ve === this && (Ve = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const t = this.disposeTimeout;
      t !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, t)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await Cr(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === !1 && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const e = (r) => {
        this.isShown && !this.$_hideInProgress || (r.usedByTooltip = !0, !this.$_preventShow && this.show({ event: r }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Ns, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], Ns, this.popperTriggers, this.popperShowTriggers, e);
      const t = (r) => {
        r.usedByTooltip || this.hide({ event: r });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, Ls, this.triggers, this.hideTriggers, t), this.$_registerTriggerListeners([this.$_popperNode], Ls, this.popperTriggers, this.popperHideTriggers, t);
    },
    $_registerEventListeners(e, t, r) {
      this.$_events.push({ targetNodes: e, eventType: t, handler: r }), e.forEach((s) => s.addEventListener(t, r, Ft ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(e, t, r, s, o) {
      let a = r;
      s != null && (a = typeof s == "function" ? s(a) : s), a.forEach((n) => {
        const l = t[n];
        l && this.$_registerEventListeners(e, l, o);
      });
    },
    $_removeEventListeners(e) {
      const t = [];
      this.$_events.forEach((r) => {
        const { targetNodes: s, eventType: o, handler: a } = r;
        !e || e === o ? s.forEach((n) => n.removeEventListener(o, a)) : t.push(r);
      }), this.$_events = t;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, t = !1) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), t && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, t) {
      for (const r of this.$_targetNodes) {
        const s = r.getAttribute(e);
        s && (r.removeAttribute(e), r.setAttribute(t, s));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const t of this.$_targetNodes)
        for (const r in e) {
          const s = e[r];
          s == null ? t.removeAttribute(r) : t.setAttribute(r, s);
        }
    },
    $_updateParentShownChildren(e) {
      let t = this.parentPopper;
      for (; t; )
        e ? t.shownChildren.add(this.randomId) : (t.shownChildren.delete(this.randomId), t.pendingHide && t.hide()), t = t.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if ($t >= e.left && $t <= e.right && _t >= e.top && _t <= e.bottom) {
        const t = this.$_popperNode.getBoundingClientRect(), r = $t - ze, s = _t - Ie, o = t.left + t.width / 2 - ze + (t.top + t.height / 2) - Ie + t.width + t.height, a = ze + r * o, n = Ie + s * o;
        return Ht(ze, Ie, a, n, t.left, t.top, t.left, t.bottom) || // Left edge
        Ht(ze, Ie, a, n, t.left, t.top, t.right, t.top) || // Top edge
        Ht(ze, Ie, a, n, t.right, t.top, t.right, t.bottom) || // Right edge
        Ht(ze, Ie, a, n, t.left, t.bottom, t.right, t.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if (ea) {
    const e = Ft ? {
      passive: !0,
      capture: !0
    } : !0;
    document.addEventListener("touchstart", (t) => Vs(t), e), document.addEventListener("touchend", (t) => Hs(t, !0), e);
  } else
    window.addEventListener("mousedown", (e) => Vs(e), !0), window.addEventListener("click", (e) => Hs(e, !1), !0);
  window.addEventListener("resize", Jf);
}
function Vs(e, t) {
  for (let r = 0; r < ve.length; r++) {
    const s = ve[r];
    try {
      s.mouseDownContains = s.popperNode().contains(e.target);
    } catch {
    }
  }
}
function Hs(e, t) {
  Uf(e, t);
}
function Uf(e, t) {
  const r = {};
  for (let s = ve.length - 1; s >= 0; s--) {
    const o = ve[s];
    try {
      const a = o.containsGlobalTarget = o.mouseDownContains || o.popperNode().contains(e.target);
      o.pendingHide = !1, requestAnimationFrame(() => {
        if (o.pendingHide = !1, !r[o.randomId] && Ws(o, a, e)) {
          if (o.$_handleGlobalClose(e, t), !e.closeAllPopover && e.closePopover && a) {
            let l = o.parentPopper;
            for (; l; )
              r[l.randomId] = !0, l = l.parentPopper;
            return;
          }
          let n = o.parentPopper;
          for (; n && Ws(n, n.containsGlobalTarget, e); )
            n.$_handleGlobalClose(e, t), n = n.parentPopper;
        }
      });
    } catch {
    }
  }
}
function Ws(e, t, r) {
  return r.closeAllPopover || r.closePopover && t || Yf(e, r) && !t;
}
function Yf(e, t) {
  if (typeof e.autoHide == "function") {
    const r = e.autoHide(t);
    return e.lastAutoHide = r, r;
  }
  return e.autoHide;
}
function Jf() {
  for (let e = 0; e < ve.length; e++)
    ve[e].$_computePosition();
}
let ze = 0, Ie = 0, $t = 0, _t = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  ze = $t, Ie = _t, $t = e.clientX, _t = e.clientY;
}, Ft ? {
  passive: !0
} : void 0);
function Ht(e, t, r, s, o, a, n, l) {
  const i = ((n - o) * (t - a) - (l - a) * (e - o)) / ((l - a) * (r - e) - (n - o) * (s - t)), d = ((r - e) * (t - a) - (s - t) * (e - o)) / ((l - a) * (r - e) - (n - o) * (s - t));
  return i >= 0 && i <= 1 && d >= 0 && d <= 1;
}
const Xf = {
  extends: ta()
}, Ur = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [s, o] of t)
    r[s] = o;
  return r;
};
function Zf(e, t, r, s, o, a) {
  return g(), v("div", {
    ref: "reference",
    class: x(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    C(e.$slots, "default", Re(to(e.slotData)))
  ], 2);
}
const Qf = /* @__PURE__ */ Ur(Xf, [["render", Zf]]);
function ep() {
  var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
  if (t > 0)
    return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  var r = e.indexOf("Trident/");
  if (r > 0) {
    var s = e.indexOf("rv:");
    return parseInt(e.substring(s + 3, e.indexOf(".", s)), 10);
  }
  var o = e.indexOf("Edge/");
  return o > 0 ? parseInt(e.substring(o + 5, e.indexOf(".", o)), 10) : -1;
}
let Gt;
function Er() {
  Er.init || (Er.init = !0, Gt = ep() !== -1);
}
var pr = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    Er(), zt(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", Gt && this.$el.appendChild(e), e.data = "about:blank", Gt || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!Gt && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const tp = /* @__PURE__ */ ga("data-v-b329ee4c");
fa("data-v-b329ee4c");
const rp = {
  class: "resize-observer",
  tabindex: "-1"
};
pa();
const sp = /* @__PURE__ */ tp((e, t, r, s, o, a) => (g(), te("div", rp)));
pr.render = sp;
pr.__scopeId = "data-v-b329ee4c";
pr.__file = "src/components/ResizeObserver.vue";
const ra = (e = "theme") => ({
  computed: {
    themeClass() {
      return qf(this[e]);
    }
  }
}), op = A({
  name: "VPopperContent",
  components: {
    ResizeObserver: pr
  },
  mixins: [
    ra()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), ap = ["id", "aria-hidden", "tabindex", "data-popper-placement"], np = {
  ref: "inner",
  class: "v-popper__inner"
}, lp = /* @__PURE__ */ b("div", { class: "v-popper__arrow-outer" }, null, -1), ip = /* @__PURE__ */ b("div", { class: "v-popper__arrow-inner" }, null, -1), dp = [
  lp,
  ip
];
function up(e, t, r, s, o, a) {
  const n = Te("ResizeObserver");
  return g(), v("div", {
    id: e.popperId,
    ref: "popover",
    class: x(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: yt(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: t[2] || (t[2] = eo((l) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    b("div", {
      class: "v-popper__backdrop",
      onClick: t[0] || (t[0] = (l) => e.autoHide && e.$emit("hide"))
    }),
    b("div", {
      class: "v-popper__wrapper",
      style: yt(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      b("div", np, [
        e.mounted ? (g(), v(ie, { key: 0 }, [
          b("div", null, [
            C(e.$slots, "default")
          ]),
          e.handleResize ? (g(), te(n, {
            key: 0,
            onNotify: t[1] || (t[1] = (l) => e.$emit("resize", l))
          })) : O("", !0)
        ], 64)) : O("", !0)
      ], 512),
      b("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: yt(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, dp, 4)
    ], 4)
  ], 46, ap);
}
const sa = /* @__PURE__ */ Ur(op, [["render", up]]), oa = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
let Or = function() {
};
typeof window < "u" && (Or = window.Element);
const cp = A({
  name: "VPopperWrapper",
  components: {
    Popper: Qf,
    PopperContent: sa
  },
  mixins: [
    oa,
    ra("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, Or, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, Or],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function fp(e, t, r, s, o, a) {
  const n = Te("PopperContent"), l = Te("Popper");
  return g(), te(l, pe({ ref: "popper" }, e.$props, {
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: [
      e.themeClass
    ],
    onShow: t[0] || (t[0] = () => e.$emit("show")),
    onHide: t[1] || (t[1] = () => e.$emit("hide")),
    "onUpdate:shown": t[2] || (t[2] = (i) => e.$emit("update:shown", i)),
    onApplyShow: t[3] || (t[3] = () => e.$emit("apply-show")),
    onApplyHide: t[4] || (t[4] = () => e.$emit("apply-hide")),
    onCloseGroup: t[5] || (t[5] = () => e.$emit("close-group")),
    onCloseDirective: t[6] || (t[6] = () => e.$emit("close-directive")),
    onAutoHide: t[7] || (t[7] = () => e.$emit("auto-hide")),
    onResize: t[8] || (t[8] = () => e.$emit("resize"))
  }), {
    default: X(({
      popperId: i,
      isShown: d,
      shouldMountContent: u,
      skipTransition: h,
      autoHide: m,
      show: c,
      hide: p,
      handleResize: _,
      onResize: k,
      classes: T,
      result: B
    }) => [
      C(e.$slots, "default", {
        shown: d,
        show: c,
        hide: p
      }),
      Ge(n, {
        ref: "popperContent",
        "popper-id": i,
        theme: e.finalTheme,
        shown: d,
        mounted: u,
        "skip-transition": h,
        "auto-hide": m,
        "handle-resize": _,
        classes: T,
        result: B,
        onHide: p,
        onResize: k
      }, {
        default: X(() => [
          C(e.$slots, "popper", {
            shown: d,
            hide: p
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const Yr = /* @__PURE__ */ Ur(cp, [["render", fp]]);
({
  ...Yr
});
({
  ...Yr
});
const pp = {
  ...Yr,
  name: "VTooltip",
  vPopperTheme: "tooltip"
};
A({
  name: "VTooltipDirective",
  components: {
    Popper: ta(),
    PopperContent: sa
  },
  mixins: [
    oa
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => Ir(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => Ir(e.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const t = ++this.$_fetchId, r = this.content(this);
        r.then ? r.then((s) => this.onResult(t, s)) : this.onResult(t, r);
      }
    },
    onResult(e, t) {
      e === this.$_fetchId && (this.$_loading = !1, this.asyncContent = t);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
});
const gp = pp, hp = { class: "fwb-tooltip flex items-start" }, jg = /* @__PURE__ */ A({
  __name: "FwbTooltip",
  props: {
    placement: { default: "top" },
    theme: { default: "dark" },
    trigger: { default: "hover" }
  },
  setup(e) {
    const t = e, r = f(() => ({
      light: "tooltip-light",
      dark: "tooltip-dark"
    })[t.theme]);
    return (s, o) => (g(), v("div", hp, [
      Ge(y(gp), {
        placement: s.placement,
        triggers: [s.trigger],
        theme: r.value,
        "auto-hide": ""
      }, {
        popper: X(() => [
          C(s.$slots, "content")
        ]),
        default: X(() => [
          C(s.$slots, "trigger")
        ]),
        _: 3
      }, 8, ["placement", "triggers", "theme"])
    ]));
  }
}), mp = "text-sm font-medium text-gray-900 dark:text-gray-300 mr-1", bp = "mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600", vp = "ml-6 text-xs font-normal text-gray-500 dark:text-gray-300", yp = "text-gray-400 dark:text-gray-500";
function wp(e) {
  const t = f(() => q([
    mp,
    e.disabled.value ? yp : "",
    e.labelClass.value
  ])), r = f(() => q([
    bp,
    e.class.value
  ])), s = f(() => q([
    vp
  ])), o = f(() => q([
    e.wrapperClass.value
  ]));
  return {
    checkboxClass: r,
    helperMessageClass: s,
    labelClass: t,
    wrapperClass: o
  };
}
const kp = { class: "flex justify-start items-center" }, xp = ["disabled", "name", "value"], Vg = /* @__PURE__ */ A({
  __name: "FwbCheckbox",
  props: /* @__PURE__ */ ro({
    class: { default: "" },
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    labelClass: { default: "" },
    name: { default: void 0 },
    value: { type: [String, Number, Boolean, Object], default: void 0 },
    wrapperClass: { default: "" }
  }, {
    modelValue: { type: [Boolean, Array], default: !1 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = so(e, "modelValue"), {
      checkboxClass: s,
      helperMessageClass: o,
      labelClass: a,
      wrapperClass: n
    } = wp(ue(t));
    return (l, i) => (g(), v("div", {
      class: x(y(n))
    }, [
      b("label", kp, [
        De(b("input", {
          "onUpdate:modelValue": i[0] || (i[0] = (d) => r.value = d),
          class: x(y(s)),
          disabled: l.disabled,
          name: l.name,
          value: l.value,
          type: "checkbox"
        }, null, 10, xp), [
          [oo, r.value]
        ]),
        l.label ? (g(), v("span", {
          key: 0,
          class: x(y(a))
        }, G(l.label), 3)) : O("", !0),
        b("span", {
          class: x(y(a))
        }, [
          C(l.$slots, "default")
        ], 2)
      ]),
      l.$slots.helper ? (g(), v("p", {
        key: 0,
        class: x(y(o))
      }, [
        C(l.$slots, "helper")
      ], 2)) : O("", !0)
    ], 2));
  }
}), Cp = "block w-full text-sm text-gray-900 border-[1px] border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400", $p = "block mb-2 text-sm font-medium text-gray-900 dark:text-white", _p = "flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600", Sp = "flex flex-col items-center justify-center pt-5 pb-6", Tp = "!-mb-2 text-sm text-gray-500 dark:text-gray-400";
function Pp(e) {
  const t = f(() => qe(
    Cp,
    "text-" + e
  )), r = f(() => $p), s = f(() => _p), o = f(() => Sp), a = f(() => Tp);
  return {
    fileInpClasses: t,
    labelClasses: r,
    dropzoneLabelClasses: s,
    dropzoneWrapClasses: o,
    dropzoneTextClasses: a
  };
}
const Ap = { key: 0 }, Fp = ["accept", "multiple"], zp = { key: 0 }, Ip = { key: 1 }, Bp = ["accept", "multiple"], Hg = /* @__PURE__ */ A({
  __name: "FwbFileInput",
  props: {
    accept: { default: "" },
    dropzone: { type: Boolean, default: !1 },
    label: { default: "" },
    modelValue: { default: null },
    multiple: { type: Boolean, default: !1 },
    size: { default: "sm" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, s = f(() => ct(r.modelValue) ? r.modelValue.map((p) => p.name).join(", ") : r.modelValue instanceof FileList ? Array.from(r.modelValue).map((p) => p.name).join(",") : r.modelValue instanceof File && r.modelValue.name || ""), o = t, a = f({
      get() {
        return r.modelValue;
      },
      set(p) {
        o("update:modelValue", p);
      }
    }), n = (p) => {
      const _ = p.target;
      r.multiple ? a.value = Array.from(_.files ?? []) : a.value = _.files?.[0] ?? null;
    }, l = (p) => {
      p.preventDefault();
      const _ = [];
      p.dataTransfer?.items ? (Object.values(p.dataTransfer.items).forEach((k) => {
        k.kind === "file" && _.push(k.getAsFile());
      }), r.multiple ? a.value = _ : a.value = _[0]) : p.dataTransfer?.files && Object.values(p.dataTransfer.files).forEach((k) => {
        a.value = k;
      });
    }, i = (p) => {
      p.preventDefault();
    }, {
      dropzoneLabelClasses: d,
      dropzoneTextClasses: u,
      dropzoneWrapClasses: h,
      fileInpClasses: m,
      labelClasses: c
    } = Pp(r.size);
    return (p, _) => (g(), v("div", null, [
      p.dropzone ? (g(), v("div", {
        key: 1,
        class: "flex flex-col items-start justify-center",
        onChange: n,
        onDragover: i,
        onDrop: l
      }, [
        p.label !== "" ? (g(), v("span", {
          key: 0,
          class: x(y(c))
        }, G(p.label), 3)) : O("", !0),
        b("label", {
          class: x(y(d))
        }, [
          b("div", {
            class: x(y(h))
          }, [
            _[1] || (_[1] = b("svg", {
              "aria-hidden": "true",
              class: "size-8 text-gray-500 dark:text-gray-400",
              fill: "none",
              viewBox: "0 0 20 16",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              b("path", {
                d: "M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                stroke: "currentColor"
              })
            ], -1)),
            a.value ? (g(), v("p", Ip, "File: " + G(s.value), 1)) : (g(), v("div", zp, [
              b("p", {
                class: x(y(u))
              }, _[0] || (_[0] = [
                b("span", { class: "font-semibold" }, "Click to upload", -1),
                ce(" or drag and drop ")
              ]), 2),
              C(p.$slots, "default")
            ]))
          ], 2),
          b("input", {
            accept: p.accept,
            multiple: p.multiple,
            class: "hidden",
            type: "file"
          }, null, 8, Bp)
        ], 2)
      ], 32)) : (g(), v("div", Ap, [
        b("label", null, [
          b("span", {
            class: x(y(c))
          }, G(p.label), 3),
          b("input", {
            accept: p.accept,
            class: x(y(m)),
            multiple: p.multiple,
            type: "file",
            onChange: n
          }, null, 42, Fp)
        ]),
        C(p.$slots, "default")
      ]))
    ]));
  }
}), Fe = {
  Error: "error",
  Success: "success"
}, Ep = "", Op = "block mb-2 text-sm font-medium", Mp = "relative flex items-center has-[input:focus]:ring-offset-0 has-[input:focus]:ring-1 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg has-[input:focus]:ring-blue-500 has-[input:focus]:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:has-[input:focus]:ring-blue-500 dark:has-[input:focus]:border-blue-500", Np = "block flex-grow w-full p-0 bg-transparent text-inherit ring-offset-0 ring-0 border-0 focus:ring-offset-0 focus:ring-0 focus:border-0 dark:placeholder-gray-400", Gs = "mt-2 text-sm text-gray-500 dark:text-gray-400", Lp = "bg-gray-100", Rp = "cursor-not-allowed", Dp = {
  sm: "p-2 text-sm",
  md: "p-2.5 text-sm",
  lg: "p-4"
}, jp = "bg-red-50 border-red-500 text-red-900 placeholder-red-700 has-[input:focus]:ring-red-500 has-[input:focus]:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500", qs = "text-red-700 dark:text-red-500", Vp = "bg-green-50 border-green-500 dark:border-green-500 text-green-900 dark:text-green-400 placeholder-green-700 dark:placeholder-green-500 has-[input:focus]:ring-green-500 has-[input:focus]:border-green-500 ", Ks = "text-green-700 dark:text-green-500", Hp = "text-red-900 placeholder-red-700 dark:placeholder-red-500", Wp = "text-green-900 dark:text-green-400 placeholder-green-700 dark:placeholder-green-500";
function Gp(e) {
  const t = f(() => q([
    Ep,
    e.wrapperClass.value
  ])), r = f(() => q([
    Op,
    e.labelClass.value,
    e.validationStatus.value === Fe.Success ? Ks : e.validationStatus.value === Fe.Error ? qs : ""
  ])), s = f(() => q([
    Mp,
    e.class.value,
    e.validationStatus.value === Fe.Success ? Vp : e.validationStatus.value === Fe.Error ? jp : "",
    e.disabled.value ? Lp : ""
  ])), o = f(() => q([
    Np,
    Dp[e.size.value],
    e.validationStatus.value === Fe.Success ? Wp : e.validationStatus.value === Fe.Error ? Hp : "",
    e.inputClass.value,
    e.disabled.value ? Rp : ""
  ])), a = f(() => q([
    Gs,
    e.validationStatus.value === Fe.Success ? Ks : e.validationStatus.value === Fe.Error ? qs : ""
  ]));
  return {
    helperMessageClass: f(() => q([
      Gs
    ])),
    inputClass: o,
    inputWrapperClass: s,
    labelClass: r,
    validationMessageClass: a,
    wrapperClass: t
  };
}
const qp = {
  key: 0,
  class: "ms-2 flex shrink-0 items-center"
}, Kp = ["autocomplete", "disabled", "required", "type"], Up = {
  key: 1,
  class: "me-2 flex shrink-0 items-center"
}, Wg = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbInput",
  props: /* @__PURE__ */ ro({
    autocomplete: { default: "off" },
    class: { default: "" },
    disabled: { type: Boolean, default: !1 },
    inputClass: { default: "" },
    label: { default: "" },
    labelClass: { default: "" },
    modelValue: { default: "" },
    required: { type: Boolean, default: !1 },
    size: { default: "md" },
    type: { default: "text" },
    validationStatus: { default: void 0 },
    wrapperClass: { default: "" }
  }, {
    modelValue: { type: String },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = so(e, "modelValue"), {
      wrapperClass: s,
      helperMessageClass: o,
      validationMessageClass: a,
      labelClass: n,
      inputWrapperClass: l,
      inputClass: i
    } = Gp(ue(t));
    return (d, u) => (g(), v("div", {
      class: x(y(s))
    }, [
      d.label ? (g(), v("label", {
        key: 0,
        class: x(y(n))
      }, G(d.label), 3)) : O("", !0),
      b("div", {
        class: x(y(l))
      }, [
        d.$slots.prefix ? (g(), v("div", qp, [
          C(d.$slots, "prefix")
        ])) : O("", !0),
        De(b("input", pe(d.$attrs, {
          "onUpdate:modelValue": u[0] || (u[0] = (h) => r.value = h),
          autocomplete: d.autocomplete,
          class: y(i),
          disabled: d.disabled,
          required: d.required,
          type: d.type
        }), null, 16, Kp), [
          [ha, r.value]
        ]),
        d.$slots.suffix ? (g(), v("div", Up, [
          C(d.$slots, "suffix")
        ])) : O("", !0)
      ], 2),
      d.$slots.validationMessage ? (g(), v("p", {
        key: 1,
        class: x(y(a))
      }, [
        C(d.$slots, "validationMessage")
      ], 2)) : O("", !0),
      d.$slots.helper ? (g(), v("p", {
        key: 2,
        class: x(y(o))
      }, [
        C(d.$slots, "helper")
      ], 2)) : O("", !0)
    ], 2));
  }
}), Yp = { class: "flex w-full items-center" }, Jp = ["disabled", "name", "value"], Xp = "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600", Zp = "m-2 mr-0 text-sm font-medium text-gray-900 dark:text-gray-300", Gg = /* @__PURE__ */ A({
  __name: "FwbRadio",
  props: {
    modelValue: { default: "" },
    name: { default: "" },
    value: { default: "" },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, s = t, o = f({
      get() {
        return r.modelValue;
      },
      set(l) {
        s("update:modelValue", l);
      }
    }), a = f(() => Xp), n = f(() => J(Zp, r.disabled && "text-gray-400 dark:text-gray-500"));
    return (l, i) => (g(), v("label", Yp, [
      De(b("input", {
        "onUpdate:modelValue": i[0] || (i[0] = (d) => o.value = d),
        type: "radio",
        disabled: l.disabled,
        name: l.name,
        value: l.value,
        class: x(a.value)
      }, null, 10, Jp), [
        [ma, o.value]
      ]),
      b("span", {
        class: x(n.value)
      }, G(l.label), 3),
      C(l.$slots, "default")
    ]));
  }
}), Qp = "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700", e0 = "block mb-2 text-sm font-medium text-gray-900 dark:text-white", t0 = {
  lg: "h-3 range-lg",
  md: "h-2 range-md",
  sm: "h-1 range-sm"
};
function r0(e) {
  const t = f(() => qe(
    Qp,
    t0[e.size.value]
  )), r = f(() => e0);
  return {
    rangeClasses: t,
    labelClasses: r
  };
}
const s0 = { class: "flex flex-col" }, o0 = ["step", "min", "max", "disabled"], a0 = /* @__PURE__ */ A({
  __name: "FwbRange",
  props: {
    disabled: { type: Boolean, default: !1 },
    label: { default: "Range slider" },
    max: { default: 100 },
    min: { default: 0 },
    modelValue: { default: 50 },
    size: { default: "md" },
    steps: { default: 1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, s = t, o = f({
      get() {
        return r.modelValue;
      },
      set(l) {
        s("update:modelValue", l);
      }
    }), { rangeClasses: a, labelClasses: n } = r0(ue(r));
    return (l, i) => (g(), v("label", s0, [
      b("span", {
        class: x(y(n))
      }, G(l.label), 3),
      De(b("input", {
        "onUpdate:modelValue": i[0] || (i[0] = (d) => o.value = d),
        step: l.steps,
        min: l.min,
        max: l.max,
        disabled: l.disabled,
        type: "range",
        class: x(y(a))
      }, null, 10, o0), [
        [ao, o.value]
      ])
    ]));
  }
}), qg = /* @__PURE__ */ Pe(a0, [["__scopeId", "data-v-7de68dc3"]]), Be = {
  Success: "success",
  Error: "error"
}, n0 = "block mb-2 text-sm font-medium", l0 = "w-full text-gray-900 bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500", i0 = "cursor-not-allowed bg-gray-100", d0 = "bg-transparent dark:bg-transparent dark:text-gray-500 border-b-2 border-gray-200 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer", u0 = {
  lg: "p-4",
  md: "p-2.5 text-sm",
  sm: "p-2 text-sm"
}, c0 = "bg-green-50 border-green-500 dark:border-green-500 text-green-900 dark:text-green-400 placeholder-green-700 dark:placeholder-green-500 focus:ring-green-500 focus:border-green-500", f0 = "bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500";
function p0(e) {
  const t = f(() => {
    const s = e.validationStatus.value, o = s === Be.Success ? c0 : s === Be.Error ? f0 : "", a = s === Be.Success ? "focus:border-green-500" : s === Be.Error ? "focus:border-red-500" : "";
    return J(
      l0,
      o,
      u0[e.size.value],
      e.disabled.value && i0,
      e.underline.value ? d0 : "border border-gray-300 rounded-lg",
      e.underline.value && a
    );
  }), r = f(() => {
    const s = e.validationStatus.value, o = s === Be.Success ? "text-green-700 dark:text-green-500" : s === Be.Error ? "text-red-700 dark:text-red-500" : "text-gray-900 dark:text-white";
    return J(n0, o);
  });
  return {
    selectClasses: t,
    labelClasses: r
  };
}
const g0 = ["disabled", "required", "autocomplete"], h0 = {
  disabled: "",
  selected: "",
  value: ""
}, m0 = ["value"], b0 = {
  key: 1,
  class: "mt-2 text-sm text-gray-500 dark:text-gray-400"
}, Kg = /* @__PURE__ */ A({
  __name: "FwbSelect",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    options: { default: () => [] },
    placeholder: { default: "Please select one" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    underline: { type: Boolean, default: !1 },
    size: { default: "md" },
    autocomplete: { default: "off" },
    validationStatus: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, o = Bl(r, "modelValue", t), { selectClasses: a, labelClasses: n } = p0(ue(r)), l = f(() => J(
      "mt-2 text-sm",
      r.validationStatus === Be.Success ? "text-green-600 dark:text-green-500" : "",
      r.validationStatus === Be.Error ? "text-red-600 dark:text-red-500" : ""
    ));
    return (i, d) => (g(), v("div", null, [
      b("label", null, [
        i.label ? (g(), v("span", {
          key: 0,
          class: x(y(n))
        }, G(i.label), 3)) : O("", !0),
        De(b("select", {
          "onUpdate:modelValue": d[0] || (d[0] = (u) => Xs(o) ? o.value = u : null),
          disabled: i.disabled,
          required: i.required,
          class: x(y(a)),
          autocomplete: i.autocomplete
        }, [
          b("option", h0, G(i.placeholder), 1),
          (g(!0), v(ie, null, Ue(i.options, (u, h) => (g(), v("option", {
            key: h,
            value: u.value
          }, G(u.name), 9, m0))), 128))
        ], 10, g0), [
          [ba, y(o)]
        ])
      ]),
      i.$slots.validationMessage ? (g(), v("p", {
        key: 0,
        class: x(l.value)
      }, [
        C(i.$slots, "validationMessage")
      ], 2)) : O("", !0),
      i.$slots.helper ? (g(), v("p", b0, [
        C(i.$slots, "helper")
      ])) : O("", !0)
    ]));
  }
}), v0 = "block w-full mb-4 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600", y0 = "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-200 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:cursor-not-allowed disabled:opacity-50", w0 = "block mb-2 text-sm font-medium text-gray-900 dark:text-white", k0 = "block py-2 px-3 border-gray-200 dark:border-gray-600";
function x0(e) {
  const t = f(() => qe(
    y0,
    e ? "bg-white dark:bg-gray-800 border-none" : "border"
  )), r = f(() => w0), s = f(() => e ? v0 : ""), o = f(() => k0);
  return {
    textareaClasses: t,
    labelClasses: r,
    wrapperClasses: s,
    footerClasses: o
  };
}
const C0 = ["rows", "placeholder", "autocomplete"], Ug = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbTextarea",
  props: {
    modelValue: { default: "" },
    label: { default: "Your message" },
    rows: { default: 4 },
    custom: { type: Boolean, default: !1 },
    placeholder: { default: "Write your message here..." },
    autocomplete: { default: "off" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, s = t, o = f({
      get() {
        return r.modelValue;
      },
      set(d) {
        s("update:modelValue", d);
      }
    }), { textareaClasses: a, labelClasses: n, wrapperClasses: l, footerClasses: i } = x0(r.custom);
    return (d, u) => (g(), v("label", null, [
      b("span", {
        class: x(y(n))
      }, G(d.label), 3),
      b("span", {
        class: x(y(l))
      }, [
        De(b("textarea", pe({
          "onUpdate:modelValue": u[0] || (u[0] = (h) => o.value = h)
        }, d.$attrs, {
          class: y(a),
          rows: d.rows,
          placeholder: d.placeholder,
          autocomplete: d.autocomplete
        }), null, 16, C0), [
          [ao, o.value]
        ]),
        d.$slots.footer ? (g(), v("span", {
          key: 0,
          class: x(y(i))
        }, [
          C(d.$slots, "footer")
        ], 2)) : O("", !0)
      ], 2)
    ]));
  }
}), $0 = "w-fit relative inline-flex items-center cursor-pointer", _0 = 'relative bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[""] after:absolute after:bg-white after:border-gray-300 after:border after:rounded-full after:transition-all dark:border-gray-600 peer-checked:bg-blue-600', S0 = "text-sm font-medium text-gray-900 dark:text-gray-300", T0 = {
  direct: "",
  reverse: "flex-row-reverse"
}, P0 = {
  direct: "ms-3",
  reverse: "me-3"
}, A0 = {
  lg: "w-14 h-7 after:top-0.5 after:start-[4px] after:h-6 after:w-6",
  md: "w-11 h-6 after:top-[2px] after:start-[2px] after:h-5 after:w-5",
  sm: "w-9 h-5 after:top-[2px] after:start-[2px] after:h-4 after:w-4"
}, F0 = {
  red: "peer-focus:ring-red-300 dark:peer-focus:ring-red-800 peer-checked:bg-red-600",
  green: "peer-focus:ring-green-300 dark:peer-focus:ring-green-800 peer-checked:bg-green-600",
  purple: "peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:bg-purple-600",
  yellow: "peer-focus:ring-yellow-300 dark:peer-focus:ring-yellow-800 peer-checked:bg-yellow-400",
  teal: "peer-focus:ring-teal-300 dark:peer-focus:ring-teal-800 peer-checked:bg-teal-600",
  orange: "peer-focus:ring-orange-300 dark:peer-focus:ring-orange-800 peer-checked:bg-orange-500"
};
function z0(e) {
  const t = f(() => $0), r = f(() => _0), s = f(() => A0[e.size.value]), o = f(() => F0[e.color.value]), a = f(() => S0), n = f(() => P0[e.reverse.value ? "reverse" : "direct"]), l = f(() => T0[e.reverse.value ? "reverse" : "direct"]);
  return {
    labelClasses: t,
    toggleSize: s,
    toggleClasses: r,
    toggleColor: o,
    toggleBallClasses: a,
    toggleBallOrder: n,
    labelOrder: l
  };
}
const I0 = ["disabled"], Yg = /* @__PURE__ */ A({
  __name: "FwbToggle",
  props: {
    color: { default: "" },
    disabled: { type: Boolean, default: !1 },
    label: { default: "" },
    modelValue: { type: Boolean, default: !1 },
    size: { default: "md" },
    reverse: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, s = t, o = f({
      get() {
        return r.modelValue;
      },
      set(m) {
        s("update:modelValue", m);
      }
    }), {
      labelClasses: a,
      toggleSize: n,
      toggleClasses: l,
      toggleColor: i,
      toggleBallClasses: d,
      toggleBallOrder: u,
      labelOrder: h
    } = z0(ue(r));
    return (m, c) => (g(), v("label", {
      class: x([y(a), y(h)])
    }, [
      De(b("input", {
        "onUpdate:modelValue": c[0] || (c[0] = (p) => o.value = p),
        disabled: m.disabled,
        class: "peer sr-only",
        type: "checkbox"
      }, null, 8, I0), [
        [oo, o.value]
      ]),
      b("span", {
        class: x([y(l), y(n), y(i)])
      }, null, 2),
      b("span", {
        class: x([y(d), y(u)])
      }, G(m.label), 3)
    ], 2));
  }
}), B0 = ["href"], Jg = /* @__PURE__ */ A({
  __name: "FwbA",
  props: {
    href: { default: "" },
    color: { default: "text-primary-600 dark:text-primary-500" }
  },
  setup(e) {
    return (t, r) => (g(), v("a", {
      href: t.href,
      class: x([t.color, "inline-flex items-center hover:underline"])
    }, [
      C(t.$slots, "default")
    ], 10, B0));
  }
}), Xg = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "FwbHeading",
  props: {
    tag: { default: "h1" },
    color: { default: "text-gray-900 dark:text-white" },
    customSize: { default: "" }
  },
  setup(e) {
    const t = e, r = {
      h1: "text-5xl font-extrabold",
      h2: "text-4xl font-bold",
      h3: "text-3xl font-bold",
      h4: "text-2xl font-bold",
      h5: "text-xl font-bold",
      h6: "text-lg font-bold"
    }, s = me(), o = J(
      "w-full",
      r[t.tag],
      t.color,
      t.customSize,
      s.class
    ), a = t.tag;
    return (n, l) => (g(), te(ge(y(a)), pe(n.$attrs, { class: y(o) }), {
      default: X(() => [
        C(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), E0 = ["src", "alt"], O0 = ["src", "alt"], Zg = /* @__PURE__ */ A({
  __name: "FwbImg",
  props: {
    caption: { default: "" },
    src: { default: "" },
    size: { default: "max-w-full" },
    alt: { default: "" },
    imgClass: { default: "h-auto" },
    alignment: { default: "" },
    captionClass: { default: "mt-2 text-sm text-center text-gray-500 dark:text-gray-400" }
  },
  setup(e) {
    return (t, r) => t.caption ? (g(), v("figure", {
      key: 0,
      class: x(t.size)
    }, [
      b("img", {
        src: t.src,
        alt: t.alt,
        class: x([t.size, t.alignment, t.imgClass])
      }, null, 10, E0),
      b("figcaption", {
        class: x(t.captionClass)
      }, G(t.caption), 3)
    ], 2)) : (g(), v("img", {
      key: 1,
      src: t.src,
      alt: t.alt,
      class: x([t.size, t.alignment, t.imgClass])
    }, null, 10, O0));
  }
}), M0 = "mb-3 last:mb-0 text-gray-900 dark:text-white leading-normal", Qg = /* @__PURE__ */ A({
  __name: "FwbP",
  props: {
    class: { default: "" }
  },
  setup(e) {
    const t = e, r = f(() => q([
      M0,
      t.class
    ]));
    return (s, o) => (g(), v("p", {
      class: x(r.value)
    }, [
      C(s.$slots, "default")
    ], 2));
  }
}), N0 = ["cite"], L0 = "font-semibold text-lg italic text-gray-900 dark:text-white", R0 = "bg-gray-100 dark:bg-gray-800 border-l-4 border-gray-300 p-4 dark:border-gray-500", eh = /* @__PURE__ */ A({
  __name: "FwbBlockquote",
  props: {
    type: { default: "default" },
    cite: { default: "" },
    class: { default: "" }
  },
  setup(e) {
    const t = e, r = f(() => q([
      L0,
      t.type === "solid" ? R0 : "",
      t.class
    ]));
    return (s, o) => (g(), v("blockquote", {
      class: x(r.value),
      cite: s.cite
    }, [
      C(s.$slots, "default")
    ], 10, N0));
  }
}), th = /* @__PURE__ */ A({
  __name: "FlowbiteThemable",
  props: {
    theme: { default: "blue" }
  },
  setup(e) {
    return ke(Do, qt(e, "theme")), (r, s) => C(r.$slots, "default");
  }
});
function rh() {
  const e = fe(Vo, null);
  return e === null && console.warn("Cannot use useToast outside <toast-provider> component. Please wrap your component with <toast-provider>"), {
    add: (o) => e ? e?.add(o) : "",
    remove: (o) => e ? e?.remove(o) : !1,
    pop: () => e ? e?.pop() : ""
  };
}
export {
  th as FlowbiteThemable,
  kf as FlowbiteThemableChild,
  Jg as FwbA,
  j0 as FwbAccordion,
  V0 as FwbAccordionContent,
  H0 as FwbAccordionHeader,
  W0 as FwbAccordionPanel,
  G0 as FwbAlert,
  q0 as FwbAvatar,
  K0 as FwbAvatarStack,
  U0 as FwbAvatarStackCounter,
  Y0 as FwbBadge,
  eh as FwbBlockquote,
  J0 as FwbBreadcrumb,
  X0 as FwbBreadcrumbItem,
  al as FwbButton,
  Z0 as FwbButtonGroup,
  Q0 as FwbCard,
  eg as FwbCarousel,
  Vg as FwbCheckbox,
  tg as FwbDropdown,
  Hg as FwbFileInput,
  rg as FwbFooter,
  sg as FwbFooterBrand,
  og as FwbFooterCopyright,
  ag as FwbFooterIcon,
  ng as FwbFooterLink,
  lg as FwbFooterLinkGroup,
  Xg as FwbHeading,
  Zg as FwbImg,
  Wg as FwbInput,
  ig as FwbJumbotron,
  dg as FwbListGroup,
  ug as FwbListGroupItem,
  cg as FwbModal,
  fg as FwbNavbar,
  pg as FwbNavbarCollapse,
  gg as FwbNavbarLink,
  hg as FwbNavbarLogo,
  Qg as FwbP,
  mg as FwbPagination,
  bg as FwbProgress,
  Gg as FwbRadio,
  qg as FwbRange,
  vg as FwbRating,
  Kg as FwbSelect,
  yg as FwbSidebar,
  wg as FwbSidebarCta,
  kg as FwbSidebarDropdownItem,
  xg as FwbSidebarItem,
  Cg as FwbSidebarItemGroup,
  $g as FwbSidebarLogo,
  bs as FwbSlotListener,
  Rt as FwbSpinner,
  zg as FwbTab,
  _g as FwbTable,
  Sg as FwbTableBody,
  Tg as FwbTableCell,
  Pg as FwbTableHead,
  Ag as FwbTableHeadCell,
  Fg as FwbTableRow,
  Ig as FwbTabs,
  Ug as FwbTextarea,
  Bg as FwbTimeline,
  Eg as FwbTimelineBody,
  Og as FwbTimelineContent,
  Mg as FwbTimelineItem,
  Ng as FwbTimelinePoint,
  Lg as FwbTimelineTime,
  Rg as FwbTimelineTitle,
  Ts as FwbToast,
  Dg as FwbToastProvider,
  Yg as FwbToggle,
  jg as FwbTooltip,
  rh as useToast
};
